import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { DialogContentText } from '@material-ui/core/';
import AddIcon from '@material-ui/icons/Add';
import BackupIcon from '@material-ui/icons/Backup';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import FlagIcon from '@material-ui/icons/Flag';
import InfoIcon from '@material-ui/icons/Info';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import SaveIcon from '@material-ui/icons/Save';
import WarningIcon from '@material-ui/icons/Warning';
import { Skeleton } from '@material-ui/lab';
import { cloneDeep, debounce, isEmpty } from 'lodash-es';
import { MTableToolbar } from 'material-table';
import moment from 'moment-timezone';
// @ts-ignore
import { highlight, languages } from 'prismjs/components/prism-core';
import React, { ChangeEvent, JSX, ReactElement } from 'react';
import update from 'react-addons-update';
import { default as NumberFormat } from 'react-number-format';
import Editor from 'react-simple-code-editor';

import { CampaignForecastEventTypes, track } from '~/src/dash/analytics/analytics';
import {
  createGlobalVast,
  getGlobalVasts,
  IAdserverGlobalVast,
  ICreateGlobalVastResponse,
  updateGlobalVast,
} from '~/src/dash/api/adserver-global-vast';
import { targetingInactiveAudienceSegments } from '~/src/dash/api/audience-segment';
import {
  CampaignActiveActive,
  CampaignActiveInactive,
  IAdserverCampaign,
  IFlightDateCheckpoint,
} from '~/src/dash/api/campaign/campaign';
import { getInactiveHeaderBiddersTargetingCampaign } from '~/src/dash/api/campaign/campaign_methods';
import { ICampaignPrebidInfo } from '~/src/dash/api/campaign/campaign_models';
import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import {
  createChannelList,
  getChannelListsPromise,
  updateChannelList,
} from '~/src/dash/api/channel-list';
import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite, IsSmallSiteActive } from '~/src/dash/api/channels/channels_models';
import {
  AudienceSegmentActiveActive,
  bulkUpdateBidders,
  CampaignTrackerActiveActive,
  CampaignTrackerActiveInactive,
  checkForecastV2,
  createCampaign,
  createCreative,
  createMediafileFromURL,
  deleteCampaign,
  EAdserverCreativeType,
  EAllowStatus,
  EBannerRank,
  genExportCampaignWithCampaignID,
  getAudienceSegments,
  getCampaign,
  getChannelLabels,
  getGlobalMedia,
  getUniqueLineItemAliases,
  HeaderBidderActiveActive,
  IAdserverAlias,
  IAdserverCampaignTracker,
  IAdserverCreative,
  IAdserverCreativeFlightDatesSubgroup,
  IAdserverGlobalMediafile,
  IAudienceSegment,
  IBidderWithTableData,
  IChannelGroup,
  IChannelGroupAdserverCampaignAssociation,
  IChannelLabel,
  IChannelList,
  IChannelListAdserverCampaignAssociation,
  ICountryGroup,
  IForecast,
  ISite,
  ISiteAdserverCampaignAssociation,
  ISitesInfo,
  IVariantMediafile,
  makeCampaignDaypartingTargetingChangeDescription,
  makeTargetingChangeDescription,
  makeTargetingChangeInfoHover,
  ResourceActiveDisabled,
  ResourceActiveEnabled,
  reverseEAllowStatus,
  scheduleCampaignForecastV2,
  SegmentTargetingAND,
  SegmentTargetingOR,
  TargetBoolTypeAll,
  TargetBoolTypeTrue,
  TargetingCCPAAll,
  TargetingCoppa0,
  TargetingCoppaAll,
  ETargetingDeviceIDTypes,
  TargetingGDPR0,
  TargetingGDPR1,
  TargetingGDPRAll,
  TargetingLogicAND,
  TargetingLogicOR,
  TargetingRequestedPodDurationNoMax,
  TargetingRequestedPodDurationNoMin,
  updateCampaign,
  updateVariantMediafile,
  uploadGlobalBanner,
  uploadGlobalMediafile,
  ExtendedIDTargetingTypeDisabled,
  ExtendedIDTargetingTypeEnabledIfPresent,
  ExtendedIDTargetingTypeEnabledIfMissing,
} from '~/src/dash/api/console-api';
import { getContextualSegmentsByPublisherID } from '~/src/dash/api/contextual-segments';
import {
  commonRegionGroupsIDs,
  createCountryGroup,
  deleteCountryGroup,
  getCountryGroupsByIDs,
  getCountryGroupsByPublisherID,
  updateCountryGroup,
} from '~/src/dash/api/country-group';
import {
  convertECurrencyTypeToString,
  convertECurrencyTypeToSymbol,
  convertStringToECurrencyType,
  CurrencyDisplayedItem,
  CurrencyType,
  CurrencyTypeUSD,
} from '~/src/dash/api/exchange-rates';
import {
  createForecastUsageAnalytic,
  ForecastEvent,
  ForecastType,
  IForecastUsageAnalytic,
} from '~/src/dash/api/forecast_usage_analytic';
import {
  FrequencyCapActiveActive,
  FrequencyCapActiveInactive,
  FrequencyCapTypeAdserverCampaign,
  FrequencyCapUnitDays,
  FrequencyCapUnitHours,
  FrequencyTargetingKey,
  FrequencyTrackingKey,
  IFrequencyCap,
} from '~/src/dash/api/frequency-cap';
import { transformBidderWithTableDataWrapper } from '~/src/dash/api/headerbidders/utils_headerbidder';
import { getAdserverOrder, IAdserverOrder, updateAdserverOrder } from '~/src/dash/api/order';
import { getDebugCampaignPacingData } from '~/src/dash/api/pacing/controller';
import { IDebugCampaignPacingModel } from '~/src/dash/api/pacing/models';
import { IHttpResponse } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';
import {
  fetchTargetingPresetOptions,
  ITargetingPresetVars,
  validateTargetingPresetSelections,
} from '~/src/dash/apiV2/targeting/targetingPresets';
import { IAccordionPanel, MultiAccordion } from '~/src/dash/components/accordion/multi-accordion';
import { CopyButton } from '~/src/dash/components/button';
import { CampaignDebugPacingTable } from '~/src/dash/components/campaign/campaign-debug-pacing-table';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import { CreateBannerModal } from '~/src/dash/components/create-banner-modal';
import { CreateOrEditFromURLModal } from '~/src/dash/components/create-or-edit-from-url-modal';
import { CurrencyConverter } from '~/src/dash/components/CurrencyConverter';
import {
  DateTimeRangeComponent,
  IDateRangeChangeEvent,
} from '~/src/dash/components/datepicker/date-time-range-component';
import {
  collapsePeriods,
  Day,
  DAYPARTING_TIMEZONES_PILLS,
  DaypartingSelector,
  daypartingTimezonesTypeToBoolean,
  daypartingTimezonesTypeToString,
  EDaypartingTimezonesType,
  findDaypartingIntervals,
  handleAddDaypartingPeriod,
  handleDaypartingDateChange,
  handleDaypartingDayClick,
  handleDeleteDaypartingPeriod,
  IDaypartingInterval,
  IPeriod,
  parseDayparting,
  parseDaypartingIntervals,
  scheduleStrings,
} from '~/src/dash/components/dayparting-selector';
import { CategoryMultiSelect } from '~/src/dash/components/dropdowns/category-multiselect';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { FocusedTextfield } from '~/src/dash/components/focused-textfield';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import {
  IIncludeExcludeTableElement,
  IncludeExcludeTable,
  SourceCampaignFormView,
} from '~/src/dash/components/include-exclude-table';
import InputGridRow from '~/src/dash/components/input-grid-row';
import { IInputRow, InputRow } from '~/src/dash/components/input-row';
import {
  ICountryGroupRowData,
  IListTableColumn,
  ISiteAdserverCampaignAssociationRowData,
  ListTable,
} from '~/src/dash/components/list-table';
import { LiveData } from '~/src/dash/components/live-data/live-data';
import {
  excludedTitleOverride,
  ILocalTargetingParameter,
  includedTitleOverride,
  LocalTargeting,
} from '~/src/dash/components/local-targeting/local-targeting';
import { MaterialLabelDropdownMulti } from '~/src/dash/components/material-label-dropdown-multi';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { MenuButton } from '~/src/dash/components/menu-button';
import { ModalSelectTable } from '~/src/dash/components/modal-select-table';
import ModelMissingPermission from '~/src/dash/components/model-missing-permission';
import { ModelPrimaryButton } from '~/src/dash/components/model-primary-button';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelSnackBarProgressBarContainer } from '~/src/dash/components/model-snackbar-progresbar-container';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import PillSwitcher, { IPillItem } from '~/src/dash/components/pill-switcher';
import { genQuickFilter } from '~/src/dash/components/quick-filter-dropdown';
import { SearchDropdownSingle } from '~/src/dash/components/search-dropdown-single';
import { SettingsAppBar } from '~/src/dash/components/settings-app-bar';
import { ITab, SettingsTabs } from '~/src/dash/components/settings-tabs';
import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { CAMPAIGN_TYPES, getCampaignTextByType } from '~/src/dash/globals/campaign-types';
import { CreativeTypeMediafile, CreativeTypeVast } from '~/src/dash/globals/constants';
import { genTimezoneList } from '~/src/dash/globals/timezone';
import {
  borderRadius,
  Col,
  Cols,
  ct,
  IndependentSelect,
  Panel,
  Panels,
  Row,
  Rows,
  spacing,
  Text,
  Textarea,
  TextInput,
} from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import {
  getColorTheme,
  getContactEmail,
  getResellerTitle,
} from '~/src/dash/resellers/utils/importResellerConfig';
import { isPBSDomain } from '~/src/dash/resellers/utils/utils';
import {
  extractRouteParams,
  getRoutePath,
  navigate,
  parseLocation,
  RouteCampaignExisting,
  RouteCampaignSettingsList,
  RouteOrderSettingsExisting,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { ChipAdserverCreativeBannerTier } from '~/src/dash/utils/adserver-creative-type';
import {
  CreateBannerFromAssetURLRow,
  isValidBannerExtension,
  isValidBannerMimetype,
  isValidBannerURL,
  isValidVideoExtension,
  isValidVideoMimetype,
  shouldRejectBannerUpload,
} from '~/src/dash/utils/banner-ads-helpers';
import { getCreativeType } from '~/src/dash/utils/campaign';
import {
  campaignStatusToChip,
  campaignStatusToString,
  computeCampaignStatus,
} from '~/src/dash/utils/campaign-status';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  generateCountriesMenuList,
  generateCountryGroupMenuList,
  generateCountryMenuListFromIsos,
  generateNewTargetingCountryGroupList,
  getAllCountries,
  IGeo,
} from '~/src/dash/utils/countries';
import {
  formatDateFromUTCToOffset,
  formatDateWithOffsetToUTC,
  getFutureEndDate,
  getFutureStartDate,
  getToday,
  printDate,
  toEndDate,
  toStartDate,
} from '~/src/dash/utils/date';
import { decorate } from '~/src/dash/utils/decorator';
import {
  getDeviceEnvironmentAsItems,
  getDeviceEnvironmentModels,
  getDeviceEnvironmentModelsAsItems,
  getDeviceEnvironmentSubTypes,
  getDeviceEnvironmentSubTypesAsItems,
} from '~/src/dash/utils/device-environments';
import { deviceORTBTypes, IDeviceType } from '~/src/dash/utils/devices';
import {
  getAllIABCategories,
  IAB_CATEGORIES,
  IABCategoryCodeToName,
} from '~/src/dash/utils/iab-category';
import { getLivestreamOption } from '~/src/dash/utils/livestream-options';
import {
  adminDebugColor,
  bigRadius,
  deleteColor,
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
  smallRadius,
} from '~/src/dash/utils/material-dashboard-react';
import { filterSitesByActive } from '~/src/dash/utils/models';
import { noopVoid } from '~/src/dash/utils/noop';
import {
  obfuscateAdserverCampaign,
  obfuscateAdserverCreative,
  obfuscateCampaignCreative,
  obfuscateCampaignVast,
  obfuscateGlobalMediafile,
  obfuscateVariant,
} from '~/src/dash/utils/obfuscate';
import { ELogicalOperator } from '~/src/dash/utils/options';
import {
  getPacingTypeOption,
  getPacingTypeOptionByText,
  pacingTypeOptions,
} from '~/src/dash/utils/pacing-type-options';
import { exportLocalTargetingToJSON } from '~/src/dash/utils/params';
import {
  allowedEmptyIPermissionCheck,
  IPermissionCheck,
  IS_AUTHORIZED,
} from '~/src/dash/utils/permission_service';
import { checkUserInfoMasked, hasRoleSuperUser } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { siteWeightOptions } from '~/src/dash/utils/site-weights';
import { convertIDStringToNumberArray } from '~/src/dash/utils/string';
import { isDemoAccount, isSamsungPublisher } from '~/src/dash/utils/ui';
import UploadManager, {
  EUploadResponseType,
  IUploadInfoBeautify,
  IUploadStatus,
} from '~/src/dash/utils/upload_manager';
import {
  channelEditListValidationSetting,
  channelListValidationSetting,
  hasErrors,
  IErrors,
  regionValidationSetting,
  validatorFactory,
} from '~/src/dash/utils/validator';
import {
  ccpaOptions,
  targetingDeviceIDTypeOptions,
} from '~/src/dash/views/bidder-settings-form-view';
import { ButtonView } from '~/src/dash/views/button-view';
import {
  adserverCreativesToSubgroups,
  coppaOptions,
  CreativeTypes,
  flagBanners,
  FLIGHT_DATES,
  FrequencyTrackingKeys,
  GDPRConsentOptions,
  GDPROptions,
  getFrequencyTargetingKeysForPublisher,
  getFrequencyTargetingKeysWithoutDurationForPublisher,
  getPercentageNumber,
  iabRegexp,
  isBannerType,
  isExistingCampaign,
  latOptions,
  livestreamOptions,
  REACTIVATE_BIDDERS,
  ResolutionTypes,
  SelectMode,
  sortIABCats,
  TrackerEventType,
  validate,
  WeightingTypes,
} from '~/src/dash/views/campaign/common';
import { CreativeSubGroups } from '~/src/dash/views/campaign/LineItem/CreativeSubGroups';
import MinMaxEditor from '~/src/dash/views/campaign/LineItem/MinMaxEditor';
import { RowButton } from '~/src/dash/views/component-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { TargetingIntegration } from '~/src/dash/views/tools/TargetingPresets/TargetingIntegration';
import {
  StaticAdvancedTargetingTooltip,
  StaticExtendedIDTooltip,
} from '~/src/dash/utils/customTooltips';
import { CampaignAuctionInsights } from '~/src/dash/views/campaigns/line-item/CampaignAuctionInsights';
import { RadioOption, RadioTextButtons } from '~/src/dash/components/radio/RadioTextButtons';
import { INewCalDates } from '~/src/dash/components/calendar/CalendarV2/common';
import { DemandSources } from '~/src/dash/globals/demand-sources';
import { PUB_OPS_TEAM_IDS } from '~/src/dash/utils/users';
import { isPublisherTegna } from '~/src/dash/utils/publishers';

// Elm seems to be the best lang to highlight HTML: https://prismjs.com/test.html#language=elm

interface ICampaignCreativeList {
  [key: string]: IMenuList;
}

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  campaign: IAdserverCampaign;
  order?: IAdserverOrder;
  creativeType?: string;
  debugPacingInfo?: IDebugCampaignPacingModel;
  campaignPrebidInfo?: ICampaignPrebidInfo[];
}
export interface IAdserverCreativeWithTableData extends IAdserverCreative {
  tableData: { [checked: string]: boolean };
}

interface IState extends IBaseState, IAdserverCampaign {
  CreativeType: string;
  dateStart: moment.Moment | undefined;
  dateEnd: moment.Moment | undefined;
  lastUpdate: moment.Moment;
  generating: boolean;
  loading: boolean;
  updating: boolean;
  count: number;
  countQuerying: number;
  snackbarMessage: string;
  snackbarError: boolean;
  impressions: number;
  errors: Record<string, string>;
  forecast: IForecast;
  checkingForecast: boolean;
  schedulingReport: boolean;
  forecastRatio: number;
  forecastGoal: number;
  uploadsInfos: Map<string, IUploadInfoBeautify>;
  // IAB
  iabList: IIncludeExcludeTableElement[]; // list of IAB displayed in the table
  userEntryIABPrefix: string; // IAB prefix of user's current entry
  userEntryIABSuffix: string; // IAB suffix of user's current entry
  userEntryIABList: string; // user's entry of comma separated IAB codes
  DaypartingIntervals: IDaypartingInterval[];
  enableViewerTimezone: boolean;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  DeviceEnvironment: string[];
  TargetingLivestreamText: string;
  localTargetingAllowedParameters: ILocalTargetingParameter[];
  localTargetingDisallowedParameters: ILocalTargetingParameter[];
  PacingTypeText: string;
  siteCount: number;
  siteWeightsActiveDBValue: EBool;
  countriesCount: number;
  forecastNotes: string;
  forecastQuery: string;
  frequencyLimitDuration: string;
  frequencyLimitUnit: string;
  targetingCountriesList: IMenuList;
  targetingCountryGroupList: IMenuList;
  createEditRegionName: string;
  createEditRegionList: IMenuList;
  createEditRegionID: string;
  updatingCountryGroup: boolean;
  publisherCountryGroups: ICountryGroup[];
  openRegionCreateEditDialog: boolean;
  openRegionSelectDialog: boolean;
  openRegionSelectTable: boolean;
  deviceTargetingCountrySelectMode: SelectMode;
  GlobalMediaFiles: IAdserverGlobalMediafile[];
  globalMediafileList: ICampaignCreativeList;
  globalVastList: ICampaignCreativeList;
  vasts: IAdserverGlobalVast[];
  blankMediaFileList: IMenuList;
  blankVastList: IMenuList;
  channelGroupsList: IMenuList;
  Name: string;
  refresh: number;
  EnableGrossCPM: EBool;
  openCreateDialog: boolean;
  newCreateURL: string;
  newCreateName: string;
  creativeIDForCreateModal: string;
  selectedResolutions: string[];
  forceMenuButtonClosed: boolean;
  uploading: boolean;
  // when active, ignores the creative flight dates warning modal
  ignoreInvalidCreativeDates: boolean;
  openCreativeFlightDateModal: boolean;
  creativeFlightModalItems: IAdserverCreativeWithTableData[];
  openDisableLowPacingDialog: boolean;
  openServeRightAwayDialog: boolean;
  vastEditIndex: number; // holds index of vast URL to be edited
  tempVastURL: string; // holds the temporary vast URL to be saved
  openReactivateBiddersModal: boolean;
  inactiveBiddersTargetingCampaign: IBidderWithTableData[];
  ignoreReactivateBidders: boolean;
  adserverOrder: IAdserverOrder;
  contextualSegmentList: IMenuList;
  commonRegionGroups: ICountryGroup[] | undefined;
  Alias: string;
  uniqueLineItemAliases: IAdserverAlias[];
  openChannelListDialog: boolean;
  openChannelListEditDialog: boolean;
  channelListChannelGroups: IMenuList;
  channelListChannels: IMenuList;
  listSettingsDialogActive: boolean;
  listSettingsDialogID: number;
  newChannelGroupActive: boolean;
  channelLists: IChannelList[];
  CategoryExclusivityEnabled: EBool;
  isCreatingPrimaryBanner: boolean;
  isCreatingSecondaryBanner: boolean;
  openCreateBannerDialog: boolean;
  newCreateBannerURL: string;
  newCreateBannerName: string;
  BannerAdvertiserID: number;
  openDeleteCreativesConfirmation: boolean;
  reactKey: number;
  selectedChartView: 'liveData' | 'insights';
  // Auction Insights
  auctionInsightsCalStartDate: moment.Moment;
  auctionInsightsCalEndDate: moment.Moment;
}

const getInitialAuctionInsightsDates = (
  endDate: string,
): { initialStartDate: moment.Moment; initialEndDate: moment.Moment } => {
  const today = moment();
  const momentEndDate = moment(endDate);

  if (today.isAfter(momentEndDate)) {
    return {
      initialStartDate: momentEndDate.clone().startOf('day'),
      initialEndDate: momentEndDate.clone().endOf('day').hours(23).minutes(0).seconds(0),
    };
  } else {
    return {
      initialStartDate: today.clone().startOf('day'),
      initialEndDate: today.clone().endOf('day').hours(23).minutes(0).seconds(0),
    };
  }
};

export const CampaignFormView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 6,
        paddingLeft: theme.spacing.unit * 6 + 'px !important',
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      campaignNameContainer: {
        display: 'inline-block',
        marginLeft: '10px',
        width: 'calc(50% - 2em)',
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 3,
      },
      button: {
        margin: theme.spacing.unit,
      },
      button2: {
        marginLeft: theme.spacing.unit * 6,
        border: 'none',
      },
      button3: {
        marginLeft: theme.spacing.unit * 4,
        border: 'none',
      },
      centeredSwitch: {
        display: 'inline-flex',
        alignItems: 'center',
        marginLeft: '10px',
        marginRight: '40px',
      },
      centeredSwitchNoLeftMargin: {
        display: 'inline-flex',
        alignItems: 'center',
        marginRight: '40px',
      },
      switch: {
        display: 'inline-flex',
        alignItems: 'center',
      },
      textCenteredSpan: {
        display: 'inline-flex',
        alignItems: 'center',
      },
      spanDescription: {
        display: 'inline-flex',
        alignItems: 'center',
        margin: '10px 10px',
        fontSize: 15,
      },
      spanSubHeader: {
        display: 'inline-flex',
        alignItems: 'center',
        width: 88,
        fontSize: 15,
      },
      spanActive: {
        display: 'inline-flex',
        alignItems: 'center',
        width: 80,
        fontWeight: 'bold',
      },
      uploadButton: {
        display: 'flex',
        'text-align': 'center',
      },
      datePickerSection: {
        display: 'inline-flex',
        'justify-content': 'center',
        'align-items': 'center',
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      table: {
        display: 'inline-block',
        marginTop: '10px',
        marginBottom: '10px',
      },
      danger: {
        color: 'red',
      },
      success: {
        color: 'green',
      },
      insideAccordionText: {
        fontSize: 12,
        fontWeight: 400,
      },
      mainGridItem: {
        marginLeft: 40,
        marginTop: 25,
        width: '98%',
      },
      insideAccordionTextfield: {
        fontSize: 12,
        fontWeight: 400,
        backgroundColor: '#F4F6FD',
        paddingLeft: 5,
        paddingTop: 8,
        paddingBottom: 8,
      },
      insideAccordionTextBold: {
        fontSize: 12,
        fontWeight: 500,
      },
      boldText: {
        fontSize: 16,
        fontWeight: 500,
      },
      boldTextError: {
        fontSize: 16,
        fontWeight: 500,
        color: 'red',
      },
      infoIcon: {
        width: '1rem',
        color: publicaColors.mediumLightGray,
        marginLeft: '5px',
      },
      inputContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '15px',
      },
      inputLabel: {
        fontSize: '16px',
        fontWeight: 500,
        color: 'black',
        width: '170px',
      },
      menuButtonText: {
        fontSize: '0.875rem',
        fontWeight: 500,
        marginBottom: 2,
      },
      menuButtonTextBlue: {
        fontSize: '0.875rem',
        fontWeight: 500,
        marginBottom: 5,
        color: '#4952FF',
      },
      menuButtonTextGrey: {
        fontSize: '0.875rem',
        fontWeight: 500,
        marginBottom: 2,
        color: 'grey',
      },
      menuButtonTextDisabled: {
        fontSize: '0.875rem',
        fontWeight: 500,
        marginBottom: 2,
        color: 'rgba(0, 0, 0, 0.26)',
      },
      creativeRow: {
        width: '100%',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 15,
        paddingBottom: 5,
      },
      parameterHeaders: {
        paddingLeft: '45px',
        fontSize: '16px',
        fontWeight: 500,
        marginBottom: '15px',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    uploadManager: UploadManager;
    prevVast: Partial<IAdserverCreative[]>;
    prevMediafiles: Partial<IAdserverCreative[]>;
    uploadKeyToIdx: Map<string, { idx: number; cidx: number }>;
    _saveCampaign: (count: number, isCampaignSwitchingToActive?: boolean) => void;

    constructor(props: IProps) {
      super(props);

      const { initialStartDate, initialEndDate } = getInitialAuctionInsightsDates(
        this.props.campaign.EndDate,
      );

      this.state = {
        ...this.props.campaign,
        CreativeType: isExistingCampaign(this.props.campaign)
          ? getCreativeType(this.props.campaign)
          : this.props.creativeType
          ? this.props.creativeType
          : CreativeTypeVast,
        dateStart: this.props.campaign.StartDate
          ? formatDateFromUTCToOffset(
              this.props.campaign.StartDate,
              this.props.campaign.Timezone || this.props.session.publisher.Timezone,
            )
          : undefined,
        dateEnd: this.props.campaign.EndDate
          ? formatDateFromUTCToOffset(
              this.props.campaign.EndDate,
              this.props.campaign.Timezone || this.props.session.publisher.Timezone,
            )
          : undefined,
        StartDate: this.props.campaign.StartDate
          ? this.props.campaign.StartDate
          : getFutureStartDate(this.props.session.publisher.Timezone || 'UTC').format(
              'YYYY-MM-DDTHH:mm:ssZ',
            ),
        EndDate: this.props.campaign.EndDate
          ? this.props.campaign.EndDate
          : getFutureEndDate(this.props.session.publisher.Timezone || 'UTC', 6, 'day').format(
              'YYYY-MM-DDTHH:mm:ssZ',
            ),
        lastUpdate: this.props.campaign.EndDate
          ? moment.tz(this.props.campaign.EndDate, this.props.session.publisher.Timezone)
          : getFutureEndDate(this.props.session.publisher.Timezone || 'UTC', 6, 'day'),
        generating: false,
        loading: false,
        updating: false,
        count: 0,
        countQuerying: 0,
        snackbarMessage: '',
        snackbarError: false,
        errors: {} as { [key: string]: any },
        forecast: {} as IForecast,
        checkingForecast: false,
        schedulingReport: false,
        forecastNotes: '',
        forecastQuery: '',
        forecastRatio: 0,
        forecastGoal: 0,
        uploadsInfos: new Map<string, IUploadInfoBeautify>(),
        impressions: 0,
        IABCategory: this.props.campaign.IABCategory,
        iabList: [] as IIncludeExcludeTableElement[], // list of IAB displayed in the table
        userEntryIABPrefix: '', // IAB prefix of user's current entry
        userEntryIABSuffix: '', // IAB suffix of user's current entry
        userEntryIABList: '', // user's entry of comma separated IAB codes
        Sites: [] as string[], // sites that the campaign is targeting
        allSites: [] as ISmallSite[],
        siteList: {} as IMenuList,
        siteCount: 0,
        siteWeightsActiveDBValue: this.props.campaign.SiteWeightsActive,
        countriesCount: getAllCountries().length,
        timezonesList: {} as IMenuList,
        Timezone: this.props.campaign.Timezone || this.props.session.publisher.Timezone,
        FrequencyLimitDays: this.props.campaign.FrequencyLimitDays || '30',
        FrequencyLimitHours: this.props.campaign.FrequencyLimitHours || '0',
        frequencyLimitDuration: '0',
        frequencyLimitUnit: FrequencyCapUnitDays,
        TargetedCountries: this.props.campaign.TargetedCountries || '',
        Dayparting: '',
        isDaypartingActive: false,
        enableViewerTimezone: false,
        DaypartingIsAllowed: this.props.campaign.DaypartingIsAllowed || EAllowStatus.ALLOW,
        DaypartingIntervals: [
          {
            ActiveDays: {
              Sunday: false,
              Monday: false,
              Tuesday: false,
              Wednesday: false,
              Thursday: false,
              Friday: false,
              Saturday: false,
            },
            StartTime: moment().startOf('day'),
            EndTime: moment().startOf('day').add(12, 'hours'),
            Error: '',
          },
        ],
        readAuthorization: allowedEmptyIPermissionCheck,
        writeAuthorization: allowedEmptyIPermissionCheck,
        DeviceEnvironment: (() => {
          if (
            this.props.campaign &&
            this.props.campaign.TargetingDevices !== undefined &&
            this.props.campaign.TargetingDevices !== ''
          ) {
            return this.props.campaign.TargetingDevices.split(',');
          }
          return ['0'];
        })(),
        TargetingDevices: (() => {
          if (this.props.campaign && this.props.campaign.TargetingDevices) {
            return this.props.campaign.TargetingDevices;
          }
          return '0';
        })(),
        TargetingDevicesIsAllowed: this.props.campaign.TargetingDevicesIsAllowed,
        TargetingDeviceSubTypes: (() => {
          if (this.props.campaign && this.props.campaign.TargetingDeviceSubTypes) {
            return this.props.campaign.TargetingDeviceSubTypes;
          }
          return '0';
        })(),
        TargetingDeviceSubTypesIsAllowed: this.props.campaign.TargetingDeviceSubTypesIsAllowed,
        TargetingDeviceModels: (() => {
          if (this.props.campaign && this.props.campaign.TargetingDeviceModels) {
            return this.props.campaign.TargetingDeviceModels;
          }
          return '0';
        })(),
        TargetingDeviceModelsIsAllowed: this.props.campaign.TargetingDeviceModelsIsAllowed,
        segments: [] as IAudienceSegment[],
        TargetingAudienceSegmentID: this.props.campaign.TargetingAudienceSegmentID || '',
        TargetingAudienceSegmentIDIsAllowed:
          this.props.campaign.TargetingAudienceSegmentIDIsAllowed,
        TargetingSitePages: this.props.campaign.TargetingSitePages || '',
        TargetingSitePagesIsAllowed: this.props.campaign.TargetingSitePagesIsAllowed,
        TargetingLivestreamText: (() => {
          if (this.props.campaign && this.props.campaign.TargetingLivestream) {
            const opt = getLivestreamOption(this.props.campaign.TargetingLivestream);
            if (opt) {
              return opt.text;
            }
          }
          return livestreamOptions[0].text;
        })(),
        TargetingLivestream: (() => {
          if (this.props.campaign && this.props.campaign.TargetingLivestream) {
            const opt = getLivestreamOption(this.props.campaign.TargetingLivestream);
            if (opt) {
              return parseInt(opt.key, 10);
            }
          }
          return livestreamOptions[0].key;
        })(),
        localTargetingAllowedParameters: [] as ILocalTargetingParameter[],
        localTargetingDisallowedParameters: [] as ILocalTargetingParameter[],
        LocalTargetingAllowedLogic: this.props.campaign.LocalTargetingAllowedLogic,
        LocalTargetingDisallowedLogic: this.props.campaign.LocalTargetingDisallowedLogic,
        TargetingAppBundleID: this.props.campaign.TargetingAppBundleID || '',
        TargetingAppBundleIDIsAllowed:
          this.props.campaign.TargetingAppBundleIDIsAllowed || EAllowStatus.UNKNOWN,
        TargetingAppBundleSitePagesLogic: this.props.campaign.TargetingAppBundleSitePagesLogic,
        TargetingDealID: this.props.campaign.TargetingDealID || '',
        TargetingDealIDIsAllowed:
          this.props.campaign.TargetingDealIDIsAllowed || EAllowStatus.UNKNOWN,
        TargetingFWSectionIDs: this.props.campaign.TargetingFWSectionIDs || '',
        TargetingFWSectionIDsIsAllowed:
          this.props.campaign.TargetingFWSectionIDsIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentChannel: this.props.campaign.TargetingContentChannel || '',
        TargetingContentChannelIsAllowed:
          this.props.campaign.TargetingContentChannelIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentDistributor: this.props.campaign.TargetingContentDistributor || '',
        TargetingContentDistributorIsAllowed:
          this.props.campaign.TargetingContentDistributorIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentGenre: this.props.campaign.TargetingContentGenre || '',
        TargetingContentGenreIsAllowed:
          this.props.campaign.TargetingContentGenreIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentID: this.props.campaign.TargetingContentID || '',
        TargetingContentIDIsAllowed:
          this.props.campaign.TargetingContentIDIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentNetwork: this.props.campaign.TargetingContentNetwork || '',
        TargetingContentNetworkIsAllowed:
          this.props.campaign.TargetingContentNetworkIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentProducer: this.props.campaign.TargetingContentProducer || '',
        TargetingContentProducerIsAllowed:
          this.props.campaign.TargetingContentProducerIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentRating: this.props.campaign.TargetingContentRating || '',
        TargetingContentRatingIsAllowed:
          this.props.campaign.TargetingContentRatingIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentSeries: this.props.campaign.TargetingContentSeries || '',
        TargetingContentSeriesIsAllowed:
          this.props.campaign.TargetingContentSeriesIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentTitle: this.props.campaign.TargetingContentTitle || '',
        TargetingContentTitleIsAllowed:
          this.props.campaign.TargetingContentTitleIsAllowed || EAllowStatus.UNKNOWN,
        TargetingContentLanguage: this.props.campaign.TargetingContentLanguage || '',
        TargetingContentLanguageIsAllowed:
          this.props.campaign.TargetingContentLanguageIsAllowed || EAllowStatus.UNKNOWN,
        CustomTargeting: this.props.campaign.CustomTargeting || '',
        CustomTargetingInclusion:
          this.props.campaign.CustomTargetingInclusion || EAllowStatus.ALLOW,
        TargetingCustom4: this.props.campaign.TargetingCustom4 || '',
        TargetingCustom4Inclusion:
          this.props.campaign.TargetingCustom4Inclusion || EAllowStatus.ALLOW,
        TargetingCustom5: this.props.campaign.TargetingCustom5 || '',
        TargetingCustom5Inclusion:
          this.props.campaign.TargetingCustom5Inclusion || EAllowStatus.ALLOW,
        TargetingCustom6: this.props.campaign.TargetingCustom6 || '',
        TargetingCustom6Inclusion:
          this.props.campaign.TargetingCustom6Inclusion || EAllowStatus.ALLOW,
        TargetingCustom7: this.props.campaign.TargetingCustom7 || '',
        TargetingCustom7Inclusion:
          this.props.campaign.TargetingCustom7Inclusion || EAllowStatus.ALLOW,
        TargetingCustom8: this.props.campaign.TargetingCustom8 || '',
        TargetingCustom8Inclusion:
          this.props.campaign.TargetingCustom8Inclusion || EAllowStatus.ALLOW,
        TargetingCustom9: this.props.campaign.TargetingCustom9 || '',
        TargetingCustom9Inclusion:
          this.props.campaign.TargetingCustom9Inclusion || EAllowStatus.ALLOW,
        TargetingCustom10: this.props.campaign.TargetingCustom10 || '',
        TargetingCustom10Inclusion:
          this.props.campaign.TargetingCustom10Inclusion || EAllowStatus.ALLOW,
        TargetingCustom11: this.props.campaign.TargetingCustom11 || '',
        TargetingCustom11Inclusion:
          this.props.campaign.TargetingCustom11Inclusion || EAllowStatus.ALLOW,
        TargetingCustom12: this.props.campaign.TargetingCustom12 || '',
        TargetingCustom12Inclusion:
          this.props.campaign.TargetingCustom12Inclusion || EAllowStatus.ALLOW,
        TargetingCustom13: this.props.campaign.TargetingCustom13 || '',
        TargetingCustom13Inclusion:
          this.props.campaign.TargetingCustom13Inclusion || EAllowStatus.ALLOW,
        TargetingCustom14: this.props.campaign.TargetingCustom14 || '',
        TargetingCustom14Inclusion:
          this.props.campaign.TargetingCustom14Inclusion || EAllowStatus.ALLOW,
        TargetingCustom15: this.props.campaign.TargetingCustom15 || '',
        TargetingCustom15Inclusion:
          this.props.campaign.TargetingCustom15Inclusion || EAllowStatus.ALLOW,
        TargetingCustom16: this.props.campaign.TargetingCustom16 || '',
        TargetingCustom16Inclusion:
          this.props.campaign.TargetingCustom16Inclusion || EAllowStatus.ALLOW,
        TargetingCustom17: this.props.campaign.TargetingCustom17 || '',
        TargetingCustom17Inclusion:
          this.props.campaign.TargetingCustom17Inclusion || EAllowStatus.ALLOW,
        TargetingCustom18: this.props.campaign.TargetingCustom18 || '',
        TargetingCustom18Inclusion:
          this.props.campaign.TargetingCustom18Inclusion || EAllowStatus.ALLOW,
        PacingTypeText: (() => {
          if (this.props.campaign && this.props.campaign.PacingType) {
            const pacingTypeOption = getPacingTypeOption(this.props.campaign.PacingType);
            if (pacingTypeOption) {
              return pacingTypeOption.text;
            }
          } else if (this.props.order && this.props.order.PacingType !== 4) {
            const pacingTypeOption = getPacingTypeOption(this.props.order.PacingType);
            if (pacingTypeOption) {
              return pacingTypeOption.text;
            }
          }

          return pacingTypeOptions[0].text;
        })(),
        PacingType: (() => {
          if (this.props.campaign && this.props.campaign.PacingType) {
            const pacingTypeOption = getPacingTypeOption(this.props.campaign.PacingType);
            if (pacingTypeOption) {
              return pacingTypeOption.value;
            }
          } else if (this.props.order && this.props.order.PacingType !== 4) {
            const pacingTypeOption = getPacingTypeOption(this.props.order.PacingType);
            if (pacingTypeOption) {
              return pacingTypeOption.value;
            }
          }

          return pacingTypeOptions[0].value;
        })(),
        IPFilter: this.props.campaign.IPFilter || '',
        targetingCountriesList: generateCountriesMenuList(),
        targetingCountryGroupList: generateCountryGroupMenuList(
          this.props.campaign.CountryGroups || [],
        ),
        createEditRegionID: '',
        createEditRegionName: '',
        createEditRegionList: generateCountriesMenuList(),
        publisherCountryGroups: [] as ICountryGroup[],
        updatingCountryGroup: false,
        openRegionCreateEditDialog: false,
        openRegionSelectDialog: false,
        openRegionSelectTable: false,
        deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        GlobalMediaFiles: [] as IAdserverGlobalMediafile[],
        globalMediafileList: {} as ICampaignCreativeList,
        globalVastList: {} as ICampaignCreativeList,
        vasts: [] as IAdserverGlobalVast[],
        blankMediaFileList: {} as IMenuList,
        blankVastList: {} as IMenuList,
        SegmentTargeting: this.props.campaign.SegmentTargeting || SegmentTargetingOR,
        channelGroupsList: {} as IMenuList,
        ChannelGroups: this.props.campaign.ChannelGroups || [],
        ChannelGroupIDS: this.props.campaign.ChannelGroupIDS || [],
        ChannelListIDS: this.props.campaign.ChannelListIDS || [],
        channelLabels: [] as IChannelLabel[],
        TargetingCoppa: this.props.campaign.TargetingCoppa,
        TargetingLimitedAdTracking: this.props.campaign.TargetingLimitedAdTracking,
        TargetingDeviceTypes: this.props.campaign.TargetingDeviceTypes,
        TargetingDeviceTypesIsAllowed: this.props.campaign.TargetingDeviceTypesIsAllowed,
        AdserverOrderID: this.props.campaign.AdserverOrderID,
        SiteAdserverCampaignAssociations: this.props.campaign.SiteAdserverCampaignAssociations,
        ChannelGroupAdserverCampaignAssociations:
          this.props.campaign.ChannelGroupAdserverCampaignAssociations,
        ChannelListAdserverCampaignAssociations:
          this.props.campaign.ChannelListAdserverCampaignAssociations,
        SiteWeightsActive: this.props.campaign.SiteWeightsActive,
        refresh: 0,
        EnableGrossCPM: this.props.campaign.EnableGrossCPM || EBool.EBool_FALSE,
        openCreateDialog: false,
        newCreateURL: '',
        newCreateName: '',
        creativeIDForCreateModal: '',
        selectedResolutions: ['1080p', '720p'],
        forceMenuButtonClosed: false,
        uploading: false,
        ignoreInvalidCreativeDates: false,
        openCreativeFlightDateModal: false,
        creativeFlightModalItems: [] as IAdserverCreativeWithTableData[],
        DisableLowPacing: this.props.campaign.DisableLowPacing,
        ServeRightAway: this.props.campaign.ServeRightAway,
        EnableOverDelivery: this.props.campaign.EnableOverDelivery,
        SkipEnabled: this.props.campaign.SkipEnabled,
        SkipOffset: this.props.campaign.SkipOffset,
        openDisableLowPacingDialog: false,
        openServeRightAwayDialog: false,
        vastEditIndex: -1,
        tempVastURL: '',
        openReactivateBiddersModal: false,
        inactiveBiddersTargetingCampaign: [] as IBidderWithTableData[],
        ignoreReactivateBidders: true,
        adserverOrder: {} as IAdserverOrder,
        contextualSegmentList: {} as IMenuList,
        ContextualSegmentIDS: this.props.campaign.ContextualSegmentIDS || [],
        quickFilterOptions: [] as Array<{ title: string; optionItems: IMenuList; type: string }>,
        commonRegionGroups: [] as ICountryGroup[],
        GuaranteedDeliveryEnabled: this.props.campaign.GuaranteedDeliveryEnabled,
        Alias: this.props.campaign.Alias || '',
        uniqueLineItemAliases: [] as IAdserverAlias[],
        openChannelListDialog: false,
        openChannelListEditDialog: false,
        channelListChannelGroups: {} as IMenuList, // Channel List (Channel Groups List) for Dropdown
        channelListChannels: {} as IMenuList, // Channel List (Channels List) for Dropdown
        channelListsList: {} as IMenuList, // List of Channel Lists for Dropdown
        channelLists: [] as IChannelList[], // Channel Lists Object retrived from the backend
        ChannelListChannelsIDS: [] as number[], // Channels IDS in the Channel Lists Object
        ChannelListGroupsIDS: [] as number[], // Channel Groups IDS in the Channel Lists Object
        editChannelListChannelGroups: {} as IMenuList, // Channel List (Channel Groups List) for Dropdown Edit
        editChannelListChannels: {} as IMenuList, // Channel List (Channels List) for Dropdown Edit
        editChannelListsList: {} as IMenuList, // List of Channel Lists for Dropdown Edit
        editChannelListID: 0 as number,
        EditChannelListChannelsIDS: [] as number[], // Edit Channels IDS in the Channel Lists Object
        EditChannelListGroupsIDS: [] as number[], // Edit Channel Groups IDS in the Channel Lists Object
        listSettingsDialogActive: false,
        listSettingsDialogID: 0,
        newChannelGroupActive: false,
        TargetingCCPA: this.props.campaign.TargetingCCPA || TargetingCCPAAll,
        CategoryExclusivityEnabled:
          this.props.campaign.CategoryExclusivityEnabled || EBool.EBool_FALSE,
        isCreatingPrimaryBanner: false,
        isCreatingSecondaryBanner: false,
        openCreateBannerDialog: false,
        newCreateBannerURL: '',
        newCreateBannerName: '',
        BannerAdvertiserID: 0,
        TargetingRequestedPodDurationMin:
          this.props.campaign.TargetingRequestedPodDurationMin ||
          TargetingRequestedPodDurationNoMin,
        TargetingRequestedPodDurationMax:
          this.props.campaign.TargetingRequestedPodDurationMax ||
          TargetingRequestedPodDurationNoMax,
        TargetingGvinParamExists: this.props.campaign.TargetingGvinParamExists || EBool.EBool_FALSE,
        openDeleteCreativesConfirmation: false,
        TargetingGDPR: this.props.campaign.TargetingGDPR || TargetingGDPRAll,
        isLoadingMediaFilesAndVasts: false,
        PresetIDs: this.props.campaign.PresetIDs || [],
        PresetList: [],
        presetConflicts: {},
        presetConflictedParamKeys: [],
        reactKey: 0,
        AdserverCreativeFlightDatesSubgroups:
          this.props.campaign.AdserverCreativeFlightDatesSubgroups || [],
        SamplingPercentageDisabledUntil: this.props.campaign.SamplingPercentageDisabledUntil,
        SamplingPercentage: this.props.campaign.SamplingPercentage,
        selectedChartView: 'liveData',
        // Auction Insights
        auctionInsightsCalStartDate: initialStartDate,
        auctionInsightsCalEndDate: initialEndDate,
        // extended id targeting type
        TargetingUID20TargetingType:
          this.props.campaign.TargetingUID20TargetingType || ExtendedIDTargetingTypeDisabled,
        TargetingGooglePairIDTargetingType:
          this.props.campaign.TargetingGooglePairIDTargetingType || ExtendedIDTargetingTypeDisabled,
        TargetingLiveRampATSTargetingType:
          this.props.campaign.TargetingLiveRampATSTargetingType || ExtendedIDTargetingTypeDisabled,
        TargetingIrisSignalTargetingType:
          this.props.campaign.TargetingIrisSignalTargetingType || ExtendedIDTargetingTypeDisabled,
        // TargetingSamsungIdentityTargetingType:
        //   this.props.campaign.TargetingSamsungIdentityTargetingType ||
        //   ExtendedIDTargetingTypeDisabled,
        // TargetingSamsungEPGMetadataTargetingType:
        //   this.props.campaign.TargetingSamsungEPGMetadataTargetingType ||
        //   ExtendedIDTargetingTypeDisabled,
      };

      this.uploadManager = new UploadManager();

      this.uploadKeyToIdx = new Map<string, { idx: number; cidx: number }>();

      // no more default vast / mediafile, works better this way with dropdowns
      this.prevVast = [];
      this.prevMediafiles = [];

      this._saveCampaign = debounce(
        async (count: number, isCampaignSwitchingToActive?: boolean) => {
          const isExistCampaign = isExistingCampaign(this.state);
          if (count !== this.state.count) {
            return;
          }
          if (this.state.vastEditIndex !== -1) {
            // if the vast edit textfield is open
            this.setState({
              snackbarError: true,
              snackbarMessage:
                'Please save or cancel the editable VAST URL textfield before saving',
            });
            return;
          }
          if (!this.validateForm()) {
            if (this.state.errors.AdserverCampaignTrackers) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.AdserverCampaignTrackers}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.IABCategorySuffix) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.IABCategorySuffix}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.Quantity) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.Quantity}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.DateTimes) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.DateTimes}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.AdserverCreativeFlightDatesSubgroups) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.AdserverCreativeFlightDatesSubgroups}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.AdserverCreatives) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.AdserverCreatives}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.localTargetingAllowedParameters) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.localTargetingAllowedParameters}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.localTargetingDisallowedParameters) {
              this.setState({
                snackbarMessage: `Saving line item failed. ${this.state.errors.localTargetingDisallowedParameters}.`,
                snackbarError: true,
                updating: false,
              });
            } else if (this.state.errors.Name) {
              this.setState({
                snackbarMessage: 'Saving line item failed. Please choose a custom name.',
                snackbarError: true,
                updating: false,
              });
            } else {
              this.setState({
                snackbarMessage:
                  'Saving line item failed. Please verify and fix your frequency values and try again.',
                snackbarError: true,
                updating: false,
              });
            }
            return;
          }
          const allCheckpointErrors = [];
          for (const checkpoint of this.state.FlightDateCheckpoints) {
            if (!!checkpoint.errors && checkpoint.errors.length > 0) {
              allCheckpointErrors.push(checkpoint.errors);
            }
          }
          if (allCheckpointErrors.length > 0) {
            this.setState({
              snackbarMessage:
                'Saving line item failed. Please correct flight date checkpoint errors.',
              snackbarError: true,
              updating: false,
            });
            return;
          }
          if (!this.state.dateStart || !this.state.dateEnd) {
            this.setState({
              snackbarMessage: 'Saving line item failed. Please provide start and end dates.',
              snackbarError: true,
              updating: false,
            });
            return;
          }

          if (this.state.Sites.length === 0 && this.state.ChannelGroupIDS.length === 0) {
            this.setState({
              snackbarMessage:
                'Saving line item failed. Please select at least one channel or channel group.',
              snackbarError: true,
              updating: false,
            });
            return;
          }

          if (EBool.toBool(this.state.SiteWeightsActive) && this.isLowPacingDisabledOnTheUI()) {
            this.setState({
              snackbarMessage:
                "Saving line item failed. You can't disable low pacing if site weight is active.",
              snackbarError: true,
              updating: false,
            });
            return;
          }

          const AdserverCreatives: IAdserverCreative[] = [];
          if (this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE) {
            this.state.AdserverCreativeFlightDatesSubgroups.forEach(
              (AdserverCreativeFlightDatesSubgroup) => {
                AdserverCreatives.push(...AdserverCreativeFlightDatesSubgroup.AdserverCreatives);
              },
            );
          } else {
            AdserverCreatives.push(...this.state.AdserverCreatives);
            // if VAST deletes mediafile IDs and if Mediafile deletes VAST ID
            if (this.state.CreativeType === CreativeTypeVast) {
              AdserverCreatives.forEach((creative) => {
                creative.AdserverGlobalMediafileIDs = [];
              });
            } else {
              AdserverCreatives.forEach((creative) => {
                creative.AdserverGlobalVastID = undefined;
              });
            }
          }

          // User must select adomain and IAB Cat if there is at least 1 Adserver Creatives
          if (
            this.state.Adomain === '' &&
            this.state.iabList.length === 0 &&
            AdserverCreatives.length > 0
          ) {
            this.setState({
              snackbarMessage:
                'Saving line item failed. Adomain and IAB Category are required. IAB Sub-Category recommended.',
              snackbarError: true,
              updating: false,
            });
            return;
          }
          if (this.state.Adomain === '' && AdserverCreatives.length > 0) {
            this.setState({
              snackbarMessage:
                'Saving line item failed. Please fill the Adomain field under the Creatives tab.',
              snackbarError: true,
              updating: false,
            });
            return;
          }
          if (this.state.iabList.length === 0 && AdserverCreatives.length > 0) {
            this.setState({
              snackbarMessage:
                'Saving line item failed. Please select at least one IAB Category under the Creatives tab.',
              snackbarError: true,
              updating: false,
            });
            return;
          }
          if (this.hasSecondaryBanner() && !this.hasPrimaryBanner()) {
            this.setState({
              snackbarMessage:
                'Saving line item failed. Cannot upload Secondary Banner without Primary Banner. Please add a Primary Banner.',
              snackbarError: true,
              updating: false,
            });
            return;
          }

          // TODO: WORK IN PROGRESS
          if (!isEmpty(this.state.PresetIDs)) {
            const { isValid, activeParameterInfo, conflictedParameters } =
              await validateTargetingPresetSelections(this.props.session.publisher.ID, {
                customTargeting: this.generateCustomTargetingPayload(),
                presetIDs: this.state.PresetIDs,
              });

            if (!isValid) {
              this.setState(
                {
                  presetConflicts: activeParameterInfo,
                  presetConflictedParamKeys: conflictedParameters,
                  snackbarMessage: `Conflicts detected with selected preset(s) and custom targeting. Please review Active Fields and adjust to resolve the issue before saving.`,
                  snackbarError: true,
                  updating: false,
                },
                () => {
                  setTimeout(this.snackbarClose, 6000);
                },
              );
              return;
            }
          }
          const cloneState = cloneDeep(this.state);
          const selectedCountryGroupItems = Object.values(
            this.state.targetingCountryGroupList,
          ).filter((item) => item.selected);
          // @ts-ignore
          delete cloneState.GlobalMediaFiles;
          (isExistCampaign ? updateCampaign : createCampaign)({
            body: Object.assign(
              {
                publisher_id: this.props.session.publisher.ID,
                campaign: {
                  ...this.state,
                  PublisherID: this.props.session.publisher.ID,
                  StartDate: formatDateWithOffsetToUTC(this.state.dateStart, this.state.Timezone),
                  EndDate: formatDateWithOffsetToUTC(this.state.dateEnd, this.state.Timezone),
                  LocalTargetingAllowed: this.exportLocalTargetingParamToJSON(true),
                  LocalTargetingDisallowed: this.exportLocalTargetingParamToJSON(false),
                  TargetedCountries: this.convertTargetedCountriesToList(), // Convert the local device targeting country to string
                  FrequencyCaps: this.state.FrequencyCaps,
                  TargetingCountryGroupIDs: selectedCountryGroupItems
                    .map((item) => item.ID)
                    .join(','),
                },
              },
              isExistCampaign
                ? {
                    campaign_id: this.state.ID,
                  }
                : {},
            ),
          }).then(
            (campaign: IAdserverCampaign) => {
              const FrequencyCaps = this.state.FrequencyCaps.map((frequencyCap) => {
                frequencyCap.DurationUnits =
                  parseInt(frequencyCap.TimeToLive, 10) % 86400 === 0
                    ? FrequencyCapUnitDays
                    : FrequencyCapUnitHours;
                frequencyCap.EditableDuration = this.calcFrequencyCapDuration(frequencyCap);
                return frequencyCap;
              });
              campaign.FrequencyCaps = FrequencyCaps;
              // if a new campaign was created, navigate to that page
              if (!isExistCampaign) {
                navigate(RouteCampaignExisting, extractRouteParams(this.props), {
                  campaignID: campaign.ID.toString(),
                  order: campaign.AdserverOrderID.toString(),
                });
                return;
              } else if (
                isExistCampaign &&
                this.props.order &&
                this.props.order.Active === ResourceActiveDisabled &&
                isCampaignSwitchingToActive
              ) {
                // if updating an existing campaign and its parent order is inactive
                // if this campaign was updating TO active, update the parent to active as well
                this.updateParentOrderToActive();
              }
              if (count !== this.state.count) {
                return;
              }
              let daypartingObj;
              try {
                daypartingObj = JSON.parse(campaign.Dayparting);
              } catch (e) {
                daypartingObj = {
                  Enabled: false,
                  Schedule: cloneDeep(scheduleStrings),
                };
              }
              const isDaypartingActive = daypartingObj.Enabled;
              const enableViewerTimezone = daypartingObj.EnableViewerTimezone || false;
              const DaypartingIntervals = findDaypartingIntervals(
                cloneDeep(daypartingObj.Schedule),
              );
              this.setState(
                {
                  ...campaign,
                  AdserverCreativeFlightDatesSubgroups:
                    this.state.EnableFlightDateSubgroups === EBool.EBool_FALSE
                      ? []
                      : adserverCreativesToSubgroups(campaign.AdserverCreatives),
                  AdserverCreatives:
                    this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE
                      ? []
                      : flagBanners(campaign.AdserverCreatives),
                  isDaypartingActive,
                  enableViewerTimezone,
                  DaypartingIntervals,
                  TargetingCountryGroupIDs: campaign.TargetingCountryGroupIDs,
                  TargetingCountryGroupIDsIsAllowed: campaign.TargetingCountryGroupIDsIsAllowed,
                  siteWeightsActiveDBValue: campaign.SiteWeightsActive,
                  updating: false,
                  snackbarMessage: 'Successfully saved line item.',
                  snackbarError: false,
                  refresh: this.state.refresh + 1,
                  presetConflictedParamKeys: [],
                  presetConflicts: {},
                },
                () => {
                  this.genChannelGroupsList();
                  window.location.href =
                    '/#' +
                    getRoutePath(RouteCampaignExisting, extractRouteParams(this.props), {
                      campaignID: campaign.ID.toString(),
                      order: campaign.AdserverOrderID.toString(),
                    }) +
                    `&refresh=${this.state.refresh}`;
                },
              );
            },
            (err: string) => {
              if (count !== this.state.count) {
                return;
              }
              this.setState({
                updating: false,
                snackbarMessage: err.toString(),
                snackbarError: true,
                presetConflictedParamKeys: [],
                presetConflicts: {},
              });
            },
          );
        },
        500,
      );
    }

    isSuperUser = hasRoleSuperUser(this.props.user.user);
    isNativeVastAuthorized =
      this.props.session.publisher.NativeVastEnabled === EBool.EBool_TRUE || this.isSuperUser;

    calcFrequencyCapDuration = (frequencyCap: IFrequencyCap): string => {
      const frequencyCapTimeToLive = frequencyCap.TimeToLive;
      if (frequencyCap.DurationUnits === FrequencyCapUnitHours) {
        return (parseInt(frequencyCapTimeToLive, 10) / 3600).toString();
      } else {
        return (parseInt(frequencyCapTimeToLive, 10) / 86400).toString();
      }
    };

    isLowPacingDisabledOnTheUI = (): boolean => EBool.toBool(this.state.DisableLowPacing);

    // if updating an existing campaign and its parent order is inactive
    // if this campaign was updating TO active, update the parent to active as well
    updateParentOrderToActive = () => {
      const order = this.props.order;
      if (order) {
        const updatedOrder = {
          ID: order.ID,
          Active: ResourceActiveEnabled,
        } as IAdserverOrder;
        // since we are only updating the active field, this is a partial update rather than a full update
        // from this, we do not want to update the children line items to be the same as the order
        updateAdserverOrder(updatedOrder, this.props.session.publisher.ID, false, false).catch(
          () => {
            console.error('Error updating parent order');
          },
        );
      }
    };

    convertTargetedCountriesToList = (): string => {
      let targetingDeviceCountry: IGeo[];
      if (this.state.deviceTargetingCountrySelectMode === SelectMode.Denylist) {
        // Denylist - Save all the invert countries (If I deny 2 countries => Allow ALL-2 countries)
        const allowlist: IGeo[] = getAllCountries().slice(); // Copy array, do not reference it
        Object.values(this.state.targetingCountriesList)
          .filter((item: IListItem) => item.selected)
          .forEach((selected: IListItem) => {
            const index = allowlist.findIndex((item: IGeo) => selected.ID === item.key);
            if (index > -1) {
              allowlist.splice(index, 1);
            }
          });
        targetingDeviceCountry = allowlist;
      } else {
        // Allowlist - save all selected countries
        targetingDeviceCountry = Object.values(this.state.targetingCountriesList)
          .filter((item: IListItem) => item.selected)
          .map((item: IListItem) => {
            return {
              key: item.ID,
              text: item.title,
            } as IGeo;
          });
      }
      return targetingDeviceCountry.map((c: IGeo) => c.key.toUpperCase()).join(',');
    };

    validateCreatives = (): string => {
      let errorMsg: string = '';

      const AdserverCreatives: IAdserverCreative[] = [];
      if (this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE) {
        this.state.AdserverCreativeFlightDatesSubgroups.forEach(
          (AdserverCreativeFlightDatesSubgroup) => {
            AdserverCreatives.push(...AdserverCreativeFlightDatesSubgroup.AdserverCreatives);
          },
        );
      } else {
        AdserverCreatives.push(...this.state.AdserverCreatives);
      }

      AdserverCreatives.forEach((creative: IAdserverCreative) => {
        if (creative.Name.trim() === '') {
          errorMsg = 'Please ensure that all creatives have a non-empty name';
        }
        // if there are current uploads, we do not check if the creatives have mediafiles since they are being created and
        // we want the user to be able to navigate away and save
        if (
          !this.state.uploading &&
          !creative.AdserverGlobalMediafileIDs.length &&
          !creative.AdserverGlobalVastID
        ) {
          errorMsg =
            'Please ensure that all creatives have an asset / VAST or ensure no creatives are assigned to this line item.';
        }
      });

      return errorMsg;
    };

    // returns a filtered list of trackers that have non-empty URLs and Types
    filterTrackers = (trackers: IAdserverCampaignTracker[]): IAdserverCampaignTracker[] => {
      return trackers.filter((tracker) => tracker.URL.trim() !== '' || tracker.Type.trim() !== '');
    };

    campaignHasInactiveChannels = (): boolean => {
      let includesInactiveSite = false;

      this.state.allSites.forEach((site: ISmallSite) => {
        if (this.state.Sites.includes(site.ID.toString())) {
          if (!IsSmallSiteActive(site)) {
            includesInactiveSite = true;
          }
        }
      });

      return includesInactiveSite;
    };

    getCampaign = () => {
      const { location, session } = this.props;
      const loc = parseLocation(location.pathname);

      getCampaign({
        query: {
          publisher_id: session.publisher.ID,
          campaign_id: loc.campaign,
        },
      })
        .then((campaign: IAdserverCampaign) => {
          this.setState(
            Object.assign({}, this.state, campaign, {
              updating: false,
              snackbarError: false,
            }),
          );
        })
        .catch(() => {
          this.setState(
            {
              snackbarMessage:
                "You don't have access to this campaign. Please create one or select one in your existiing list.",
              snackbarError: true,
            },
            () => {
              setTimeout(() => {
                navigate(
                  RouteCampaignSettingsList,
                  extractRouteParams({
                    session: this.props.session,
                    user: this.props.user,
                  }),
                );
              }, 3000);
            },
          );
        });
    };

    saveCampaign = (isCampaignSwitchingToActive?: boolean) => {
      const {
        count,
        isDaypartingActive,
        enableViewerTimezone,
        AdserverCampaignTrackers,
        AdserverCreativeFlightDatesSubgroups,
        DaypartingIntervals,
        FrequencyLimitDays,
        TargetingAudienceSegmentID,
        Quantity,
        segments,
        Timezone,
        ignoreInvalidCreativeDates,
      } = this.state;

      const errorMessages: string[] = [];

      if (!this.state.dateStart) {
        errorMessages.push('Please provide a start date');
      }
      if (!this.state.dateEnd) {
        errorMessages.push('Please provide an end date');
      }
      if (this.daypartingActiveWithoutTimePeriod()) {
        errorMessages.push(
          'Dayparting is set to active, please check your dayparting time periods',
        );
      }
      if (this.daypartingHasInvalidTimeErrors()) {
        errorMessages.push('Check dayparting for invalid times');
      }
      if (parseInt(FrequencyLimitDays, 10) > 30) {
        errorMessages.push('Frequency limit days must be less than or equal to 30');
      }
      if (this.campaignHasInactiveChannels()) {
        errorMessages.push('Please remove inactive channels from your line item');
      }
      if (targetingInactiveAudienceSegments(segments, TargetingAudienceSegmentID)) {
        errorMessages.push('Please remove inactive audience segments from your line item');
      }
      for (const cap of this.state.FrequencyCaps) {
        const ttl = parseInt(cap.TimeToLive, 10);
        if (ttl > 120 * 24 * 60 * 60) {
          errorMessages.push('Frequency cap duration cannot exceed 120 days');
        }
      }
      const creativesErrMsg = this.validateCreatives();
      if (creativesErrMsg !== '') {
        errorMessages.push(creativesErrMsg);
      }

      if (errorMessages.length > 0 || !this.state.dateStart || !this.state.dateEnd) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot save: ' + errorMessages.join('. '),
        });
        return;
      }

      // While saving campaign, it converts Adserver Creative Subgroup object to AdserverCreatives
      if (this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE) {
        let AdserverCreatives = [] as IAdserverCreative[];
        AdserverCreativeFlightDatesSubgroups.forEach((sg: IAdserverCreativeFlightDatesSubgroup) => {
          AdserverCreatives = AdserverCreatives.concat(sg.AdserverCreatives);
        });
        this.setState({
          AdserverCreatives,
        });
      }

      // if the creative flight dates are not adequately covering line item dates, open modal
      // if ignoreInvalidCreativeDates is active, we skip this step
      if (!ignoreInvalidCreativeDates && !this.validCreativeFlightDates()) {
        const creativeFlightModalItems = [] as any[];
        const lineItemPlus = {
          ID: 'Line Item',
          Name: this.state.Name,
          StartDate: formatDateWithOffsetToUTC(this.state.dateStart, this.state.Timezone),
          EndDate: formatDateWithOffsetToUTC(this.state.dateEnd, this.state.Timezone),
          tableData: { checked: true },
        };
        creativeFlightModalItems.push(lineItemPlus);
        for (const creative of this.state.AdserverCreatives) {
          const creativePlus = Object.assign({}, creative, { tableData: { checked: true } });
          creativeFlightModalItems.push(creativePlus);
        }
        this.setState({
          openCreativeFlightDateModal: true,
          creativeFlightModalItems,
        });
        return;
      }

      // check if deactivated headerbidders need reactivating
      // TO DO: when bidder targeting is updated to be cloned with line item cloning
      // this will need to be updated to search for inactive bidders targeting the line item being cloned
      if (!this.state.ignoreReactivateBidders && this.state.ID !== '') {
        getInactiveHeaderBiddersTargetingCampaign(this.state.ID, this.props.session.publisher.ID)
          .then((val: IHttpResponse<IBidderWithTableData[]>) => {
            const headerbidders = [] as IBidderWithTableData[];
            if (val.parsedBody) {
              for (const item of val.parsedBody as IBidderWithTableData[]) {
                const bidder = transformBidderWithTableDataWrapper(item);
                headerbidders.push(bidder);
              }
            }
            if (headerbidders.length > 0) {
              this.setState({
                inactiveBiddersTargetingCampaign: headerbidders,
                openReactivateBiddersModal: true,
              });
            } else {
              this.setState(
                {
                  ignoreReactivateBidders: true,
                },
                this.saveCampaign,
              );
            }
          })
          .catch(() => {
            this.setState({
              snackbarMessage: 'error fetching bidders targeting this campaign',
            });
          });
        return;
      }

      let IABCategory = '';
      IABCategory = this.makeIABString();

      // Set GrossCPM to 0 if empty
      let GrossCPM = this.state.GrossCPM;
      if (!GrossCPM) {
        GrossCPM = '0';
      }

      // Create Dayparting Object
      // we always want to parse dayparting non-inverted for the DB
      const Dayparting = parseDaypartingIntervals(
        DaypartingIntervals,
        isDaypartingActive,
        Timezone,
        true,
        enableViewerTimezone,
      );
      this.setState(
        {
          updating: true,
          count: count + 1,
          Quantity: Quantity.replace(/,/g, ''), // Removing number formatting causing issue in console
          IABCategory,
          Dayparting,
          GrossCPM,
          AdserverCampaignTrackers: this.filterTrackers(AdserverCampaignTrackers),
          ignoreInvalidCreativeDates: false,
        },
        () => {
          this._saveCampaign(count + 1, isCampaignSwitchingToActive);
        },
      );
    };

    // determines if the creative flight dates adequately cover the line item's flight dates
    // we can start by collapsing all the periods into a single period
    // for this collapsed period, the start must be before or equal to the line item start
    // for this collapsed period, the end must be after or equal to the line item end
    validCreativeFlightDates = (): boolean => {
      const periods = [] as IPeriod[];

      for (const creative of this.state.AdserverCreatives) {
        // if the start/end date of a creative is blank
        // we can use the line item start/end as a valid date
        const period = {
          start:
            creative.StartDate === ''
              ? this.state.dateStart
              : formatDateFromUTCToOffset(creative.StartDate, this.state.Timezone),
          end:
            creative.EndDate === ''
              ? this.state.dateEnd
              : formatDateFromUTCToOffset(creative.EndDate, this.state.Timezone),
        } as IPeriod;
        periods.push(period);
      }

      const collapsedPeriods = collapsePeriods(periods);

      // if the periods cannot be collapsed into a single period, we can return false since that means there is a gap in coverage
      if (collapsedPeriods.length > 1) {
        return false;
        // if there are no periods, there are no creatives
      } else if (collapsedPeriods.length === 0) {
        return true;
      } else if (
        collapsedPeriods[0].start.isAfter(this.state.dateStart) ||
        collapsedPeriods[0].end.isBefore(this.state.dateEnd)
      ) {
        return false;
      }

      return true;
    };

    validateForm = (): boolean => {
      // even weights if all weight is 1
      let isWeight1ForAll = true;
      this.state.AdserverCreatives.forEach((cr: IAdserverCreative) => {
        if (cr.Weight !== '1') {
          isWeight1ForAll = false;
        }
      });
      if (isWeight1ForAll) {
        this.evenWeights();
      }

      const errors = validate(this.state);
      if (hasErrors(errors)) {
        this.setState({
          errors,
        });
        return false;
      }
      this.setState({
        errors: {} as IErrors,
      });
      return true;
    };

    daypartingActiveWithoutTimePeriod = (): boolean => {
      if (this.state.isDaypartingActive === true) {
        if (this.state.DaypartingIntervals.length === 0) {
          return true;
        }
        if (this.state.DaypartingIntervals.length >= 1) {
          for (const interval of this.state.DaypartingIntervals) {
            let err = true;
            for (const val of Object.values(interval.ActiveDays)) {
              if (val === true) {
                err = false;
                break;
              }
            }
            // if at least one interval is missing a day selection, return error
            if (err === true) {
              return true;
            }
          }
        }
      }
      return false;
    };

    daypartingHasInvalidTimeErrors = (): boolean => {
      for (const interval of this.state.DaypartingIntervals) {
        const { StartTime, EndTime } = interval;
        if (!StartTime.isValid() || !EndTime.isValid()) {
          return true;
        }
      }
      return false;
    };

    // Top bar name change
    handleNameChange = (name: string): void => {
      this.setState({
        Name: name,
      });
    };

    handleSetUpdatingCountryGroup = (updatingCountryGroup: boolean) => {
      this.setState({ updatingCountryGroup });
    };

    handleOpenRegionSelectDialog = (countryGroupID: string) => {
      const { publisherCountryGroups } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      let newCreateEditRegionList = generateCountriesMenuList();
      let newCreateEditRegionName = '';
      if (foundCountryGroup) {
        newCreateEditRegionList = generateCountryMenuListFromIsos(
          foundCountryGroup.CountryIsos.split(','),
        );
        newCreateEditRegionName = foundCountryGroup.Name;
      }
      this.setState({
        createEditRegionID: countryGroupID,
        createEditRegionList: newCreateEditRegionList,
        createEditRegionName: newCreateEditRegionName,
        openRegionCreateEditDialog: true,
        openRegionSelectTable: false,
      });
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.name === 'SegmentTargeting') {
        this.setState({
          SegmentTargeting: parseInt(target.value, 10),
        });
      } else if (target.name === 'LocalTargetingAllowedLogic') {
        this.setState({
          LocalTargetingAllowedLogic:
            this.state.LocalTargetingAllowedLogic === TargetingLogicOR
              ? TargetingLogicAND
              : TargetingLogicOR,
        });
      } else if (target.name === 'LocalTargetingDisallowedLogic') {
        this.setState({
          LocalTargetingDisallowedLogic:
            this.state.LocalTargetingDisallowedLogic === TargetingLogicOR
              ? TargetingLogicAND
              : TargetingLogicOR,
        });
      } else if (target.name === 'ChannelListName') {
        // If disabling, clear thresholds, otherwise default with 1 threshold
        this.setState({
          channelListName: target.value,
        });
      } else {
        this.setState(
          {
            [target.name]: target.value,
          },
          () => {
            if (hasErrors(this.state.errors)) {
              this.validateForm();
            }
          },
        );
      }
    };

    handleChangeCPMAndCurrency = (cpm: string, currency: CurrencyType) => {
      this.setState({
        CPM: cpm === undefined ? '0' : cpm,
        CurrencyDisplayed: convertStringToECurrencyType(currency),
      });
    };

    handleActiveChange = () => {
      this.setState(
        {
          Active:
            this.state.Active === CampaignActiveActive
              ? CampaignActiveInactive
              : CampaignActiveActive,
          // prompt reactivate bidders if campaign switched to active and campaign dates are currently serving
          ignoreReactivateBidders:
            this.state.Active === CampaignActiveInactive &&
            this.state.dateEnd &&
            this.state.dateEnd.isAfter(moment(new Date()).tz(this.state.Timezone))
              ? false
              : true,
        },
        () => this.saveCampaign(this.state.Active === CampaignActiveActive),
      );
    };

    handleChangeFrequencyCap = (
      { target }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | { value: any }>,
      field: string,
      frequencyCapIdx: number,
    ) => {
      const { FrequencyCaps } = this.state;
      const clonedFrequencyCaps = cloneDeep(FrequencyCaps);
      const foundFrequencyCap = clonedFrequencyCaps[frequencyCapIdx];

      if (foundFrequencyCap) {
        switch (field) {
          case 'Switch':
            if (foundFrequencyCap.Active === FrequencyCapActiveActive) {
              foundFrequencyCap.Active = FrequencyCapActiveInactive;
            } else {
              foundFrequencyCap.Active = FrequencyCapActiveActive;
            }
            break;
          case 'Limit':
            foundFrequencyCap.Limit = parseInt(target.value, 10) || 0;
            break;
          case 'TimeToLive':
            foundFrequencyCap.EditableDuration = target.value;
            if (foundFrequencyCap.DurationUnits === FrequencyCapUnitDays) {
              foundFrequencyCap.TimeToLive = (
                (parseInt(target.value as string, 10) || 0) * 86400
              ).toString();
            } else {
              foundFrequencyCap.TimeToLive = (
                (parseInt(target.value as string, 10) || 0) * 3600
              ).toString();
            }
          case 'Unit':
            foundFrequencyCap.DurationUnits = target.value;
            if (foundFrequencyCap.DurationUnits === FrequencyCapUnitDays) {
              foundFrequencyCap.TimeToLive = (
                (parseInt(foundFrequencyCap.EditableDuration || '', 10) || 0) * 86400
              ).toString();
            } else {
              foundFrequencyCap.TimeToLive = (
                (parseInt(foundFrequencyCap.EditableDuration || '', 10) || 0) * 3600
              ).toString();
            }
            break;
          case 'FrequencyTrackingKey':
            foundFrequencyCap.FrequencyTrackingKey = target.value;
            break;
          case 'FrequencyTargetingKey':
            foundFrequencyCap.FrequencyTargetingKey = target.value;
            break;
          default:
            break;
        }
      }
      this.setState({
        FrequencyCaps: clonedFrequencyCaps,
      });
    };

    handleChangeSwitch = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const { GuaranteedDeliveryEnabled, EnableFlightDateSubgroups } = this.state;
      const val = '';
      if (target.name === 'DaypartingActive') {
        this.setState(
          {
            isDaypartingActive: !this.state.isDaypartingActive,
          },
          () => {
            if (this.state.DaypartingIntervals.length === 0) {
              this.handleAddDaypartingPeriod();
            }
          },
        );
        return;
      } else if (['SkipEnabled', 'SiteWeightsActive'].includes(target.name)) {
        this.setState({
          [target.name]:
            this.state[target.name] === EBool.EBool_TRUE ? EBool.EBool_FALSE : EBool.EBool_TRUE,
        });
        return;
      } else if (['FlightDateCheckpointsEnabled'].includes(target.name)) {
        // quantity is the sum of the checkpoints quantity if the flight date checkpoints are enabled
        let Quantity = this.state.Quantity;
        if (this.state.FlightDateCheckpointsEnabled) {
          if (this.state.FlightDateCheckpoints.length > 0) {
            Quantity = this.state.FlightDateCheckpoints.map((c) => c.Quantity)
              .reduce((prev, curr) => prev + curr)
              .toString();
          } else {
            Quantity = '0';
          }
        }
        this.setState({
          FlightDateCheckpointsEnabled:
            this.state.FlightDateCheckpointsEnabled === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
          Quantity,
        });
        return;
      } else if (['FlightDateCheckpointsRolloverEnabled'].includes(target.name)) {
        this.setState({
          FlightDateCheckpointsRolloverEnabled:
            this.state.FlightDateCheckpointsRolloverEnabled === EBool.EBool_TRUE
              ? EBool.EBool_FALSE
              : EBool.EBool_TRUE,
        });
        return;
      } else if (target.name === 'EnableGrossCPM') {
        this.setState({
          EnableGrossCPM: target.checked ? EBool.EBool_TRUE : EBool.EBool_FALSE,
          GrossCPM: target.checked ? this.state.GrossCPM : '0', // still set to zero when inactive
        });
        return;
      } else if (target.name === 'DaypartingIsAllowed') {
        this.setState({
          DaypartingIsAllowed: target.checked ? EAllowStatus.ALLOW : EAllowStatus.DENY,
        });
        return;
      } else if (target.name === 'GuaranteedDeliveryEnabled') {
        this.setState({
          GuaranteedDeliveryEnabled:
            GuaranteedDeliveryEnabled === EBool.EBool_TRUE ? EBool.EBool_FALSE : EBool.EBool_TRUE,
        });
        return;
      } else if (target.name === 'EnableFlightDateSubgroups') {
        this.setState({
          EnableFlightDateSubgroups:
            EnableFlightDateSubgroups === EBool.EBool_TRUE ? EBool.EBool_FALSE : EBool.EBool_TRUE,
        });
        return;
      }
      this.setState(
        Object.assign({
          [target.name]: val,
        }),
      );
    };

    handleChangeSamplingDays = (elem: React.ChangeEvent<HTMLInputElement>): void => {
      if (elem.target.value === '') {
        this.setState({
          samplingPercentageDisabledUntilDays: 0,
          SamplingPercentageDisabledUntil: '',
        });
      } else {
        const samplingPercentageDisabledUntilDays = parseInt(elem.target.value, 10);
        if (
          Number.isNaN(samplingPercentageDisabledUntilDays) ||
          samplingPercentageDisabledUntilDays > 8
        ) {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'debug days must be between 0 and 8',
          });
        } else {
          this.setState({
            samplingPercentageDisabledUntilDays,
            SamplingPercentageDisabledUntil:
              samplingPercentageDisabledUntilDays !== 0
                ? moment(
                    moment.utc(new Date()).add(samplingPercentageDisabledUntilDays, 'day'),
                  ).format('YYYY-MM-DDTHH:mm:ssZ')
                : moment(moment.utc(new Date())).format('YYYY-MM-DDTHH:mm:ssZ'),
          });
        }
      }
    };

    handleChangeSelect = (name: string, value: string | string[]) => {
      this.setState({
        [name]: value,
      });
    };

    handleChangeEBool = (name: string, value: EBool): void => {
      const newVal = value === EBool.EBool_TRUE ? EBool.EBool_FALSE : EBool.EBool_TRUE;
      this.setState({
        [name]: newVal,
      });
    };

    creativeChangeHelper = (
      cidx: number,
      overwrite: { [key: string]: string | IAdserverGlobalMediafile[] },
      cb?: () => void,
    ) => {
      if (this.state.AdserverCreatives.length <= cidx) {
        this.setState(
          {
            AdserverCreatives: update(this.state.AdserverCreatives, {
              $push: [
                {
                  ID: '',
                  UUID: '',
                  CreatedAt: '',
                  UpdatedAt: '',
                  DeletedAt: '',

                  _CreativeType: CreativeTypeVast,
                  VAST: '',
                  AdserverMediafiles: [],
                  AdserverGlobalMediafileIDs: [],
                  overwrite,
                },
              ],
            }),
          },
          () => {
            if (cb) {
              cb();
            }
          },
        );
        return;
      }

      this.setState(
        {
          AdserverCreatives: update(this.state.AdserverCreatives, {
            $splice: [
              [
                cidx,
                1,
                update(this.state.AdserverCreatives[cidx], {
                  $merge: overwrite,
                }),
              ],
            ],
          }),
        },
        () => {
          if (cb) {
            cb();
          }
        },
      );
    };

    handleChangeCreativeType = (_: string, value: string) => {
      if (this.state.CreativeType !== value) {
        let backupState: any;

        if (this.state.CreativeType === CreativeTypeVast) {
          backupState = this.prevMediafiles;
          this.prevVast = this.state.AdserverCreatives;
        } else {
          backupState = this.prevVast;
          this.prevMediafiles = this.state.AdserverCreatives;
        }

        this.setState({
          CreativeType: value,
          AdserverCreatives: backupState,
        });
      }
    };

    handleAdserverCreativeChange = (name: string, value: string, cidx: number) => {
      this.creativeChangeHelper(cidx, {
        [name]: value,
      });
    };

    // updates the media / vast list in state but does not update campaign
    handleMediaOnChange = (list: IMenuList, creativeID: string) => {
      if (this.areCurrentCreativesAssets()) {
        const globalMediafileList = cloneDeep(this.state.globalMediafileList);
        globalMediafileList[creativeID] = list;
        this.setState({
          globalMediafileList,
        });
      } else {
        const globalVastList = cloneDeep(this.state.globalVastList);
        globalVastList[creativeID] = list;
        this.setState({
          globalVastList,
        });
      }
    };

    // sets creative mf ids or vast ids from the list
    handleMediaOnClick = (menuList: IMenuList, creativeID: string) => {
      const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
      // find all IDs that were selected on MenuList
      const selectedIDs = [] as string[];
      Object.values(menuList).forEach((item: IListItem) => {
        if (item.selected) {
          selectedIDs.push(item.ID);
        }
      });

      if (this.areCurrentCreativesAssets() && selectedIDs.length > 0) {
        // find the creative and update the mediafile IDS
        for (let i = 0; i < AdserverCreatives.length; i++) {
          if (creativeID === i.toString()) {
            AdserverCreatives[i].AdserverGlobalMediafileIDs = selectedIDs;
            break;
          }
        }
      } else if (!this.areCurrentCreativesAssets() && selectedIDs.length > 0) {
        // find the creative and update the vast id
        for (let i = 0; i < AdserverCreatives.length; i++) {
          if (creativeID === i.toString()) {
            AdserverCreatives[i].AdserverGlobalVastID = parseInt(selectedIDs[0], 10);
            break;
          }
        }
      }

      this.setState({
        AdserverCreatives,
      });
    };

    handleMediaOnClickV2 = (creativeIdx: number, ids: string[]) => {
      const newAdserverCreatives = [...this.state.AdserverCreatives];
      newAdserverCreatives[creativeIdx].AdserverGlobalMediafileIDs = ids;
      if (this.areCurrentCreativesAssets()) {
        newAdserverCreatives[creativeIdx].AdserverGlobalMediafileIDs = ids;
      } else {
        newAdserverCreatives[creativeIdx].AdserverGlobalVastID = parseInt(ids[0], 10);
      }

      this.setState({
        AdserverCreatives: newAdserverCreatives,
        reactKey: this.state.reactKey + 1,
      });
    };

    // finds the variant and changes active
    handleChangeVariantActive = (variantIdx: number, gmfIdx: number) => {
      const GlobalMediaFiles = cloneDeep(this.state.GlobalMediaFiles);
      if (GlobalMediaFiles.length === 0) {
        return;
      }
      if (GlobalMediaFiles[gmfIdx] && GlobalMediaFiles[gmfIdx].VariantMediafiles[variantIdx]) {
        GlobalMediaFiles[gmfIdx].VariantMediafiles[variantIdx].Active =
          GlobalMediaFiles[gmfIdx].VariantMediafiles[variantIdx].Active === EBool.EBool_TRUE
            ? EBool.EBool_FALSE
            : EBool.EBool_TRUE;
        this.setState(
          {
            updating: true,
          },
          () => {
            updateVariantMediafile({
              query: {
                publisher_id: this.props.session.publisher.ID,
                variant_mediafile_id:
                  GlobalMediaFiles[gmfIdx].VariantMediafiles[variantIdx].ID.toString(),
                active: GlobalMediaFiles[gmfIdx].VariantMediafiles[variantIdx].Active,
              },
            })
              .then(() => {
                this.setState({
                  GlobalMediaFiles,
                  snackbarMessage: 'Variant active successfully updated.',
                  updating: false,
                });
              })
              .catch(() => {
                this.setState({
                  snackbarMessage: 'Variant active failed to update.',
                  snackbarError: true,
                  updating: true,
                });
              });
          },
        );
      }
    };

    exportCampaign = () => {
      if (this.state.ID) {
        window.open(
          genExportCampaignWithCampaignID(
            this.state.siteList[Object.keys(this.state.siteList)[0]].ID,
            this.state.ID,
          ),
          '_blank',
        );
      } else {
        this.setState({
          snackbarMessage: 'Current line item has not been saved yet.',
          snackbarError: true,
        });
      }
    };

    handleDateChange = ({ start, end }: IDateRangeChangeEvent) => {
      const now = moment(new Date()).tz(this.state.Timezone);
      // if campaign is active and end date switched from not current to currently serving, prompt to reactivate bidders
      if (
        this.state.Active === CampaignActiveActive &&
        this.state.dateEnd &&
        this.state.dateEnd.isBefore(now) &&
        !this.state.dateEnd.isSame(end) &&
        end.isAfter(now)
      ) {
        this.setState({
          ignoreReactivateBidders: false,
        });
      }
      this.setState(
        {
          dateStart: start ? start : this.state.dateStart,
          StartDate: start
            ? start.utc().tz(this.state.Timezone).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.state.StartDate,
          dateEnd: end ? end : this.state.dateEnd,
          EndDate: end
            ? end.utc().tz(this.state.Timezone).format('YYYY-MM-DDTHH:mm:ssZ')
            : this.state.EndDate,
        },
        () => {
          if (this.state.FlightDateCheckpointsEnabled === EBool.EBool_TRUE) {
            this.validateFlightDateCheckpoints();
          }
        },
      );
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    // if we close a campaign form, if this is an existing campaign with an order ID,
    // we want to navigate back to that order's form. Otherwise, we can navigate
    // back to all Line Items
    goToOrderListView = () => {
      if (this.state.AdserverOrderID) {
        navigate(RouteOrderSettingsExisting, extractRouteParams(this.props), {
          order: this.state.AdserverOrderID.toString(),
        });
      } else {
        navigate(RouteCampaignSettingsList, extractRouteParams(this.props));
      }
    };

    // generating the params that's being used for line item forecast and tracked by forecast_usage_analytics
    generateTrackingMeta = (): { [key: string]: any } => {
      // edge case
      if (!this.state.dateStart || !this.state.dateEnd) {
        return {};
      }

      // Local targeting allowed
      const dmasAllowed = [];
      const zipsAllowed = [];
      const statesAllowed = [] as string[];
      const citiesAllowed = [];
      for (const params of this.state.localTargetingAllowedParameters) {
        dmasAllowed.push(params.dmas);
        zipsAllowed.push(params.zips);
        params.states.split(',').forEach((state: string) => statesAllowed.push(state));
        citiesAllowed.push(params.cities);
      }

      // Local targeting disallowed
      const dmasDisallowed = [];
      const zipsDisallowed = [];
      const statesDisallowed = [] as string[];
      const citiesDisallowed = [];
      for (const params of this.state.localTargetingDisallowedParameters) {
        dmasDisallowed.push(params.dmas);
        zipsDisallowed.push(params.zips);
        params.states.split(',').forEach((state: string) => statesDisallowed.push(state));
        citiesDisallowed.push(params.cities);
      }

      // Targeted countries
      const targetedCountries = this.convertTargetedCountriesToList();

      // we may want to parse dayparting inverted for forecasting since it won't use DaypartingIsAllowed
      const dayparting = parseDaypartingIntervals(
        this.state.DaypartingIntervals,
        this.state.isDaypartingActive,
        this.state.Timezone,
        this.state.DaypartingIsAllowed === EAllowStatus.ALLOW,
        this.state.enableViewerTimezone,
      );

      const activeFCaps = this.state.FrequencyCaps.filter(
        (FCap) => FCap.Active === FrequencyCapActiveActive,
      );
      const oneActiveFCap = activeFCaps.length === 1;

      return {
        publisher_id: this.props.session.publisher.ID,
        site_ids:
          this.state.Sites.length === this.state.siteCount ? 'all' : this.state.Sites.join(','),
        channel_group_ids:
          this.state.Sites.length === this.state.siteCount
            ? ''
            : this.state.ChannelGroupIDS.join(','),
        start_date: formatDateWithOffsetToUTC(this.state.dateStart, this.state.Timezone),
        end_date: formatDateWithOffsetToUTC(this.state.dateEnd, this.state.Timezone),
        timezone: this.state.Timezone,
        targeting_device_ids:
          this.state.TargetingDevices === '0' ? '' : this.state.TargetingDevices,
        countries:
          targetedCountries.split(',').length === this.state.countriesCount
            ? 'all'
            : targetedCountries,
        app_bundle_ids: this.state.TargetingAppBundleID,
        content_ids: this.state.TargetingContentID,
        livestream: this.state.TargetingLivestream !== 0 ? this.state.TargetingLivestream : '',
        frequency_active: oneActiveFCap ? FrequencyCapActiveActive : FrequencyCapActiveInactive,
        frequency_limit: oneActiveFCap ? activeFCaps[0].Limit : 0,
        frequency_ttl: oneActiveFCap ? activeFCaps[0].TimeToLive : 0,
        frequency_tracking_key: oneActiveFCap ? activeFCaps[0].FrequencyTrackingKey : 0,
        dayparting,
        dmas_allowed: dmasAllowed.join(''),
        zips_allowed: zipsAllowed.join(''),
        states_allowed: statesAllowed.join(','),
        cities_allowed: citiesAllowed.join(''),
        dmas_disallowed: dmasDisallowed.join(''),
        zips_disallowed: zipsDisallowed.join(''),
        states_disallowed: statesDisallowed.join(','),
        cities_disallowed: citiesDisallowed.join(''),
        targeting_device_types: this.state.TargetingDeviceTypes,
        targeting_device_subtypes:
          this.state.TargetingDeviceSubTypes === '0' ? '' : this.state.TargetingDeviceSubTypes,
        targeting_device_models:
          this.state.TargetingDeviceModels === '0' ? '' : this.state.TargetingDeviceModels,
        content_networks: this.state.TargetingContentNetwork,
        content_channels: this.state.TargetingContentChannel,
        content_genres: this.state.TargetingContentGenre,
        content_titles: this.state.TargetingContentTitle,
        lat:
          this.state.TargetingLimitedAdTracking === 1
            ? 'TRUE'
            : this.state.TargetingLimitedAdTracking === 2
            ? 'FALSE'
            : '',
        targeting_site_pages: this.state.TargetingSitePages,
      };
    };

    generateForecastParams = (trackedForecastParams: {
      [key: string]: any;
    }): { [key: string]: any } => {
      return Object.assign(
        {
          segment_targeting: this.state.SegmentTargeting, // default to 0 (OR), only single targeting segments HB-2181
          segment_ids: this.state.TargetingAudienceSegmentID,
          segment_ids_is_allowed:
            this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY,
          targeting_device_ids_is_allowed:
            this.state.TargetingDevicesIsAllowed !== EAllowStatus.DENY,
          targeting_device_types_is_allowed:
            this.state.TargetingDeviceTypesIsAllowed !== EAllowStatus.DENY,
          targeting_device_subtypes_is_allowed:
            this.state.TargetingDeviceSubTypesIsAllowed !== EAllowStatus.DENY,
          app_bundle_ids_is_allowed: this.state.TargetingAppBundleIDIsAllowed !== EAllowStatus.DENY,
          content_ids_is_allowed: this.state.TargetingContentIDIsAllowed !== EAllowStatus.DENY,
          content_networks_is_allowed:
            this.state.TargetingContentNetworkIsAllowed !== EAllowStatus.DENY,
          content_channels_is_allowed:
            this.state.TargetingContentChannelIsAllowed !== EAllowStatus.DENY,
          content_genres_is_allowed:
            this.state.TargetingContentGenreIsAllowed !== EAllowStatus.DENY,
          content_titles_is_allowed:
            this.state.TargetingContentTitleIsAllowed !== EAllowStatus.DENY,
          targeting_site_pages_is_allowed:
            this.state.TargetingSitePagesIsAllowed !== EAllowStatus.DENY,
          local_targeting_allowed_logic: this.state.LocalTargetingAllowedLogic,
          app_bundle_ids_site_pages_logic: this.state.TargetingAppBundleSitePagesLogic,
        },
        trackedForecastParams,
      );
    };

    trackEvent = (eventTitle: CampaignForecastEventTypes, meta: { [key: string]: any }): void => {
      const is_super_user = hasRoleSuperUser(this.props.user.user);
      track(
        eventTitle,
        Object.assign(
          {
            is_super_user,
            campaign: `${this.state.ID}_${this.state.Name}`,
          },
          meta,
        ),
        this.props.user.user,
      );
    };

    checkForecast = () => {
      const doesInvalidFrequencyTTLExistOnActiveFCap =
        this.state.FrequencyCaps.filter(
          (frequencyCap) =>
            +frequencyCap.TimeToLive <= 0 && frequencyCap.Active === FrequencyCapActiveActive,
        ).length > 0;
      if (this.state.Sites.length === 0 && this.state.ChannelGroupIDS.length === 0) {
        this.setState({
          snackbarMessage: 'You must pick a site/app or channel group before checking your channel',
          snackbarError: true,
        });
        return;
      } else if (doesInvalidFrequencyTTLExistOnActiveFCap) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot check forecast. Frequency limit duration must be greater than 0',
        });
        return;
      } else if (!this.state.dateStart) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot check forecast. Flight Date Start not selected',
        });
        return;
      } else if (!this.state.dateEnd) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot check forecast. Flight Date End not selected',
        });
        return;
      }

      this.setState({
        forecast: {} as IForecast,
        checkingForecast: true,
        forecastRatio: 0,
        forecastGoal: 0,
        snackbarMessage: 'Running forecast. This may take up to 1 min...',
      });

      const trackedForecastParams = this.generateTrackingMeta();
      this.trackEvent('Line Item - Forecasting Tool', trackedForecastParams);
      createForecastUsageAnalytic(
        {
          UserID: this.props.user.user.ID,
          PublisherID: this.props.session.publisher.ID,
          ForecastEvent: ForecastEvent.Run,
          ForecastType: ForecastType.LineItem,
          ForecastTargetID: this.state.ID,
          ChannelIDs: trackedForecastParams.site_ids,
          ChannelGroupIDs: trackedForecastParams.channel_group_ids,
          StartDate: trackedForecastParams.start_date,
          EndDate: trackedForecastParams.end_date,

          // line item targeting that's supports a value
          Dayparting: trackedForecastParams.dayparting,
          TargetingLivestream: '' + trackedForecastParams.livestream,
          TargetingLimitedAdTracking: trackedForecastParams.lat,
          // TODO: uncomment when UI is fixed
          // https://jira.integralads.com/browse/CTV-8634
          // TargetingCCPA: trackedForecastParams['ccpa'],         // pbapi.GeneralTargetingCCPA
          // TargetingRequestedPodDurationMin: trackedForecastParams['requested_pod_duration_min'],
          // TargetingRequestedPodDurationMax: trackedForecastParams['requested_pod_duration_max'],

          // line item targeting that supports a list
          TargetingDevices: trackedForecastParams.targeting_device_ids,
          TargetingDeviceTypes: trackedForecastParams.targeting_device_types,
          TargetingDeviceSubTypes: trackedForecastParams.targeting_device_subtypes,
          TargetingAppBundleIDs: trackedForecastParams.app_bundle_ids,
          TargetingContentChannels: trackedForecastParams.content_channels,
          // TargetingContentDistributors: trackedForecastParams['targeting_device_ids'],
          TargetingContentGenres: trackedForecastParams.content_genres,
          TargetingContentIDs: trackedForecastParams.content_ids,
          TargetingContentNetworks: trackedForecastParams.content_networks,
          // TargetingContentProducers: trackedForecastParams['targeting_device_ids'],
          // TargetingContentRatings: trackedForecastParams['targeting_device_ids'],
          // TargetingContentSeries: trackedForecastParams['targeting_device_ids'],
          TargetingContentTitles: trackedForecastParams.content_titles,
          TargetingSitePages: trackedForecastParams.targeting_site_pages,
          TargetingCountries: trackedForecastParams.countries,
          TargetingDmasAllowed: trackedForecastParams.dmas_allowed,
          TargetingZipsAllowed: trackedForecastParams.zips_allowed,
          TargetingCitiesAllowed: trackedForecastParams.cities_allowed,
          TargetingStatesAllowed: trackedForecastParams.states_allowed,
          TargetingDmasDisallowed: trackedForecastParams.dmas_disallowed,
          TargetingZipsDisallowed: trackedForecastParams.zips_disallowed,
          TargetingCitiesDisallowed: trackedForecastParams.cities_disallowed,
          TargetingStatesDisallowed: trackedForecastParams.states_disallowed,
        } as IForecastUsageAnalytic,
        this.props.session.publisher.ID,
      );

      checkForecastV2(
        this.generateForecastParams(trackedForecastParams),
        this.props.session.publisher.ID,
      )
        .then((forecast: IForecast) => {
          const quantity = parseInt(this.state.Quantity.replace(/,/g, ''), 10);
          let forecastRatio = 0;
          if (!isNaN(quantity) && quantity > 0) {
            forecastRatio = forecast.Forecast / quantity;
          }
          this.setState({
            forecast,
            checkingForecast: false,
            forecastRatio,
            forecastGoal: quantity,
            forecastNotes: forecast.Notes,
            forecastQuery: forecast.Query,
            snackbarMessage: '',
          });
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Error while retrieving forecast',
            snackbarError: true,
            checkingForecast: false,
          });
        });
    };

    scheduleReport = () => {
      const doesInvalidFrequencyTTLExistOnActiveFCap =
        this.state.FrequencyCaps.filter(
          (frequencyCap) =>
            +frequencyCap.TimeToLive <= 0 && frequencyCap.Active === FrequencyCapActiveActive,
        ).length > 0;
      if (this.state.Sites.length === 0 && this.state.ChannelGroupIDS.length === 0) {
        this.setState({
          snackbarMessage: 'You must pick a site/app or channel group before checking your channel',
          snackbarError: true,
        });
        return;
      } else if (doesInvalidFrequencyTTLExistOnActiveFCap) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot check forecast. Frequency limit duration must be greater than 0',
        });
        return;
      } else if (!this.state.dateStart) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot check forecast. Flight Date Start not selected',
        });
        return;
      } else if (!this.state.dateEnd) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot check forecast. Flight Date End not selected',
        });
        return;
      }

      this.setState({
        schedulingReport: true,
      });

      const trackedForecastParams = this.generateTrackingMeta();
      this.trackEvent('Line Item - Forecasting Email', trackedForecastParams);
      createForecastUsageAnalytic(
        {
          UserID: this.props.user.user.ID,
          PublisherID: this.props.session.publisher.ID,
          ForecastEvent: ForecastEvent.Email,
          ForecastType: ForecastType.LineItem,
          ForecastTargetID: this.state.ID,
          ChannelIDs: trackedForecastParams.site_ids,
          ChannelGroupIDs: trackedForecastParams.channel_group_ids,
          StartDate: trackedForecastParams.start_date,
          EndDate: trackedForecastParams.end_date,

          // line item targeting that's supports a value
          Dayparting: trackedForecastParams.dayparting,
          TargetingLivestream: '' + trackedForecastParams.livestream,
          TargetingLimitedAdTracking: trackedForecastParams.lat,
          // TODO: uncomment when UI is fixed
          // https://jira.integralads.com/browse/CTV-8634
          // TargetingCCPA: trackedForecastParams['ccpa'],         // pbapi.GeneralTargetingCCPA
          // TargetingRequestedPodDurationMin: trackedForecastParams['requested_pod_duration_min'],
          // TargetingRequestedPodDurationMax: trackedForecastParams['requested_pod_duration_max'],

          // line item targeting that supports a list
          TargetingDevices: trackedForecastParams.targeting_device_ids,
          TargetingDeviceTypes: trackedForecastParams.targeting_device_types,
          TargetingDeviceSubTypes: trackedForecastParams.targeting_device_subtypes,
          TargetingAppBundleIDs: trackedForecastParams.app_bundle_ids,
          TargetingContentChannels: trackedForecastParams.content_channels,
          // TargetingContentDistributors: trackedForecastParams['targeting_device_ids'],
          TargetingContentGenres: trackedForecastParams.content_genres,
          TargetingContentIDs: trackedForecastParams.content_ids,
          TargetingContentNetworks: trackedForecastParams.content_networks,
          // TargetingContentProducers: trackedForecastParams['targeting_device_ids'],
          // TargetingContentRatings: trackedForecastParams['targeting_device_ids'],
          // TargetingContentSeries: trackedForecastParams['targeting_device_ids'],
          TargetingContentTitles: trackedForecastParams.content_titles,
          TargetingSitePages: trackedForecastParams.targeting_site_pages,
          TargetingCountries: trackedForecastParams.countries,
          TargetingDmasAllowed: trackedForecastParams.dmas_allowed,
          TargetingZipsAllowed: trackedForecastParams.zips_allowed,
          TargetingCitiesAllowed: trackedForecastParams.cities_allowed,
          TargetingStatesAllowed: trackedForecastParams.states_allowed,
          TargetingDmasDisallowed: trackedForecastParams.dmas_disallowed,
          TargetingZipsDisallowed: trackedForecastParams.zips_disallowed,
          TargetingCitiesDisallowed: trackedForecastParams.cities_disallowed,
          TargetingStatesDisallowed: trackedForecastParams.states_disallowed,
        } as IForecastUsageAnalytic,
        this.props.session.publisher.ID,
      );

      scheduleCampaignForecastV2(
        this.generateForecastParams(trackedForecastParams),
        this.props.session.publisher.ID,
      )
        .then((json: any) => {
          this.setState({
            schedulingReport: false,
            snackbarMessage: json.message,
            snackbarError: !json.success,
          });
        })
        .catch(() => {
          this.setState({
            snackbarMessage: 'Error while retrieving forecast',
            snackbarError: true,
            checkingForecast: false,
          });
        });

      // set schedulingReport as false, if we did not receive response in 5 seconds(which means system is querying data)
      setTimeout(() => {
        if (this.state.schedulingReport) {
          this.setState({
            schedulingReport: false,
            snackbarMessage:
              'Successfully sent line item forecast data request to server. An email will be sent to your email when the data is ready.',
          });
        }
      }, 5000);
    };

    addNewTracker = () => {
      this.setState({
        AdserverCampaignTrackers: update(this.state.AdserverCampaignTrackers, {
          $push: [
            {
              Active: CampaignTrackerActiveActive,
              URL: '',
              Type: '',
            } as IAdserverCampaignTracker,
          ],
        }),
      });
    };

    removeTracker = (idx: number) => {
      this.setState({
        AdserverCampaignTrackers: update(this.state.AdserverCampaignTrackers, {
          $splice: [[idx, 1]],
        }),
      });
    };

    trackerChangeHelper = (idx: number, overwrite: { [key: string]: string | number }) => {
      const trackers = this.state.AdserverCampaignTrackers;
      this.setState({
        AdserverCampaignTrackers: update(trackers, {
          $splice: [
            [
              idx,
              1,
              update(trackers[idx], {
                $merge: overwrite,
              }),
            ],
          ],
        }),
      });
    };

    handleChangeTracker = (target: Partial<EventTarget & HTMLInputElement>, idx: number) => {
      let value = target.value as string;
      if (target.name === 'Active') {
        value =
          value === CampaignTrackerActiveActive
            ? CampaignTrackerActiveInactive
            : CampaignTrackerActiveActive;
      }

      const name: string = target.name as string;

      this.trackerChangeHelper(idx, {
        [name]: value,
      });
    };

    handleVastEditEnabled = (index: number, vast?: IAdserverGlobalVast) => {
      if (vast === undefined) {
        return;
      }
      if (index === -1) {
        // cancel button pressed
        this.setState({
          vastEditIndex: index,
          tempVastURL: vast.URL,
        });
      } else if (this.state.vastEditIndex === index && vast.URL === this.state.tempVastURL) {
        // no changes
        this.setState({
          vastEditIndex: -1,
          tempVastURL: vast.URL,
        });
      } else if (this.state.vastEditIndex === -1 || this.state.vastEditIndex !== index) {
        // no edit enabled or click on diff vast, enable editing on that index
        this.setState({
          vastEditIndex: index,
          tempVastURL: vast.URL,
        });
      } else if (this.state.vastEditIndex === index && vast.URL !== this.state.tempVastURL) {
        // saving vast and disable edit
        const tempVastURL = this.state.tempVastURL;
        if (tempVastURL.length === 0) {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'VAST must have a URL.',
          });
          return;
        } else if (isPBSDomain(tempVastURL)) {
          this.setState({
            snackbarError: true,
            snackbarMessage: `VAST cannot target a domain with that root.`,
          });
          return;
        }
        vast.URL = tempVastURL;
        this.setState(
          {
            vastEditIndex: -1,
            tempVastURL: '',
            updating: true,
          },
          () => {
            updateGlobalVast(vast, this.props.session.publisher.ID)
              .then(() => {
                const vasts = cloneDeep(this.state.vasts);
                vasts[index].URL = tempVastURL;
                this.setState({
                  updating: false,
                  vasts,
                  snackbarMessage: 'VAST URL successfully updated',
                });
              })
              .catch(() => {
                this.setState({
                  updating: false,
                  snackbarError: true,
                  snackbarMessage: 'VAST URL failed to update',
                });
              });
          },
        );
      }
    };

    renderTrackerManager = () => {
      const { classes } = this.props;
      const { AdserverCreatives } = this.state;
      const savedAdserverCreatives = AdserverCreatives.filter(
        (c: IAdserverCreative) => c.ID !== '',
      );

      return this.state.AdserverCampaignTrackers.map(
        (tracker: IAdserverCampaignTracker, idx: number) => {
          return (
            <div>
              <Grid
                container
                direction='column'
                justify='space-between'
                style={{
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  boxShadow: '0px 3px 6px #CBCBCB',
                  borderRadius: bigRadius,
                  opacity: '1',
                  paddingLeft: '2%',
                  paddingRight: '2%',
                  marginBottom: '25px',
                  minHeight: '50px',
                }}
              >
                <Grid container direction='row' justify='flex-start' alignItems='center'>
                  <Grid item xs={2}>
                    <p
                      style={{
                        textAlign: 'left',
                        fontWeight: 500,
                        letterSpacing: '0',
                        color: '#292F36',
                        paddingLeft: '2%',
                        fontSize: 'large',
                      }}
                    >
                      Tracker {idx + 1}
                    </p>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid container direction='row' justify='flex-start' alignItems='center'>
                      <p>Tracker Status:&nbsp;&nbsp;&nbsp;</p>
                      <p className={`pb-tracker-${idx}-tracker-status`}>
                        {tracker.Active === CampaignTrackerActiveActive ? 'Active' : 'Inactive'}
                      </p>
                      <Switch
                        disabled={!this.state.writeAuthorization.isAuthorized}
                        className={classes.centeredSwitch}
                        color='secondary'
                        checked={tracker.Active === CampaignTrackerActiveActive}
                        name='Active'
                        value={tracker.Active}
                        onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                          this.handleChangeTracker(target, idx);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={3}>
                    <Grid container direction='row' justify='flex-start' alignItems='center'>
                      <InputLabel
                        style={{
                          marginRight: '20px',
                        }}
                      >
                        Type
                      </InputLabel>

                      <Select
                        value={tracker.Type}
                        name='Type'
                        className={`pb-tracker-${idx}-type`}
                        onChange={(ev: React.ChangeEvent<{ name: string; value: string }>) => {
                          this.trackerChangeHelper(idx, {
                            [ev.target.name]: ev.target.value,
                          });
                        }}
                      >
                        {TrackerEventType.map((type) => {
                          return <MenuItem value={type.value}>{type.label}</MenuItem>;
                        })}
                      </Select>
                    </Grid>
                  </Grid>
                  {
                    // only allow user to select tracker for creatives that has already been saved in db
                    // when a line item is cloned, the creatives are not available to select in Applied To field of Tracker.
                    // Once a cloned line item is saved, creatives can be applied to Tracker.
                    <Grid item xs={3}>
                      <Tooltip
                        title={
                          savedAdserverCreatives.length > 0
                            ? ''
                            : 'Must save cloned line item before adding trackers'
                        }
                      >
                        <Grid container direction='row' justify='flex-start' alignItems='center'>
                          <InputLabel
                            style={{
                              marginRight: '20px',
                            }}
                          >
                            Applied to
                          </InputLabel>

                          <Select
                            value={tracker.CreativeID}
                            name='CreativeID'
                            className={`pb-tracker-${idx}-applied-to`}
                            style={{ width: '275px' }}
                            onChange={(ev: React.ChangeEvent<{ name: string; value: string }>) => {
                              this.trackerChangeHelper(idx, {
                                [ev.target.name]: parseInt(ev.target.value, 10),
                              });
                            }}
                          >
                            <MenuItem value={0}>Line Item Level</MenuItem>
                            {savedAdserverCreatives.map((c: IAdserverCreative) => {
                              return (
                                <MenuItem value={c.ID}>
                                  [{c.ID}] {c.Name}{' '}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </Grid>
                      </Tooltip>
                    </Grid>
                  }

                  <Grid item xs={1}>
                    <Grid container justify='flex-end' direction='row' alignItems='center'>
                      <Button
                        className={`pb-tracker-${idx}-delete-button`}
                        onClick={() => {
                          this.removeTracker(idx);
                        }}
                        disabled={!this.state.writeAuthorization.isAuthorized}
                      >
                        <DeleteIcon style={{ fill: deleteColor, cursor: 'pointer' }} />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container item direction='row' alignItems='center'>
                  <Grid item xs={1}>
                    <p>URL</p>
                  </Grid>
                  <Grid item xs={11}>
                    <div
                      style={{
                        background: 'aliceblue',
                        borderRadius: smallRadius,
                        opacity: '1',
                        marginBottom: '5px',
                        paddingLeft: '10px',
                        paddingRight: '10px',
                        width: 'inherit',
                      }}
                    >
                      <Editor
                        value={tracker.URL}
                        className={`pb-tracker-${idx}-url`}
                        highlight={(code: any) => highlight(code, languages.elm, 'elm')}
                        padding={5}
                        onValueChange={(text: string) => {
                          this.handleChangeTracker({ value: text, name: 'URL' }, idx);
                        }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          );
        },
      );
    };

    hasPrimaryBanner = (creatives?: IAdserverCreative[]) => {
      return this.getBannerIndexOfMatchingRank(EBannerRank.Primary, creatives) !== -1;
    };

    hasSecondaryBanner = (creatives?: IAdserverCreative[]) => {
      return this.getBannerIndexOfMatchingRank(EBannerRank.Secondary, creatives) !== -1;
    };

    getBannerIndexOfMatchingRank = (
      bannerRank: EBannerRank,
      creatives?: IAdserverCreative[],
    ): number => {
      if (creatives === undefined) {
        creatives = this.state.AdserverCreatives;
      }
      for (const [i, c] of creatives.entries()) {
        if (c?.BannerRank === bannerRank) {
          return i;
        }
      }
      return -1;
    };

    // add a new list for this creative's global media / vast files, creatives start with the same start/end date as existing
    addNewCreative = (bannerRank: EBannerRank) => {
      const globalMediafileList = cloneDeep(this.state.globalMediafileList);
      const globalVastList = cloneDeep(this.state.globalVastList);

      if (this.areCurrentCreativesAssets()) {
        globalMediafileList[this.state.AdserverCreatives.length] = cloneDeep(
          this.state.blankMediaFileList,
        );
      } else {
        globalVastList[this.state.AdserverCreatives.length] = cloneDeep(this.state.blankVastList);
      }

      let StartDate = 'null';
      let EndDate = 'null';

      if (this.state.dateStart) {
        StartDate = formatDateWithOffsetToUTC(
          this.state.dateStart,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      }

      if (this.state.dateEnd) {
        EndDate = formatDateWithOffsetToUTC(
          this.state.dateEnd,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      }
      const newCreative = {
        ID: '0',
        UUID: '',
        CreatedAt: '',
        UpdatedAt: '',
        DeletedAt: '',
        StartDate,
        EndDate,
        Name: 'Creative ' + Date.now().toString(),
        Weight: '1',
        VAST: '',
        AdserverMediafiles: [],
        AdserverGlobalMediafileIDs: [],
        AdserverCampaignID: this.state.ID,
        _CreativeType: CreativeTypeVast,
        CreativeType:
          bannerRank === EBannerRank.NotBanner
            ? EAdserverCreativeType.Video
            : EAdserverCreativeType.Banner,
        BannerRank: bannerRank,
      } as IAdserverCreative;
      this.setState({
        AdserverCreatives: update(this.state.AdserverCreatives, {
          $push: [newCreative],
        }),
        globalMediafileList,
        globalVastList,
      });
    };

    removeCreative = (cidx: number) => {
      const { AdserverCreatives, globalMediafileList, globalVastList, CreativeType } = this.state;
      // remove from globalMediafileList to allow for proper mapping after creative removal
      if (CreativeType === CreativeTypeMediafile) {
        const globalMediafileListArr = Object.values(globalMediafileList);
        globalMediafileListArr.splice(cidx, 1);
        const newGlobalMediafileList: ICampaignCreativeList = {};
        for (let idx = 0; idx < globalMediafileListArr.length; idx++) {
          newGlobalMediafileList[idx] = globalMediafileListArr[idx];
        }
        this.setState({
          globalMediafileList: newGlobalMediafileList,
        });
        // remove from globalVastList to allow for proper mapping after creative removal
      } else if (CreativeType === CreativeTypeVast) {
        const globalVastListArr = Object.values(globalVastList);
        globalVastListArr.splice(cidx, 1);
        const newGlobalVastList: ICampaignCreativeList = {};
        for (let idx = 0; idx < globalVastListArr.length; idx++) {
          newGlobalVastList[idx] = globalVastListArr[idx];
        }
        this.setState({
          globalVastList: newGlobalVastList,
        });
      }
      const rank = AdserverCreatives[cidx]?.BannerRank;
      if (rank === EBannerRank.Primary) {
        this.setState({
          isCreatingPrimaryBanner: false,
          AdserverCreatives: update(AdserverCreatives, {
            $splice: [[cidx, 1]],
          }),
        });
      } else if (rank === EBannerRank.Secondary) {
        this.setState({
          isCreatingSecondaryBanner: false,
          AdserverCreatives: update(AdserverCreatives, {
            $splice: [[cidx, 1]],
          }),
        });
      } else {
        this.setState({
          AdserverCreatives: update(AdserverCreatives, {
            $splice: [[cidx, 1]],
          }),
        });
      }
    };

    removeGlobalMediafile = (creativeIdx: number, mediafileID: string) => {
      const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
      for (let i = 0; i < AdserverCreatives.length; i++) {
        if (i === creativeIdx) {
          // remove the chosen id
          AdserverCreatives[i].AdserverGlobalMediafileIDs = AdserverCreatives[
            i
          ].AdserverGlobalMediafileIDs.filter((id: string) => mediafileID !== id);
          break;
        }
      }
      // also update the dropdown
      const globalMediafileList = cloneDeep(this.state.globalMediafileList);
      for (const item of Object.values(globalMediafileList[creativeIdx])) {
        if (item.ID === mediafileID) {
          item.selected = false;
        }
      }
      this.setState({
        AdserverCreatives,
        globalMediafileList,
      });
    };

    // Top bar delete
    handleDelete = (): void => {
      this.setState(
        {
          updating: true,
        },
        () => {
          // if this is a new campaign or cloned campaign, navigate to list
          if (!isExistingCampaign(this.state)) {
            this.goToOrderListView();
          } else {
            deleteCampaign({
              query: {
                publisher_id: this.props.session.publisher.ID,
                campaign_id: this.state.ID,
              },
            })
              .then(() => {
                this.goToOrderListView();
              })
              .catch((err: any) => {
                console.error(err);
                this.setState({
                  updating: false,
                  snackbarMessage: 'Error while deleting line item.',
                  snackbarError: true,
                });
              });
          }
        },
      );
    };

    // checks if start date is before end date, converts the moment from the component to a string
    handleCreativeDateChange = ({ start, end }: IDateRangeChangeEvent, index: number) => {
      if (start && end && start.isAfter(end) && end.year() !== 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Creative start date must be before creative end date.',
        });
        return;
      }
      const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
      if (start !== undefined) {
        AdserverCreatives[index].StartDate = formatDateWithOffsetToUTC(
          start,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      } else {
        AdserverCreatives[index].StartDate = 'null';
      }
      if (end !== undefined) {
        AdserverCreatives[index].EndDate = formatDateWithOffsetToUTC(
          end,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      } else {
        AdserverCreatives[index].EndDate = 'null';
      }
      this.setState({
        AdserverCreatives,
      });
    };

    // clears the creative's start and end dates
    clearCreativeDates = (index: number) => {
      const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
      AdserverCreatives[index].StartDate = 'null';
      AdserverCreatives[index].EndDate = 'null';
      this.setState({
        AdserverCreatives,
      });
    };

    uploadMediafile = (
      { target }: React.ChangeEvent<HTMLInputElement>,
      cidx: number,
      idx: number, // length of GlobalMediaFiles
      isBanner?: boolean,
      sgidx?: number, // is EnableFlightDateSubgroups is true, then we need the subgroup index for AdserverCreativeFlightDatesSubgroups.
    ) => {
      this.setState(
        {
          forceMenuButtonClosed: true,
          uploading: true,
        },
        () => {
          const isNewCampaign = !isExistingCampaign(this.state);
          // upload mediafile requires that new creatives have the line item's ID since the mediafile also
          // requires the creative's ID, so it is better if the line item is saved first
          if (isNewCampaign) {
            this.setState({
              snackbarMessage:
                'Please remove this creative and save the line item before uploading a new asset.',
              snackbarError: true,
              uploading: false,
            });
            return;
          }
          const creative =
            this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE && sgidx !== undefined
              ? this.state.AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives[cidx]
              : this.state.AdserverCreatives[cidx];

          // if the creative is new, we need to create a new creative first so we have a creative ID
          if (creative && creative.ID === '0') {
            createCreative({
              query: {
                publisher_id: this.props.session.publisher.ID,
                creative,
              },
            })
              .then((creative: IAdserverCreative) => {
                if (
                  this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE &&
                  sgidx !== undefined
                ) {
                  const AdserverCreatives = cloneDeep(
                    this.state.AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives,
                  );
                  AdserverCreatives[cidx].ID = creative.ID;
                  AdserverCreatives[cidx].UUID = creative.UUID;
                  AdserverCreatives[cidx].AdserverGlobalMediafileIDs = [];
                  const AdserverCreativeFlightDatesSubgroups = cloneDeep(
                    this.state.AdserverCreativeFlightDatesSubgroups,
                  );
                  if (
                    AdserverCreativeFlightDatesSubgroups &&
                    AdserverCreativeFlightDatesSubgroups[sgidx]
                  ) {
                    AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives =
                      AdserverCreatives;
                  }
                  this.setState(
                    {
                      AdserverCreativeFlightDatesSubgroups,
                    },
                    () => {
                      this.uploadGlobalMediafile(target, idx, creative.ID, isBanner, sgidx);
                    },
                  );
                } else {
                  const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
                  AdserverCreatives[cidx].ID = creative.ID;
                  AdserverCreatives[cidx].UUID = creative.UUID;
                  AdserverCreatives[cidx].AdserverGlobalMediafileIDs = [];
                  this.setState(
                    {
                      AdserverCreatives,
                    },
                    () => {
                      this.uploadGlobalMediafile(target, idx, creative.ID, isBanner, sgidx);
                    },
                  );
                }
              })
              .catch(() => {
                this.setState({
                  snackbarError: true,
                  snackbarMessage: 'Error creating new creative for mediafile upload.',
                  uploading: false,
                });
              });
            return;
          }
          this.uploadGlobalMediafile(target, idx, creative.ID, isBanner, sgidx);
        },
      );
    };

    uploadGlobalMediafile = (
      target: EventTarget & HTMLInputElement,
      idx: number,
      creativeID: string,
      isBanner?: boolean,
      sgidx?: number, // is EnableFlightDateSubgroups is true, then we need the subgroup index for AdserverCreativeFlightDatesSubgroups.
    ) => {
      let creative;
      let cidx = -1;
      const AdserverCreatives =
        this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE && sgidx !== undefined
          ? cloneDeep(this.state.AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives)
          : cloneDeep(this.state.AdserverCreatives);
      for (let i = 0; i < AdserverCreatives.length; i++) {
        const c = AdserverCreatives[i];
        if (c.ID === creativeID) {
          cidx = i;
          creative = c;
          break;
        }
      }

      if (creative === undefined || cidx === -1) {
        this.setState({
          snackbarMessage: 'Cannot find creative to upload mediafile.',
          snackbarError: true,
          uploading: false,
        });
        return;
      }
      if (target.files && target.files.length > 0) {
        const file = target.files[0];
        const filenameParams = file.name.split('.');
        const ext = filenameParams[filenameParams.length - 1];
        // determine if the file type is invalid
        if (isBanner === true) {
          if (!isValidBannerExtension(ext)) {
            this.setState({
              snackbarMessage: 'Only .gif, .jpg, and .png formats are supported.',
              snackbarError: true,
              uploading: false,
            });
            return;
          }
        } else if (!isValidVideoExtension(ext.toLowerCase())) {
          this.setState({
            snackbarMessage:
              'Currently the only supported mediafile format is .mp4 and .mov. If another mediafile is required, please send your request to ' +
              getContactEmail() +
              '.',
            snackbarError: true,
            uploading: false,
          });
          return;
        }
        target.value = '';
        const uploadKey = this.uploadManager.addUpload(file.name);
        this.uploadKeyToIdx.set(uploadKey, {
          idx,
          cidx,
        });
        // upload the mediafile, passing the creative_id which will create a creative => mediafile association
        let uploadFilePromise;
        if (isBanner) {
          uploadFilePromise = uploadGlobalBanner({
            publisher_id: this.props.session.publisher.ID,
            global_mediafile: 'true',
            creative_id: creative ? creative.ID.toString() : '',
            resolutions: this.state.selectedResolutions.join(','),
            name: filenameParams[0],
            file,
            managerFunc: (xhr: XMLHttpRequest) => {
              this.uploadManager.addListenersToUpload(uploadKey, xhr);
            },
          });
        } else {
          uploadFilePromise = uploadGlobalMediafile({
            publisher_id: this.props.session.publisher.ID,
            global_mediafile: 'true',
            creative_id: creative ? creative.ID.toString() : '',
            resolutions: this.state.selectedResolutions.join(','),
            name: filenameParams[0],
            file,
            managerFunc: (xhr: XMLHttpRequest) => {
              this.uploadManager.addListenersToUpload(uploadKey, xhr);
            },
          });
        }

        uploadFilePromise
          .then((json: any) => {
            // if the response is good, iterate over the mediafiles and add the mf IDs to creative.AdserverGlobalMediafileIDs
            // and signal success for snackbar
            if (json.status === 200 && json.response && json.response.MediaList) {
              const MediaList = json.response.MediaList;
              if (
                this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE &&
                sgidx !== undefined
              ) {
                const AdserverCreatives = cloneDeep(
                  this.state.AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives,
                );
                for (let i = 0; i < MediaList.length; i++) {
                  if (MediaList[i]) {
                    AdserverCreatives[cidx].AdserverGlobalMediafileIDs.push(
                      MediaList[i].ID.toString(),
                    );
                  }
                }
                this.uploadManager.signalSuccess(uploadKey);

                const AdserverCreativeFlightDatesSubgroups = cloneDeep(
                  this.state.AdserverCreativeFlightDatesSubgroups,
                );
                if (
                  AdserverCreativeFlightDatesSubgroups &&
                  AdserverCreativeFlightDatesSubgroups[sgidx]
                ) {
                  AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives = AdserverCreatives;
                }
                this.setState(
                  {
                    AdserverCreativeFlightDatesSubgroups,
                    uploading: false,
                  },
                  this.fetchGlobalMediaFilesAndVasts,
                );
              } else {
                const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
                for (let i = 0; i < MediaList.length; i++) {
                  if (MediaList[i]) {
                    AdserverCreatives[cidx].AdserverGlobalMediafileIDs.push(
                      MediaList[i].ID.toString(),
                    );
                  }
                }
                this.uploadManager.signalSuccess(uploadKey);

                this.setState(
                  {
                    AdserverCreatives,
                    uploading: false,
                  },
                  this.fetchGlobalMediaFilesAndVasts,
                );
              }
            } else {
              this.uploadManager.signalFailure(uploadKey, json.response.error);
              this.setState({
                uploading: false,
              });
            }
          })
          .catch(() => {
            this.setState({
              uploading: false,
            });
            this.uploadManager.signalFailure(uploadKey);
          });
      }
    };

    renderMenuTitle = (inMenu: boolean, disabled: boolean) => {
      return (
        <Grid item>
          <Grid container direction='row' alignItems='center' spacing={2}>
            <Grid item>
              <AddIcon
                style={{
                  marginTop: 5,
                  color: inMenu ? 'grey' : disabled ? 'lightgrey' : 'black',
                }}
              />
            </Grid>
            <Grid item>
              <Typography
                className={
                  inMenu ? this.props.classes.menuButtonTextGrey : this.props.classes.menuButtonText
                }
              >
                ADD NEW ASSET
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderUploadBannerRow = (
      cidx: number,
      GlobalMediaFiles: IAdserverGlobalMediafile[],
      sgidx?: number, // is EnableFlightDateSubgroups is true, then we need the subgroup index for AdserverCreativeFlightDatesSubgroups.
    ) => {
      return (
        <Button component='label'>
          <Cols
            style={{
              justifyContent: 'space-between',
              alignItems: 'center',
              minWidth: '128px',
              maxHeight: '16px',
              marginLeft: '-24px',
            }}
          >
            <Col horizontalPadding>
              <PhotoLibraryIcon
                style={{
                  color: `${publicaColors.blue}`,
                }}
              />
            </Col>
            <Col>
              <Text
                style={{
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  marginBottom: '5px',
                  color: publicaColors.blue,
                }}
              >
                DIRECT UPLOAD BANNER
              </Text>
            </Col>
          </Cols>
          <input
            type='file'
            style={{ display: 'none' }}
            onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
              this.uploadMediafile(evt, cidx, GlobalMediaFiles.length, true, sgidx);
            }}
          />
        </Button>
      );
    };

    renderUploadRow = (
      cidx: number,
      GlobalMediaFiles: IAdserverGlobalMediafile[],
      sgidx?: number, // is EnableFlightDateSubgroups is true, then we need the subgroup index for AdserverCreativeFlightDatesSubgroups.
    ) => {
      return (
        <Grid container direction='column'>
          <Grid item>
            <Grid container direction='row' alignItems='center'>
              <Grid item>
                <Tooltip
                  title={
                    GlobalMediaFiles.length === 0
                      ? 'Upload a .mp4 mediafile and assign it to this creative'
                      : 'Only one asset may be assigned to each creative'
                  }
                >
                  <label>
                    <Grid
                      container
                      direction='row'
                      alignItems='center'
                      spacing={2}
                      style={{ cursor: 'pointer' }}
                    >
                      <Grid item>
                        <BackupIcon style={{ color: '#4952FF' }} />
                      </Grid>
                      <Grid item>
                        <Typography className={this.props.classes.menuButtonTextBlue}>
                          UPLOAD MEDIAFILE
                        </Typography>
                      </Grid>
                    </Grid>
                    <input
                      type='file'
                      style={{ display: 'none', marginLeft: '20px' }}
                      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                        this.uploadMediafile(evt, cidx, GlobalMediaFiles.length, undefined, sgidx);
                      }}
                    />
                  </label>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          {ResolutionTypes.length > 0 && (
            <Grid item>
              <CategoryMultiSelect
                key={`${cidx}-selectedResolutions`}
                helperText='Select variant resolutions to be created'
                name='selectedResolutions'
                disabled={!this.state.writeAuthorization.isAuthorized}
                items={ResolutionTypes}
                onChange={this.handleChangeSelect}
                values={this.state.selectedResolutions}
                style={{ width: 225, zIndex: 999 }}
                textfieldClass={this.props.classes.insideAccordionTextfield}
                selectFontSize={14}
                disableClear={true}
              />
            </Grid>
          )}
        </Grid>
      );
    };

    renderCreateFromAssetURLRow = (
      cidx: number,
      GlobalMediaFiles: IAdserverGlobalMediafile[],
      sgidx?: number, // is EnableFlightDateSubgroups is true, then we need the subgroup index for AdserverCreativeFlightDatesSubgroups.
    ) => {
      const disabled = !this.state.writeAuthorization.isAuthorized || GlobalMediaFiles.length >= 1;
      return (
        <Grid item>
          <Grid item>
            <Tooltip
              title={
                GlobalMediaFiles.length === 0
                  ? 'Create an asset from a link to a .mp4 mediafile'
                  : 'Only one asset may be assigned to each creative'
              }
            >
              <span>
                <Button
                  disabled={disabled}
                  component='label'
                  style={{
                    marginLeft: -8,
                    color: getColorTheme('primaryButtons'), // Color for upload button of Campaign Settings
                    maxHeight: '16px',
                  }}
                  onClick={() => {
                    if (!disabled) {
                      this.handleOpenCreateModal(cidx, sgidx);
                    }
                  }}
                >
                  <Grid container direction='row' alignItems='center' spacing={2}>
                    <Grid item>
                      <NoteAddIcon
                        style={{
                          color: `${publicaColors.blue}`,
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography className={this.props.classes.menuButtonTextBlue}>
                        ADD EXT HOSTED FILE
                      </Typography>
                    </Grid>
                  </Grid>
                </Button>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      );
    };

    handleCreateBannerFromURL = () => {
      const { newCreateBannerName, newCreateBannerURL, BannerAdvertiserID } = this.state;
      const uploadValidationResult = shouldRejectBannerUpload(
        newCreateBannerName,
        newCreateBannerURL,
      );
      if (!uploadValidationResult.rejected) {
        this.setState(
          {
            updating: true,
          },
          () => {
            createMediafileFromURL({
              query: {
                publisher_id: this.props.session.publisher.ID,
                name: newCreateBannerName,
                url: newCreateBannerURL,
                advertiser_id: BannerAdvertiserID,
              },
            })
              .then(() => {
                this.fetchGlobalMediaFilesAndVasts();
                this.setState({
                  updating: false,
                  openCreateBannerDialog: false,
                  snackbarMessage: 'Successfully created banner asset from URL',
                });
              })
              .catch((resp) => {
                this.setState({
                  updating: false,
                  openCreateBannerDialog: false,
                  snackbarMessage: `Failed to create banner asset from URL: ${resp}`,
                  snackbarError: true,
                });
              });
          },
        );
      } else {
        this.setState({
          snackbarError: true,
          snackbarMessage: uploadValidationResult.reason,
        });
      }
    };

    renderCreateBannerFromAssetURLRow = () => {
      return CreateBannerFromAssetURLRow(this.handleOpenCreateBannerModal);
    };

    renderMediafileMenuButton = (cidx: number, GlobalMediaFiles: IAdserverGlobalMediafile[]) => {
      const disabled = !this.state.writeAuthorization.isAuthorized || GlobalMediaFiles.length >= 1;
      const menuRow = {
        closeOnClick: true,
        render: () => this.renderMenuTitle(true, disabled),
      };
      const createFromAssetURLRow = {
        closeOnClick: true,
        render: () => this.renderCreateFromAssetURLRow(cidx, GlobalMediaFiles),
      };
      const bannerFromAssetURLRow = {
        closeOnClick: true,
        render: this.renderCreateBannerFromAssetURLRow,
      };
      const uploadRow = {
        closeOnClick: false,
        render: () => this.renderUploadRow(cidx, GlobalMediaFiles),
      };
      const uploadBannerRow = {
        closeOnClick: false,
        render: () => this.renderUploadBannerRow(cidx, GlobalMediaFiles),
      };
      const menuButtonItems = [menuRow];

      if (this.isNativeVastAuthorized) {
        menuButtonItems.push(bannerFromAssetURLRow, uploadBannerRow);
      }
      menuButtonItems.push(createFromAssetURLRow, uploadRow);
      return (
        <Grid
          onClick={() => {
            this.setState({
              forceMenuButtonClosed: false,
            });
          }}
        >
          <MenuButton
            forceClosed={this.state.forceMenuButtonClosed}
            disabled={disabled}
            disabledMsg='Only one asset may be assigned to each creative. Remove the current asset if you want to add a new asset.'
            titleRender={() => this.renderMenuTitle(false, disabled)}
            items={menuButtonItems}
            minWidth={250}
            enableGreyFirstItem={true}
            enableDividers={true}
          />
        </Grid>
      );
    };

    renderExistingAssetRow = (c: IAdserverCreative, cidx: number, isBanner: boolean) => {
      const { user } = this.props;
      const mediaFileOptions: ISelectOption[] = Object.values(this.state.blankMediaFileList)
        .filter((file) =>
          isBanner
            ? isValidBannerMimetype(file.mimeType ?? '')
            : isValidVideoMimetype(file.mimeType ?? ''),
        )
        .map((file) => ({
          id: file.ID,
          label: isDemoAccount(user.user.Username)
            ? obfuscateCampaignCreative(file.ID)
            : file.title,
        }));

      return (
        <Grid item>
          <Grid container direction='row' alignItems='center' spacing={2}>
            <Grid item xs={2}>
              <Typography className={this.props.classes.menuButtonText}>
                LINK EXISTING ASSET
              </Typography>
            </Grid>
            <Grid item xs={8}>
              {this.state.isLoadingMediaFilesAndVasts ? (
                <Skeleton
                  variant='rect'
                  animation='wave'
                  width={480}
                  height={28}
                  style={{ borderRadius: borderRadius.base }}
                />
              ) : (
                <IndependentSelect
                  key={c.ID}
                  enableLabelTooltip
                  isDisabled={!this.state.writeAuthorization.isAuthorized}
                  handleApplySelect={(ids: Set<string>) =>
                    this.handleMediaOnClickV2(cidx, [...ids])
                  }
                  selectedLimit={1}
                  listLabel='Assets'
                  options={mediaFileOptions}
                  placeholder='Select Existing Asset'
                  selectedOptionIDs={new Set(c.AdserverGlobalMediafileIDs)}
                  singularLabel='Asset'
                  maxWidth={480}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderVast = (c: IAdserverCreative, cidx: number) => {
      const { classes, user } = this.props;
      const vastEditEnabled = this.state.vastEditIndex === cidx;
      const vast = this.state.vasts.find(
        (v: IAdserverGlobalVast) => v.ID === c.AdserverGlobalVastID,
      );
      const vastOptions: ISelectOption[] = Object.values(this.state.blankVastList).map((vast) => ({
        id: vast.ID,
        label: isDemoAccount(user.user.Username) ? obfuscateCampaignVast(vast.ID) : vast.title,
      }));

      return (
        <Grid container direction='column'>
          {/* vast selector */}
          <Grid item className={classes.creativeRow}>
            <Grid container alignItems='center' spacing={2} style={{ marginBottom: 10 }}>
              <Grid item xs={2}>
                <Text small bold>
                  Select Existing Vast
                </Text>
              </Grid>
              <Grid item xs={8}>
                {this.state.isLoadingMediaFilesAndVasts ? (
                  <Skeleton
                    variant='rect'
                    animation='wave'
                    width={480}
                    height={28}
                    style={{ borderRadius: borderRadius.base }}
                  />
                ) : (
                  <IndependentSelect
                    key={c.ID}
                    enableLabelTooltip
                    isDisabled={!this.state.writeAuthorization.isAuthorized}
                    handleApplySelect={(ids: Set<string>) =>
                      this.handleMediaOnClickV2(cidx, [...ids])
                    }
                    selectedLimit={1}
                    listLabel='Vasts'
                    options={vastOptions}
                    placeholder='Select Existing Vast'
                    selectedOptionIDs={
                      c.AdserverGlobalVastID ? new Set([c.AdserverGlobalVastID]) : new Set()
                    }
                    singularLabel='Vast'
                    maxWidth={480}
                  />
                )}
              </Grid>
            </Grid>
            {vast && (
              <Grid container alignItems='center' spacing={2}>
                <Grid item xs={2}>
                  {vastEditEnabled ? (
                    <Grid container direction='row' alignItems='center' justify='flex-start'>
                      <Grid item>
                        <ModelSecondaryButton
                          onClick={() => this.handleVastEditEnabled(cidx, vast)}
                        >
                          SAVE
                        </ModelSecondaryButton>
                      </Grid>
                      <Grid item>
                        <ModelSecondaryButton onClick={() => this.handleVastEditEnabled(-1, vast)}>
                          CANCEL
                        </ModelSecondaryButton>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid container direction='row' alignItems='center' justify='flex-start'>
                      <Grid item>
                        <ModelSecondaryButton
                          onClick={() => this.handleVastEditEnabled(cidx, vast)}
                        >
                          EDIT VAST URL
                        </ModelSecondaryButton>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Textarea
                    key={this.state.reactKey}
                    msDelay={800}
                    isDisabled={!vastEditEnabled}
                    initialValue={vastEditEnabled ? this.state.tempVastURL : vast ? vast.URL : ''}
                    handleOnChange={(value: string) => {
                      this.setState({ tempVastURL: value });
                    }}
                    style={{ minWidth: '480px' }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
          {/* add vast */}
          <Grid item className={classes.creativeRow} style={{ marginBottom: 10 }}>
            <Grid container direction='row' alignItems='center' spacing={2}>
              <Grid item>
                <AddIcon
                  style={{
                    marginTop: 5,
                    color: 'black',
                  }}
                />
              </Grid>
              <Grid item onClick={() => this.handleOpenCreateModal(cidx)}>
                <Typography
                  className={this.props.classes.menuButtonText}
                  style={{ cursor: 'pointer' }}
                >
                  ADD NEW VAST
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderMediafiles = (c: IAdserverCreative, cidx: number, isBanner: boolean) => {
      // get the global media files
      let { AdserverGlobalMediafileIDs } = this.state.AdserverCreatives[cidx];
      const GlobalMediaFiles = [] as IAdserverGlobalMediafile[];
      AdserverGlobalMediafileIDs = AdserverGlobalMediafileIDs || [];

      let gmfIdx = -1;
      for (const id of AdserverGlobalMediafileIDs) {
        for (let idx = 0; idx < this.state.GlobalMediaFiles.length; idx++) {
          const mediaFile = this.state.GlobalMediaFiles[idx];
          if (mediaFile.ID === id) {
            gmfIdx = idx;
            GlobalMediaFiles.push(mediaFile);
          }
        }
      }

      return (
        <Grid
          container
          spacing={2}
          direction='column'
          style={{
            width: '100%',
            paddingBottom: 10,
          }}
        >
          <Grid item style={{ marginLeft: -8 }}>
            {this.renderMediafileMenuButton(cidx, GlobalMediaFiles)}
          </Grid>
          <Grid item>{this.renderExistingAssetRow(c, cidx, isBanner)}</Grid>
          {/* asset / variant table */}
          {GlobalMediaFiles.length > 0 && (
            <Grid item>
              <Table>
                <TableHead
                  style={{
                    backgroundColor: publicaColors.white,
                  }}
                >
                  <TableRow>
                    {hasRoleSuperUser(this.props.user.user) && (
                      <TableCell
                        align='right'
                        padding='none'
                        style={{
                          textAlign: 'center',
                        }}
                      >
                        ID *
                      </TableCell>
                    )}
                    <TableCell
                      padding='none'
                      style={{
                        color: publicaColors.gray,
                      }}
                    >
                      Asset Name
                    </TableCell>
                    <TableCell
                      align='right'
                      style={{
                        color: publicaColors.gray,
                        textAlign: 'center',
                      }}
                      padding='none'
                    >
                      URL
                    </TableCell>
                    <TableCell
                      align='right'
                      style={{
                        color: publicaColors.gray,
                        textAlign: 'center',
                      }}
                      padding='none'
                    >
                      Bitrate (kbps)
                    </TableCell>
                    <TableCell
                      align='right'
                      style={{
                        color: publicaColors.gray,
                        textAlign: 'center',
                      }}
                      padding='none'
                    >
                      Duration (secs)
                    </TableCell>
                    <TableCell
                      align='right'
                      style={{
                        color: publicaColors.gray,
                        textAlign: 'center',
                      }}
                      padding='none'
                    >
                      Resolution
                    </TableCell>
                    <TableCell
                      padding='none'
                      style={{
                        textAlign: 'center',
                        color: publicaColors.gray,
                      }}
                      align='right'
                    >
                      Remove / Active
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    // Global mediafile
                    GlobalMediaFiles.map((mediafile: IAdserverGlobalMediafile) => {
                      // shorten the URL and shorten the bit rate to make it more readable
                      const Duration = mediafile.Duration;
                      let Bitrate = mediafile.Bitrate.toString();
                      const bitRateNum = parseInt(mediafile.Bitrate, 10) || 0;
                      if (bitRateNum > 10000) {
                        Bitrate = Math.floor(bitRateNum / 1000) + ' kbps';
                      }
                      // truncate the name and url if the value is too long
                      const mediafileName = obfuscateGlobalMediafile(
                        mediafile,
                        this.props.user.user.Username,
                        '',
                        mediafile.Name,
                      );
                      const truncatedMediafileName =
                        mediafileName.length <= 30
                          ? mediafileName
                          : mediafileName.slice(0, 30) + '...';
                      const mediafileURL = obfuscateGlobalMediafile(
                        mediafile,
                        this.props.user.user.Username,
                        'url',
                        mediafile.URL,
                      );
                      const truncatedMediafileURL =
                        mediafileURL.length <= 30
                          ? mediafileURL
                          : mediafileURL.slice(0, 30) + '...';
                      return (
                        <TableRow>
                          {/* ID (Super user only) */}
                          {hasRoleSuperUser(this.props.user.user) && (
                            <TableCell
                              style={{
                                textAlign: 'center',
                              }}
                              padding='none'
                              align='right'
                            >
                              <CopyButton
                                text={mediafile.ID ? mediafile.ID + ' *' : '*'}
                                copy={mediafile.ID || ''}
                              />
                            </TableCell>
                          )}
                          {/* Name Link */}
                          <TableCell padding='none'>
                            <Tooltip title={mediafileName}>
                              <a
                                href={mediafile.URL}
                                style={{
                                  color: 'black',
                                }}
                                target='_blank'
                              >
                                {truncatedMediafileName}
                              </a>
                            </Tooltip>
                          </TableCell>
                          {/* URL */}
                          <TableCell
                            padding='none'
                            align='right'
                            style={{
                              textAlign: 'center',
                            }}
                          >
                            <Tooltip title={mediafileURL}>
                              <Typography style={{ fontSize: 14 }}>
                                {truncatedMediafileURL}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                          {/* Bit Rate */}
                          <TableCell
                            padding='none'
                            align='right'
                            style={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography style={{ fontSize: 14 }}>{Bitrate}</Typography>
                          </TableCell>
                          {/* Duration */}
                          <TableCell
                            padding='none'
                            align='right'
                            style={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography style={{ fontSize: 14 }}>{Duration}</Typography>
                          </TableCell>
                          {/* Resolution */}
                          <TableCell
                            padding='none'
                            align='right'
                            style={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography style={{ fontSize: 14 }}>
                              {`${mediafile.Width} x ${mediafile.Height}`}
                            </Typography>
                          </TableCell>
                          {/* Remove asset from creative */}
                          <TableCell
                            style={{
                              textAlign: 'center',
                            }}
                            padding='none'
                            align='right'
                          >
                            <Button
                              disabled={!this.state.writeAuthorization.isAuthorized}
                              onClick={() => {
                                this.removeGlobalMediafile(cidx, mediafile.ID);
                              }}
                            >
                              <LinkOffIcon
                                style={{
                                  fill: deleteColor,
                                }}
                              />
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  }
                  {GlobalMediaFiles.length === 1 &&
                    // Variants
                    GlobalMediaFiles[0].VariantMediafiles.map(
                      (variant: IVariantMediafile, vIdx: number) => {
                        // shorten the URL and shorten the bit rate to make it more readable
                        let Bitrate = variant.Bitrate.toString();
                        const bitRateNum = variant.Bitrate;
                        if (bitRateNum > 10000) {
                          Bitrate = Math.floor(bitRateNum / 1000) + ' kbps';
                        }
                        // truncate the name and url if the value is too long
                        const variantName = obfuscateVariant(
                          variant,
                          this.props.user.user.Username,
                          '',
                          variant.Name,
                        );
                        const truncatedVariantName =
                          variantName.length <= 30 ? variantName : variantName.slice(0, 30) + '...';
                        const variantURL = obfuscateVariant(
                          variant,
                          this.props.user.user.Username,
                          'url',
                          variant.URL,
                        );
                        const truncatedVariantURL =
                          variantURL.length <= 30 ? variantURL : variantURL.slice(0, 30) + '...';
                        return (
                          <TableRow>
                            {/* ID (Super user only) */}
                            {hasRoleSuperUser(this.props.user.user) && (
                              <TableCell
                                style={{
                                  textAlign: 'center',
                                }}
                                padding='none'
                                align='right'
                              >
                                <CopyButton
                                  text={variant.ID.toString() ? variant.ID.toString() + ' *' : '*'}
                                  copy={variant.ID.toString() || ''}
                                />
                              </TableCell>
                            )}
                            {/* Name Link */}
                            <TableCell padding='none'>
                              <Tooltip title={variantName}>
                                <a
                                  href={variant.URL}
                                  style={{
                                    color: 'black',
                                  }}
                                  target='_blank'
                                >
                                  {truncatedVariantName}
                                </a>
                              </Tooltip>
                            </TableCell>
                            {/* URL */}
                            <TableCell
                              padding='none'
                              align='right'
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <Tooltip title={variantURL}>
                                <Typography
                                  style={{
                                    fontSize: 14,
                                  }}
                                >
                                  {truncatedVariantURL}
                                </Typography>
                              </Tooltip>
                            </TableCell>
                            {/* Bit Rate */}
                            <TableCell
                              padding='none'
                              align='right'
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography style={{ fontSize: 14 }}>{Bitrate}</Typography>
                            </TableCell>
                            {/* Duration */}
                            <TableCell
                              padding='none'
                              align='right'
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography style={{ fontSize: 14 }}>{variant.Duration}</Typography>
                            </TableCell>
                            {/* Resolution */}
                            <TableCell
                              padding='none'
                              align='right'
                              style={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography style={{ fontSize: 14 }}>
                                {`${variant.Width} x ${variant.Height}`}
                              </Typography>
                            </TableCell>
                            {/* Remove asset from creative */}
                            <TableCell
                              style={{
                                textAlign: 'center',
                              }}
                              padding='none'
                              align='center'
                            >
                              <Switch
                                disabled={!this.state.writeAuthorization.isAuthorized}
                                className={this.props.classes.switch}
                                checked={variant.Active === EBool.EBool_TRUE}
                                name='Active'
                                onChange={() => this.handleChangeVariantActive(vIdx, gmfIdx)}
                                color='secondary'
                              />
                            </TableCell>
                          </TableRow>
                        );
                      },
                    )}
                </TableBody>
              </Table>
            </Grid>
          )}
        </Grid>
      );
    };

    evenWeights = () => {
      const AdserverCreatives = this.state.AdserverCreatives;
      const nonBannerCreatives = AdserverCreatives.filter((c) => {
        return c?.CreativeType !== EAdserverCreativeType.Banner;
      });
      if (isEmpty(nonBannerCreatives)) {
        return;
      }

      const quotient = Math.floor(100 / nonBannerCreatives.length);
      let remainder = 100 % nonBannerCreatives.length;
      for (const creative of AdserverCreatives) {
        if (!isBannerType(creative)) {
          creative.Weight = (quotient + remainder).toString();
          remainder = 0;
        }
      }

      this.setState({
        AdserverCreatives,
        reactKey: this.state.reactKey + 1, // force TextInput components to update
      });
    };

    makeIABString(): string {
      return this.state.iabList
        .sort(sortIABCats)
        .map((list: IIncludeExcludeTableElement) => {
          return list.ID;
        })
        .join(',');
    }

    // gets the single IAB string entered by the user (via the IAB prefix and IAB suffix dropdowns)
    // ex: 'IAB1-2' or 'IAB1'
    getUserSingleIABString(): string {
      const userEntryIABPrefix = this.state.userEntryIABPrefix;
      const userEntryIABSuffix = this.state.userEntryIABSuffix;
      return (
        userEntryIABPrefix +
        (userEntryIABSuffix !== ''
          ? (userEntryIABSuffix !== '-' ? '-' : '') + userEntryIABSuffix
          : '')
      );
    }

    // adds the IAB user entry into the include/exclude table
    addIABUserEntry() {
      const userSingleIABString = this.getUserSingleIABString();

      const iabList = [...this.state.iabList];
      if (
        iabList.findIndex(
          (elem: IIncludeExcludeTableElement) => elem.ID === userSingleIABString,
        ) !== -1
      ) {
        // user single entry already exists in the table → error
        this.setState({
          snackbarError: true,
          snackbarMessage: `The IAB category ${userSingleIABString} already exists in the list.`,
          userEntryIABPrefix: '',
          userEntryIABSuffix: '',
        });
        return;
      }

      // insert user single entry
      let iabs: string[] = [userSingleIABString];
      // get user comma separated IAB list
      iabs = iabs.concat(
        this.state.userEntryIABList
          .toUpperCase()
          .split(',')
          .map((s: string) => s.trim()),
      );

      // remove bad strings from array
      iabs = iabs.filter((s: string) => iabRegexp.test(s));
      iabs.forEach((iab: string) => {
        if (iabList.findIndex((elem: IIncludeExcludeTableElement) => elem.ID === iab) === -1) {
          // if iab don't exist if, add it
          iabList.push({
            ID: iab,
            included: true,
            name: IABCategoryCodeToName(iab),
            title: iab,
          });
        }
      });
      // sort list
      iabList.sort(sortIABCats);
      // refresh the state and reset input fields
      this.setState({
        iabList,
        userEntryIABPrefix: '',
        userEntryIABSuffix: '',
        userEntryIABList: '',
      });
    }

    handleIABUserStringChange(ev: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
      // eg. IAB4-1; prefix = IAB4, suffix = 1
      const value = ev.target.value.split('-');
      if (value.length > 1 && value[1] === '') {
        value[1] = '-';
      }
      this.setState({
        userEntryIABPrefix: value[0].toUpperCase(),
        userEntryIABSuffix: (value.length > 1 ? value[1] : '').toUpperCase(),
      });
    }

    deleteCreativesAfterRotationChange = () => {
      if (this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE) {
        this.setState({
          AdserverCreatives: [],
        });
      } else {
        this.setState({
          AdserverCreativeFlightDatesSubgroups: [],
        });
      }
    };

    renderDeleteCreativesConfirm = () => {
      const { openDeleteCreativesConfirmation, EnableFlightDateSubgroups } = this.state;

      const onCloseFn = () => {
        this.setState({
          openDeleteCreativesConfirmation: false,
          EnableFlightDateSubgroups:
            EnableFlightDateSubgroups === EBool.EBool_TRUE ? EBool.EBool_FALSE : EBool.EBool_TRUE,
        });
      };

      const onUpdateFn = () => {
        this.deleteCreativesAfterRotationChange();
        this.setState({
          openDeleteCreativesConfirmation: false,
        });
      };

      const confirmDeleteCreativesDescription =
        'By changing of Creative Rotation selection all Creatives in the previous rotation will be deleted.';
      const confirmDeleteCreativesNotice = 'This will delete all created creatives';

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openDeleteCreativesConfirmation}
          onClose={() => this.setState({ openChannelListEditDialog: false })}
        >
          <DialogTitle style={{ paddingLeft: 50, paddingTop: 50 }}>
            Confirm Creatives Deletion
          </DialogTitle>
          <DialogContent style={{ paddingLeft: 50 }}>
            <DialogContentText id='alert-dialog-description'>
              {confirmDeleteCreativesDescription}
            </DialogContentText>
            <DialogContentText id='alert-dialog-notice' style={{ color: 'red' }}>
              {confirmDeleteCreativesNotice}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn()} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn()} color='primary' autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderRuleTypeIABEntry(disabled?: boolean) {
      const iabList = this.state.iabList;

      return (
        <div style={{ marginLeft: 10, width: 'inherit' }}>
          <Grid
            container
            direction='column'
            alignItems='flex-start'
            spacing={4}
            style={{ width: 'inherit' }}
          >
            <Grid item style={{ width: 900, padding: 5 }}>
              {/* Enter IAB */}
              <Grid container direction='column'>
                <Grid container direction='row' alignItems='flex-start' spacing={2}>
                  <Grid item xs={2}>
                    <InputLabel
                      style={{
                        marginRight: '20px',
                        fontSize: '14px',
                        color: 'black',
                      }}
                    >
                      IAB Category
                    </InputLabel>
                  </Grid>
                  <Grid item xs={6}>
                    <div style={{ fontSize: '14px' }}>Enter IAB Category or Subcategory</div>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container direction='row' alignItems='center' spacing={2}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={10}>
                      <Grid container direction='row' alignItems='center' spacing={2}>
                        <Grid item style={{ width: 80, marginTop: 16 }}>
                          <TextField
                            disabled={!!disabled}
                            name='IAB Cat'
                            fullWidth
                            placeholder='ex: IAB1-2'
                            onKeyPress={(ev: React.KeyboardEvent) => {
                              if (ev && ev.key === 'Enter') {
                                this.addIABUserEntry(); // add value when pressing enter
                              }
                            }}
                            value={this.getUserSingleIABString()}
                            onChange={(ev) => this.handleIABUserStringChange(ev)}
                          />
                        </Grid>

                        {/* IAB CAT PREFIX ONLY*/}
                        <Grid
                          item
                          style={{
                            marginTop: 16,
                          }}
                        >
                          <Select
                            style={{
                              width: 250,
                            }}
                            disabled={!!disabled}
                            value={this.state.userEntryIABPrefix}
                            onChange={(ev: ChangeEvent<{ name: string; value: unknown }>) => {
                              this.setState({
                                userEntryIABPrefix: ev.target.value as string,
                              });
                            }}
                            className='iab-category-prefix-select'
                          >
                            {getAllIABCategories().map((val) => {
                              return (
                                <MenuItem value={val}>
                                  {val}: {IAB_CATEGORIES[val].label}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </Grid>
                        {/* IAB SUFFIX ONLY*/}
                        {this.state.userEntryIABPrefix !== '' && (
                          <Grid
                            item
                            style={{
                              marginTop: 16,
                            }}
                          >
                            <Select
                              style={{
                                width: '250px',
                              }}
                              disabled={!!disabled}
                              value={this.state.userEntryIABSuffix}
                              onChange={(ev: ChangeEvent<{ name: string; value: unknown }>) => {
                                this.setState({
                                  userEntryIABSuffix: ev.target.value as string,
                                });
                              }}
                              className='iab-category-suffix-select'
                            >
                              {Object.keys(
                                (IAB_CATEGORIES[this.state.userEntryIABPrefix] || { values: [] })
                                  .values || {},
                              ).map((val) => {
                                return (
                                  <MenuItem value={val}>
                                    {val}:{' '}
                                    {IAB_CATEGORIES[this.state.userEntryIABPrefix].values[val]}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </Grid>
                        )}
                        {/* OR */}
                        <Grid item style={{ marginTop: '18px', fontSize: '17px', fontWeight: 500 }}>
                          OR
                        </Grid>
                        {/* IAB Comma Separated */}
                        <Grid item style={{ width: '250px' }}>
                          <TextField
                            style={{ width: 260 }}
                            disabled={!!disabled}
                            name='IABCatCommaSeparated'
                            label='IAB Cat Separated by comma'
                            value={this.state.userEntryIABList}
                            onKeyPress={(ev: React.KeyboardEvent) => {
                              if (ev && ev.key === 'Enter') {
                                this.addIABUserEntry(); // add value when pressing enter
                              }
                            }}
                            placeholder='ex: IAB1-1,IAB1-2,IAB2,IAB3'
                            onChange={(ev: ChangeEvent<{ name: string; value: unknown }>) => {
                              this.setState({
                                userEntryIABList: ev.target.value as string,
                              });
                            }}
                          />
                        </Grid>
                        {/* Add */}
                        <Grid item style={{ paddingTop: '20px' }}>
                          <ModelSecondaryButton
                            disabled={!!disabled}
                            size='large'
                            onClick={() => {
                              this.addIABUserEntry();
                            }}
                          >
                            + Add
                          </ModelSecondaryButton>
                        </Grid>
                        {/* TABLE WITH IAB Cat Values*/}
                        <Grid item>
                          <IncludeExcludeTable
                            list={iabList}
                            source={SourceCampaignFormView}
                            handleChange={(newList: IIncludeExcludeTableElement[]) =>
                              this.setState({ iabList: newList })
                            }
                            elementTitleHeader='IAB Code'
                            elementNameHeader='IAB Category: Subcategory'
                            handleOpenRuleTargetedExceptionDialog={noopVoid}
                            hideStatus
                            parentClassName='iabcat'
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }

    renderCreativesTab = () => {
      const {
        writeAuthorization,
        AdserverCreatives,
        CreativeType,
        EnableFlightDateSubgroups,
        EnforceSameCreativePerReqEnabled,
      } = this.state;

      const { classes, user } = this.props;
      let totalWeight = 0;
      for (const creative of AdserverCreatives) {
        if (!isBannerType(creative)) {
          totalWeight += Number(creative.Weight);
        }
      }
      let showWeightMsg = false;
      if (this.props.campaign && this.props.campaign.UpdatedAt) {
        const lastUpdated = formatDateFromUTCToOffset(
          this.props.campaign.UpdatedAt,
          this.state.Timezone,
        );
        const checkDate = formatDateFromUTCToOffset('2021-04-14T17:00:00Z', this.state.Timezone);
        // this date represents the day weights must add up to 100% was implemented
        if (lastUpdated.isBefore(checkDate)) {
          showWeightMsg = true;
        }
      }
      const WeightingTypeRequests: string = 'Requests count';
      const WeightingTypeImps: string = 'Imps count';

      const WeightingType =
        EnforceSameCreativePerReqEnabled === EBool.EBool_FALSE ||
        EnforceSameCreativePerReqEnabled === undefined
          ? WeightingTypeRequests
          : WeightingTypeImps;

      const displayAddPrimaryBannerButton =
        !this.hasPrimaryBanner() &&
        !this.state.isCreatingPrimaryBanner &&
        this.isNativeVastAuthorized;
      const displayAddSecondaryBannerButton =
        !displayAddPrimaryBannerButton &&
        !this.hasSecondaryBanner() &&
        !this.state.isCreatingSecondaryBanner &&
        this.isNativeVastAuthorized;

      const CREATIVE_PILLS: IPillItem[] = [
        {
          text: 'Flight Creatives',
          icon: {
            active: '/assets/shared/svg/RepeatActive.svg',
            inactive: '/assets/shared/svg/RepeatInactive.svg',
          },
        },
        {
          text: 'Set Creative Checkpoints',
          icon: {
            active: '/assets/shared/svg/CalendarActive.svg',
            inactive: '/assets/shared/svg/CalendarInactive.svg',
          },
        },
      ];

      return (
        <Grid className={classes.mainGridItem}>
          <Grid
            container
            direction='column'
            justify='flex-start'
            spacing={2}
            style={{
              marginBottom: '25px',
            }}
          >
            {/* Advertiser Details */}
            <Grid item style={{ width: '100% ' }}>
              <Grid
                container
                direction='row'
                alignItems='center'
                spacing={2}
                style={{
                  marginBottom: '15px',
                }}
              >
                <Grid item xs={2}>
                  <InputLabel
                    style={{
                      marginRight: '20px',
                      marginLeft: '-20px',
                      fontSize: '19px',
                      color: 'black',
                      fontWeight: 500,
                    }}
                  >
                    <IconV2
                      name='price-tag'
                      color={publicaColors.black}
                      style={{ marginRight: '5px', verticalAlign: 'middle' }}
                      large
                    />
                    Advertiser details
                  </InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <Grid container direction='row' alignItems='center' spacing={0}>
                    <Grid item>
                      <IconV2
                        name='info'
                        color={publicaColors.black}
                        style={{ width: '15px', height: '15px', verticalAlign: 'middle' }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography
                        className={classes.headingCategorySubtitle}
                        style={{
                          fontSize: '12px',
                          backgroundColor: publicaColors.lighterGray,
                          borderRadius: 3,
                          marginLeft: 8,
                          padding: '0px 4px',
                        }}
                      >
                        Input will be passed as the campaign delivers the creatives added below
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                alignItems='flex-start'
                spacing={2}
                style={{
                  marginBottom: '15px',
                }}
              >
                <Grid
                  item
                  xs={1}
                  style={{
                    marginRight: '50px',
                  }}
                >
                  <InputLabel
                    style={{
                      fontSize: '14px',
                      color: 'black',
                      paddingTop: '8px',
                    }}
                  >
                    Adomain
                  </InputLabel>
                </Grid>
                <Grid item xs={4}>
                  <Textarea
                    key='Adomain'
                    msDelay={800}
                    initialValue={
                      !isDemoAccount(user.user.Username) ? this.state.Adomain : 'demo.com'
                    }
                    handleOnChange={(value: string) => {
                      const newErrors = { ...this.state.errors };
                      let isMalformat = false;
                      for (let i = 0; i < value.length; i++) {
                        if (['"', "'", '>', '<', '&'].includes(value[i])) {
                          isMalformat = true;
                          newErrors.Adomain = 'Values ", \', >, <, and & not allowed.';
                          break;
                        }
                      }
                      this.setState({
                        Adomain: value,
                        errors: {
                          ...this.state.errors,
                          Adomain: isMalformat ? 'Values ", \', >, <, and & not allowed.' : '',
                        },
                      });
                    }}
                    style={{ minWidth: '360px' }}
                  />
                  {this.state.errors.Adomain && (
                    <Text extraSmall color={publicaColors.red}>
                      {this.state.errors.Adomain}
                    </Text>
                  )}
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                alignItems='center'
                justify='flex-start'
                style={{
                  marginBottom: '25px',
                }}
              >
                {this.renderRuleTypeIABEntry(!writeAuthorization.isAuthorized)}
              </Grid>
            </Grid>

            <Divider variant='middle' style={{ margin: 10, height: 1, color: 'black' }} />

            <Grid item style={{ width: '100% ' }}>
              <Grid
                container
                direction='row'
                alignItems='center'
                spacing={2}
                style={{
                  marginBottom: '15px',
                }}
              >
                <Grid item xs={2}>
                  <InputLabel
                    style={{
                      marginRight: '20px',
                      marginLeft: '-23px',
                      fontSize: '19px',
                      color: 'black',
                      fontWeight: 500,
                    }}
                  >
                    <IconV2
                      name='play'
                      color={publicaColors.black}
                      style={{ marginRight: '5px', verticalAlign: 'bottom' }}
                      large
                    />
                    Creatives Files
                  </InputLabel>
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                alignItems='center'
                spacing={2}
                style={{
                  marginBottom: '15px',
                }}
              >
                <Grid item xs={2}>
                  <InputLabel
                    style={{
                      marginRight: '20px',
                      fontSize: '14px',
                      color: 'black',
                    }}
                  >
                    Creative Type
                  </InputLabel>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    value={CreativeType}
                    className='pb-campaign-form-view_creative_type'
                    onChange={(event: React.ChangeEvent<{ _: string; value: string }>) => {
                      this.handleChangeCreativeType('CreativeType', event.target.value);
                    }}
                    fullWidth
                  >
                    {CreativeTypes.map((creative) => {
                      return <MenuItem value={creative.value}>{creative.label}</MenuItem>;
                    })}
                  </Select>
                </Grid>
                <Grid item xs={2} style={{ marginRight: -40 }}>
                  <InputLabel
                    style={{
                      marginLeft: '23px',
                      fontSize: '14px',
                      color: 'black',
                    }}
                  >
                    Weighting Logic
                    <Tooltip title={'The default weighting of creatives is by endpoint requests.'}>
                      <InfoIcon
                        style={{
                          verticalAlign: 'middle',
                          width: '1rem',
                          color: publicaColors.mediumLightGray,
                          marginLeft: '5px',
                        }}
                      />
                    </Tooltip>
                  </InputLabel>
                </Grid>
                <Grid item xs={2}>
                  <Select
                    value={WeightingType}
                    className='pb-campaign-form-view_creative_type'
                    onChange={(event: React.ChangeEvent<{ _: string; value: string }>) => {
                      this.setState({
                        EnforceSameCreativePerReqEnabled:
                          event.target.value === 'Imps count'
                            ? EBool.EBool_TRUE
                            : EBool.EBool_FALSE,
                      });
                    }}
                    fullWidth
                  >
                    {WeightingTypes.map((creative) => {
                      return <MenuItem value={creative.value}>{creative.label}</MenuItem>;
                    })}
                  </Select>
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                alignItems='center'
                spacing={2}
                style={{
                  marginBottom: '15px',
                }}
              >
                <Grid item xs={2}>
                  <InputLabel
                    style={{
                      marginRight: '20px',
                      fontSize: '14px',
                      color: 'black',
                    }}
                  >
                    Creative Rotation
                  </InputLabel>
                </Grid>
                <Grid item xs={6}>
                  <PillSwitcher
                    currentText={
                      EnableFlightDateSubgroups === EBool.EBool_TRUE
                        ? 'Set Creative Checkpoints'
                        : 'Flight Creatives'
                    }
                    pills={CREATIVE_PILLS}
                    customStyle={{
                      width: '366px',
                      height: '34px',
                      marginBottom: -10,
                    }}
                    onChange={(value: string) => {
                      const enableFlightDateSubgroups = value === 'Set Creative Checkpoints';
                      this.setState({
                        EnableFlightDateSubgroups: enableFlightDateSubgroups
                          ? EBool.EBool_TRUE
                          : EBool.EBool_FALSE,
                        openDeleteCreativesConfirmation:
                          this.state.AdserverCreatives.length !== 0 ||
                          (this.state.AdserverCreativeFlightDatesSubgroups !== undefined
                            ? this.state.AdserverCreativeFlightDatesSubgroups.length !== 0
                            : false),
                      });
                    }}
                  />
                  {this.state.openDeleteCreativesConfirmation &&
                    this.renderDeleteCreativesConfirm()}
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                alignItems='center'
                spacing={2}
                style={{
                  marginBottom: '15px',
                }}
              >
                <Grid item>
                  <Grid container direction='row' alignItems='center' spacing={0}>
                    <Grid item>
                      <IconV2
                        name='info'
                        color={publicaColors.black}
                        style={{ width: '15px', height: '15px', verticalAlign: 'middle' }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography
                        className={classes.headingCategorySubtitle}
                        style={{
                          fontSize: '12px',
                          backgroundColor: publicaColors.lighterGray,
                          borderRadius: 3,
                          marginLeft: 8,
                          padding: '0px 4px',
                        }}
                      >
                        {EnableFlightDateSubgroups === EBool.EBool_FALSE
                          ? 'Each Creative will be used throughout the campaign delivery dates according to its respective flight dates and weight.'
                          : 'Use Checkpoint to set the date range for which a subset of creatives will be valid and rotate depending on their respective assigned weight'}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {EnableFlightDateSubgroups !== EBool.EBool_TRUE && (
                <Grid container direction='row' alignItems='center' spacing={2}>
                  <Grid item xs={2}>
                    <InputLabel
                      style={{
                        marginRight: '20px',
                        fontSize: '14px',
                        color: 'black',
                      }}
                    >
                      <IconV2
                        name='hamburger'
                        color={publicaColors.black}
                        style={{ width: '12px', height: '12px', marginRight: '5px' }}
                      />
                      Total Creative Weight
                    </InputLabel>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography
                      className={
                        totalWeight === 100
                          ? `${classes.boldText} pb-campaign-form-view_total_weight`
                          : classes.boldTextError
                      }
                    >
                      {`${totalWeight}%`}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <ModelSecondaryButton onClick={this.evenWeights}>
                      Even Weights
                    </ModelSecondaryButton>
                  </Grid>
                  <Grid item xs={9}>
                    {showWeightMsg && (
                      <Button
                        style={{
                          width: '100%',
                          textAlign: 'left',
                          fontSize: '0.85rem',
                          color: publicaColors.gray,
                          textTransform: 'none',
                          justifyContent: 'flex-start',
                          backgroundColor: publicaColors.lighterYellow,
                          lineHeight: '15px',
                        }}
                        disabled={true}
                      >
                        <Typography style={{ fontSize: 12 }}>
                          This percentage isn't representative of your actual total weight. The
                          creatives on this screen are using the legacy weighting system (1-5) and
                          will still function as before. Any update to this line item will require
                          percentages added to all creatives and they will need to add up to 100%.
                        </Typography>
                      </Button>
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>

            {EnableFlightDateSubgroups === EBool.EBool_TRUE
              ? this.renderAdserverCreativeFlightDatesSubgroupsConfig()
              : this.renderAdserverCreativeFlightDatesConfig(
                  (c: IAdserverCreative) => c?.CreativeType !== EAdserverCreativeType.Banner,
                )}
          </Grid>

          {AdserverCreatives.length < 8 && EnableFlightDateSubgroups !== EBool.EBool_TRUE && (
            <Button
              disabled={!writeAuthorization.isAuthorized}
              onClick={() => this.addNewCreative(EBannerRank.NotBanner)}
              style={{
                color: !writeAuthorization.isAuthorized
                  ? getColorTheme('secondaryButtonDisabled')
                  : getColorTheme('secondaryButtonText'),
              }}
            >
              + Add new creative
            </Button>
          )}

          <Divider variant='middle' style={{ margin: 10, height: 1, color: 'black' }} />

          <Grid
            container
            direction='row'
            alignItems='center'
            spacing={2}
            style={{
              marginBottom: '15px',
            }}
          >
            <Grid item xs={2}>
              <InputLabel
                style={{
                  marginRight: '20px',
                  marginLeft: '-20px',
                  fontSize: '19px',
                  color: 'black',
                  fontWeight: 500,
                }}
              >
                <IconV2
                  name='image'
                  color={publicaColors.black}
                  style={{ marginRight: '5px', verticalAlign: 'bottom' }}
                  large
                />
                Companion Ad
              </InputLabel>
            </Grid>
            <Grid item xs={8}>
              <Grid container direction='row' alignItems='center' spacing={0}>
                <Grid item>
                  <IconV2
                    name='image'
                    color={publicaColors.black}
                    style={{ width: '15px', height: '15px', verticalAlign: 'middle' }}
                  />
                </Grid>
                <Grid item>
                  <Typography
                    className={classes.headingCategorySubtitle}
                    style={{
                      fontSize: '12px',
                      backgroundColor: publicaColors.lighterGray,
                      borderRadius: 3,
                      marginLeft: 8,
                      padding: '0px 4px',
                    }}
                  >
                    Optional setting - Support for native display creatives. Add a maximum of two
                    banners per line item.{' '}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {this.renderAdserverCreativeFlightDatesConfig(
              (c: IAdserverCreative) =>
                c?.CreativeType === EAdserverCreativeType.Banner &&
                EnableFlightDateSubgroups !== EBool.EBool_TRUE,
            )}
          </Grid>

          {displayAddPrimaryBannerButton && EnableFlightDateSubgroups !== EBool.EBool_TRUE && (
            <Button
              disabled={!writeAuthorization.isAuthorized}
              onClick={() => {
                this.setState({ isCreatingPrimaryBanner: true }, () => {
                  this.addNewCreative(EBannerRank.Primary);
                });
              }}
              style={{
                color: getColorTheme('secondaryButtonText'),
                marginBottom: '80px',
              }}
            >
              + Add Primary Banner
            </Button>
          )}
          {displayAddSecondaryBannerButton && EnableFlightDateSubgroups !== EBool.EBool_TRUE && (
            <Button
              disabled={!writeAuthorization.isAuthorized}
              onClick={() => {
                this.setState({ isCreatingSecondaryBanner: true }, () => {
                  this.addNewCreative(EBannerRank.Secondary);
                });
              }}
              style={{
                color: getColorTheme('secondaryButtonText'),
                marginBottom: '80px',
              }}
            >
              + Add Secondary Banner
            </Button>
          )}
        </Grid>
      );
    };

    getTimezone = () => {
      return this.state.Timezone || this.props.session.publisher.Timezone;
    };

    getCountryGroupsByPublisherID = () => {
      const { targetingCountryGroupList } = this.state;
      const { session } = this.props;

      getCountryGroupsByPublisherID(session.publisher.ID)
        .then((countryGroups: ICountryGroup[]) => {
          // create the updated menu list and update the state
          const updatedCountryGroupMenuList = generateNewTargetingCountryGroupList(
            targetingCountryGroupList,
            countryGroups,
          );
          this.setState({
            publisherCountryGroups: countryGroups,
            targetingCountryGroupList: updatedCountryGroupMenuList,
          });
        })
        .then(this.populateTargetingCountryGroupList);
    };

    getCommonRegionGroupsByIDs = () => {
      getCountryGroupsByIDs(commonRegionGroupsIDs, this.props.session.publisher.ID)
        .then((regionGroups) => {
          this.setState({ commonRegionGroups: regionGroups[0] });
        })
        .catch(() => {
          this.setState({
            commonRegionGroups: [],
            snackbarError: true,
            snackbarMessage: 'Error loading common country groups',
          });
        });
    };

    // populateTargetingCountryGroupList sets the selected value in targetingCountryGroupList
    // based on the TargetingCountryGroupIDs on the headerbidder, then updates the state
    populateTargetingCountryGroupList = (): void => {
      const { targetingCountryGroupList, TargetingCountryGroupIDs } = this.state;

      const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
      const selectedCountryGroupIDs = TargetingCountryGroupIDs.split(',');

      for (const selectedCountryGroupID of selectedCountryGroupIDs) {
        if (clonedTargetingCountryGroupList[selectedCountryGroupID] !== undefined) {
          clonedTargetingCountryGroupList[selectedCountryGroupID].selected = true;
        }
      }

      this.setState({
        targetingCountryGroupList: clonedTargetingCountryGroupList,
      });
    };

    componentDidMount(): void {
      const FrequencyCaps = this.state.FrequencyCaps.map((frequencyCap) => {
        frequencyCap.DurationUnits =
          parseInt(frequencyCap.TimeToLive, 10) % 86400 === 0
            ? FrequencyCapUnitDays
            : FrequencyCapUnitHours;
        frequencyCap.EditableDuration = this.calcFrequencyCapDuration(frequencyCap);
        return frequencyCap;
      });
      // Rights
      this.setState({
        readAuthorization: IS_AUTHORIZED(['read_campaign'], this.props.user.user),
        writeAuthorization: IS_AUTHORIZED(['write_campaign'], this.props.user.user),
        FrequencyCaps,
      });

      this.initializeIABList(this.props.campaign.IABCategory);
      this.uploadManager.events.addListener(
        'uploadManager_uploadStatusChange',
        (item: IUploadStatus) => {
          if (item.status === EUploadResponseType.ABORTED) {
            if (this.uploadKeyToIdx.has(item.key)) {
              const itemLocation = this.uploadKeyToIdx.get(item.key);
              if (itemLocation === undefined) {
                return;
              }
            }
          }
        },
      );

      this.setCampaignImpressions();
      this.fetchAdserverOrder();
      this.parseDayparting();
      this.genChannelList();
      this.genContextualSegmentList();
      this.genChannelGroupsList();
      this.genChannelLists();
      this.getCountryGroupsByPublisherID();
      this.importLocalTargetingParamFromJSON(true, this.props.campaign.LocalTargetingAllowed);
      this.importLocalTargetingParamFromJSON(false, this.props.campaign.LocalTargetingDisallowed);
      this.setupCountriesList();
      this.genTimezoneList();
      this.fetchSegments();
      this.getCommonRegionGroupsByIDs();
      this.handleGetUniqueLineItemAliases();
      this.fetchGlobalMediaFilesAndVasts();
      this.getPresetList();
    }

    componentWillUnmount() {
      this.uploadManager.cleanup();
    }

    isUserInfoMasked = (): boolean => {
      return checkUserInfoMasked(this.props.user.user);
    };

    // determines if the current user can write and returns permissions
    getWriteCampaignAuthorization = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_campaign'], this.props.user.user);
    };

    setCampaignImpressions = () => {
      getDebugCampaignPacingData(this.props.session.publisher.ID, this.state.ID).then(([data]) => {
        if (data) {
          this.setState({
            impressions: data.total_impressions,
          });
        }
      });
    };

    fetchAdserverOrder = () => {
      const { session } = this.props;
      const { AdserverOrderID } = this.state;
      getAdserverOrder(AdserverOrderID.toString(), session.publisher.ID, true).then(
        (adserverOrder: IAdserverOrder) => {
          const pacingTypeOption = getPacingTypeOption(adserverOrder.PacingType);
          if (!pacingTypeOption) {
            return;
          }
          this.setState({
            adserverOrder,
          });
        },
      );
    };

    // calls api for mediafiles and vasts, creates dropdown lists
    fetchGlobalMediaFilesAndVasts = () => {
      this.setState({
        isLoadingMediaFilesAndVasts: true,
      });
      const publisherID = this.props.session.publisher.ID;
      Promise.all([
        getGlobalMedia({
          query: {
            publisher_id: publisherID,
          },
        }),
        getGlobalVasts(publisherID),
      ]).then((resp) => {
        // MEDIAFILES
        const GlobalMediaFiles = resp[0] as IAdserverGlobalMediafile[];
        const blankMediaFileList = {} as IMenuList;
        const AdserverCreatives = this.state.AdserverCreatives;

        // create media file list for all creatives and when we add new creative
        GlobalMediaFiles.forEach((mediaFile: IAdserverGlobalMediafile) => {
          blankMediaFileList[mediaFile.ID] = {
            title: mediaFile.Name,
            selected: false,
            ID: mediaFile.ID,
            advertiserID: mediaFile.AdvertiserID,
            mimeType: mediaFile.Type,
          };
        });

        // for each creative in a campaign, make a menu list with the media files selected
        const globalMediafileList = {} as ICampaignCreativeList;
        for (let i = 0; i < AdserverCreatives.length; i++) {
          const creative = AdserverCreatives[i];
          const creativeMenuList = cloneDeep(blankMediaFileList);
          if ('AdserverGlobalMediafileIDs' in creative) {
            for (const mediaFileID of creative.AdserverGlobalMediafileIDs) {
              if (creativeMenuList[mediaFileID]) creativeMenuList[mediaFileID].selected = true;
            }
          }
          globalMediafileList[i] = creativeMenuList;
        }

        // VASTS
        const vasts = resp[1].parsedBody as IAdserverGlobalVast[];
        const globalVastList = {} as ICampaignCreativeList;
        const blankVastList = {} as IMenuList;

        // create vast list for all creatives and when we add new creative
        vasts.forEach((vast: IAdserverGlobalVast) => {
          blankVastList[vast.ID] = {
            title: vast.Name,
            selected: false,
            ID: vast.ID.toString(),
            advertiserID: vast.AdvertiserID,
          };
        });

        // for each creative in a campaign, make a menu list with the media files selected
        for (let i = 0; i < AdserverCreatives.length; i++) {
          const creative = AdserverCreatives[i];
          const creativeMenuList = cloneDeep(blankVastList);
          if (creative.AdserverGlobalVastID) {
            creativeMenuList[creative.AdserverGlobalVastID].selected = true;
          }
          globalVastList[i] = creativeMenuList;
          AdserverCreatives[i].GlobalVastList = creativeMenuList;
        }

        this.setState({
          isLoadingMediaFilesAndVasts: false,
          blankMediaFileList,
          blankVastList,
          globalMediafileList,
          globalVastList,
          vasts,
          GlobalMediaFiles,
          AdserverCreatives,
        });
      });
    };

    getSitesInfoForChannelList = (channelList: IChannelList): ISitesInfo[] => {
      return channelList.Sites.map((site: ISite) => {
        return { ID: site.ID, Name: site.Name };
      });
    };

    genChannelLists = (newCreatedChannelList?: boolean, newChannelListID?: number) => {
      getChannelListsPromise({
        publisherID: this.props.session.publisher.ID,
      })
        .then((response: { channelLists: IChannelList[] }) => {
          // if a headerbidder is selected from bidder list, use channel Lists
          // if channel Lists are in state, bidder was chosen from clone bidder
          const campaignChannelLists = this.props.campaign.ChannelLists || [];
          const channelListsList: IMenuList = {};
          const ChannelListIDS: number[] = [];
          campaignChannelLists.forEach((ccl: IChannelList) => {
            ChannelListIDS.push(ccl.ID);
          });
          // generate channelLists list for dropdown
          response.channelLists.forEach((cl: IChannelList) => {
            const channelGroupsLength = cl.ChannelGroupIDs.split(',').length;
            let channelListName;
            if (cl.ChannelGroupIDs === '' || cl.ChannelGroupIDs === 'undefined') {
              channelListName = `${cl.Name}: (${cl.SitesInfo.length} Channel(s))`;
            } else if (cl.ChannelIDs === '' || cl.ChannelIDs === 'undefined') {
              channelListName = `${cl.Name}: (${channelGroupsLength} Channel Group(s))`;
            } else {
              channelListName = `${cl.Name}: (${cl.SitesInfo.length} Channel(s) ${channelGroupsLength} Channel Group(s))`;
            }

            // new HBs should have selected all false to start
            // if hb is cloned or hb exists, look at headerbidderChannelListIDS to determine if this channel List is selected
            const selected = ChannelListIDS.includes(cl.ID);
            channelListsList[cl.ID] = {
              title: channelListName,
              selected,
              ID: cl.ID.toString(),
              channelList: cl,
            };
          });

          if (!!newCreatedChannelList && newChannelListID !== undefined) {
            ChannelListIDS.push(newChannelListID);
            channelListsList[newChannelListID].selected = true;
          }
          this.setState({
            channelLists: response.channelLists,
            ChannelListIDS,
            channelListsList,
          });
        })
        .catch(() => {
          this.setState({
            channelLists: [],
            ChannelListIDS: [],
            channelListsList: {} as IMenuList,
          });
        });
    };

    // parseDayparting is run when component mounts and is used to transform the dayparting string into dayparting intervals
    parseDayparting = () => {
      if (!this.state.CampaignType || this.state.CampaignType === '0') {
        this.setState({ CampaignType: CAMPAIGN_TYPES[0].value });
      }

      const daypartingObj = parseDayparting(this.props.campaign.Dayparting);
      const isDaypartingActive = daypartingObj[0];
      const DaypartingIntervals = daypartingObj[1];
      const enableViewerTimezone = daypartingObj[2];
      this.setState({
        isDaypartingActive,
        DaypartingIntervals,
        enableViewerTimezone,
      });
    };

    genContextualSegmentList = () => {
      getContextualSegmentsByPublisherID(this.props.session.publisher.ID)
        .then((resp) => {
          const contextualSegments = resp[0];
          const contextualSegmentList: IMenuList = {};
          for (const segment of contextualSegments || []) {
            if (segment.Active === ResourceActiveDisabled) {
              continue;
            }
            contextualSegmentList[segment.ID] = {
              title: segment.Name,
              selected: this.state.ContextualSegmentIDS.includes(segment.ID),
              ID: segment.ID.toString(),
            };
          }
          this.setState({
            contextualSegmentList,
          });
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Error loading contextual segments',
          });
        });
    };

    genChannelList = async () => {
      const campaignSites = this.props.campaign.Sites || [];
      const siteList: IMenuList = {};
      const Sites: string[] = [];
      const channelListChannels = {} as IMenuList;

      const [allSites, err] = await getSmallSites(this.props.session.publisher.ID);
      if (err) {
        console.error(err);
        return;
      }

      // If new campaign, only show active channels
      let renderedSites = allSites || [];
      if (!isExistingCampaign(this.state)) {
        renderedSites = filterSitesByActive(renderedSites);
      }
      renderedSites.forEach((site: ISmallSite) => {
        const siteName = checkUserInfoMasked(this.props.user.user)
          ? 'demo_site_' + site.ID
          : site.Name;
        siteList[site.ID] = {
          title: siteName,
          selected: campaignSites.includes(site.ID.toString()),
          ID: site.ID.toString(),
          defaultWeight: site.DefaultWeight,
        };
        if (campaignSites.includes(site.ID.toString())) {
          Sites.push(site.ID.toString());
        }
        channelListChannels[site.ID] = {
          selected: false,
          title: siteName,
          ID: site.ID.toString(),
        };
      });
      // Update associations in state to use a site's default weight if site weights are turned on for an already-targeted channel
      if (
        (this.props.session.publisher.ID === '788' || this.props.session.publisher.ID === '359') &&
        this.state.siteWeightsActiveDBValue === EBool.EBool_FALSE
      ) {
        const SiteAdserverCampaignAssociations = this.state.SiteAdserverCampaignAssociations.map(
          (asso: ISiteAdserverCampaignAssociation) => {
            const site = Object.values(siteList).find(
              (menuItem: IListItem) => menuItem.ID === asso.SiteID.toString(),
            );
            return Object.assign(asso, {
              SiteWeight: site && site.defaultWeight ? site.defaultWeight : asso.SiteWeight,
            });
          },
        );
        this.setState({
          SiteAdserverCampaignAssociations,
          siteList,
          Sites,
          siteCount: Object.values(siteList).length,
          channelListChannels,
          editChannelListChannels: channelListChannels,
        });
      } else {
        this.setState({
          siteList,
          Sites,
          siteCount: Object.values(siteList).length,
          channelListChannels,
          editChannelListChannels: channelListChannels,
          allSites: allSites || [],
        });
      }
    };

    genChannelGroupsList = () => {
      const getChannelLabelPromise = getChannelLabels({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      });
      Promise.all([
        getChannelGroupsPromise({
          publisherID: this.props.session.publisher.ID,
        }),
        getChannelLabelPromise,
      ]).then((response: any[]) => {
        const channelGroupsList: IMenuList = {};
        const ChannelGroupIDS = [] as number[];
        const campaignChannelGroups = this.state.ChannelGroups || [];
        const campaignChannelGroupIDS = campaignChannelGroups.map((cg: IChannelGroup) => cg.ID);
        const channelListChannelGroups: IMenuList = {};
        response[0].channelGroups.forEach((cg: IChannelGroup) => {
          const channelGroupName = checkUserInfoMasked(this.props.user.user)
            ? 'demo_site_' + cg.ID
            : cg.Name;
          channelGroupsList[cg.ID] = {
            title: channelGroupName,
            selected: campaignChannelGroupIDS.includes(cg.ID),
            ID: cg.ID.toString(),
            defaultWeight: cg.DefaultWeight,
          };
          if (campaignChannelGroupIDS.includes(cg.ID)) {
            ChannelGroupIDS.push(cg.ID);
          }
          channelListChannelGroups[cg.ID] = {
            title: channelGroupName,
            selected: false,
            ID: cg.ID.toString(),
            channelGroup: cg,
          };
        });
        // Update associations in state to use a CG's default weight if site weights are turned on for an already-targeted channel group
        if (
          (this.props.session.publisher.ID === '788' ||
            this.props.session.publisher.ID === '359') &&
          this.state.siteWeightsActiveDBValue === EBool.EBool_FALSE
        ) {
          const ChannelGroupAdserverCampaignAssociations =
            this.state.ChannelGroupAdserverCampaignAssociations.map(
              (asso: IChannelGroupAdserverCampaignAssociation) => {
                const CG = Object.values(channelGroupsList).find(
                  (menuItem: IListItem) => menuItem.ID === asso.ChannelGroupID.toString(),
                );
                return Object.assign(asso, {
                  SiteWeight: CG && CG.defaultWeight ? CG.defaultWeight : asso.SiteWeight,
                });
              },
            );
          this.setState(
            {
              ChannelGroupAdserverCampaignAssociations,
              channelGroupsList,
              ChannelGroupIDS,
              ChannelGroups: response[0].channelGroups,
              channelLabels: response[1].channel_labels,
              channelListChannelGroups,
              editChannelListChannelGroups: channelListChannelGroups,
            },
            () => {
              this.setState({
                quickFilterOptions: genQuickFilter(
                  this.state.ChannelGroups,
                  this.state.channelLabels,
                  this.props.user.user.Username,
                ),
              });
            },
          );
        } else {
          this.setState(
            {
              channelGroupsList,
              ChannelGroupIDS,
              ChannelGroups: response[0].channelGroups,
              channelLabels: response[1].channel_labels,
              channelListChannelGroups,
              editChannelListChannelGroups: channelListChannelGroups,
            },
            () => {
              this.setState({
                quickFilterOptions: genQuickFilter(
                  this.state.ChannelGroups,
                  this.state.channelLabels,
                  this.props.user.user.Username,
                ),
              });
            },
          );
        }
      });
    };

    setupCountriesList = () => {
      const { targetingCountriesList, TargetedCountries } = this.state;

      // If number of selected countries < total/2, we are in Allow list mode
      const ckeys: string[] = TargetedCountries.split(',');
      if (ckeys.length < getAllCountries().length / 2) {
        // Allowlist mode
        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (targetingCountriesList[selectedCountry] !== undefined) {
            targetingCountriesList[selectedCountry].selected = true;
          }
        }
        this.setState({
          targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Allowlist,
        });
      } else {
        // Denylist mode
        for (const key of Object.keys(targetingCountriesList)) {
          targetingCountriesList[key].selected = true;
        }

        for (let selectedCountry of ckeys) {
          selectedCountry = selectedCountry.toLowerCase();
          if (targetingCountriesList[selectedCountry] !== undefined) {
            targetingCountriesList[selectedCountry].selected = false;
          }
        }

        this.setState({
          targetingCountriesList,
          deviceTargetingCountrySelectMode: SelectMode.Denylist,
        });
      }
    };

    genTimezoneList = () => {
      const { campaign, session } = this.props;

      const { FrequencyLimitDays, FrequencyLimitHours } = this.state;

      const Timezone = campaign.Timezone || session.publisher.Timezone;
      const timezonesList = genTimezoneList(campaign.Timezone || session.publisher.Timezone);

      let frequencyLimitUnit: string = FrequencyCapUnitDays;
      let frequencyLimitDuration: string;
      if (FrequencyLimitDays && FrequencyLimitDays !== '0') {
        frequencyLimitUnit = FrequencyCapUnitDays;
        frequencyLimitDuration = FrequencyLimitDays;
      } else if (FrequencyLimitHours && FrequencyLimitHours !== '0') {
        frequencyLimitUnit = FrequencyCapUnitHours;
        frequencyLimitDuration = FrequencyLimitHours;
      } else {
        frequencyLimitUnit = FrequencyCapUnitDays;
        frequencyLimitDuration = '30';
      }
      this.setState({
        timezonesList,
        Timezone,
        frequencyLimitDuration,
        frequencyLimitUnit,
      });
    };

    fetchSegments = () => {
      getAudienceSegments({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then((segments: IAudienceSegment[]) => {
        this.setState({
          segments,
        });
      });
    };

    handleChannelAcceptClick = (siteList: IMenuList): void => {
      // update the SiteAdserverCampaignAssociations by adding and removing associations
      const SiteAdserverCampaignAssociations = [] as ISiteAdserverCampaignAssociation[];
      const Sites: string[] = [];
      Object.values(siteList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          Sites.push(listItem.ID);
          // find the association between the campaign and site
          const matchedAsso = this.state.SiteAdserverCampaignAssociations.find(
            (asso: ISiteAdserverCampaignAssociation) => asso.SiteID === parseInt(listItem.ID, 10),
          );
          // if found, keep it and if not, create a new association with site weight = 1 (default)
          if (matchedAsso) {
            SiteAdserverCampaignAssociations.push(matchedAsso);
          } else if (
            (this.props.session.publisher.ID === '788' ||
              this.props.session.publisher.ID === '359') &&
            listItem.defaultWeight
          ) {
            SiteAdserverCampaignAssociations.push({
              ID: 0,
              AdserverCampaignID: parseInt(this.state.ID, 10),
              SiteID: parseInt(listItem.ID, 10),
              SiteWeight: listItem.defaultWeight,
            });
          } else {
            SiteAdserverCampaignAssociations.push({
              ID: 0,
              AdserverCampaignID: parseInt(this.state.ID, 10),
              SiteID: parseInt(listItem.ID, 10),
              SiteWeight: 1,
            });
          }
        }
      });
      this.setState({
        Sites,
        siteList,
        SiteAdserverCampaignAssociations,
      });
    };

    renderChannelListDialog = (channelListRow: IInputRow) => {
      const { openChannelListDialog, openChannelListEditDialog } = this.state;

      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={channelListRow} disableEdit={false} />
          {openChannelListDialog && this.renderChannelCreateList()}
          {openChannelListEditDialog && this.renderChannelEditList()}
        </Grid>
      );
    };

    renderChannelCreateList = () => {
      const {
        openChannelListDialog,
        channelListName,
        channelListChannelGroups,
        channelListChannels,
        ChannelListChannelsIDS,
        ChannelListGroupsIDS,
      } = this.state;
      const { classes } = this.props;

      const onCloseFn = (openDialog?: boolean) => {
        this.handleCloseChannelList();
        this.setState({
          openRegionCreateEditDialog: false,
          openChannelListDialog: !!openDialog,
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = validatorFactory(channelListValidationSetting)(this.state);
        // Check channel targeting and ensure a channel or channel group is selected
        if (
          (ChannelListChannelsIDS === undefined && ChannelListGroupsIDS === undefined) ||
          (ChannelListChannelsIDS === '' && ChannelListGroupsIDS === '')
        ) {
          // If no channel ids, adds appropriate error text to errors
          errors.ChannelIds = 'Select at least one channel or channel group';
        }

        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: `Please fix errors before saving channel list: ${errorText}`,
              snackbarError: true,
            },
            () => {
              setTimeout(this.snackbarClose, 5000);
            },
          );
          return;
        }
        this.saveChannelList(channelListName, ChannelListChannelsIDS, ChannelListGroupsIDS);
        this.clearChannelListsGroupsandChannels();
        this.setState({
          openRegionCreateEditDialog: false,
          openChannelListDialog: !!openDialog,
        });
      };

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Name',
        field1: 'ChannelListName',
        value1: channelListName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;
      const ListChannelRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: 'Channels',
        value1: channelListChannels,
        defaultValue1: false,
        handleChange1: this.handleChangeList('channelListChannels'),
        handleAccept1: this.handleChannelListChannelsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active ? `${ChannelListChannelsIDS.length} Channel(s)` : 'All Channels',
        materialDropdownShowPrefixID: true,
      } as IInputRow;
      const ListChannelGroupRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: 'Channel Groups',
        value1: channelListChannelGroups,
        defaultValue1: false,
        handleChange1: this.handleChangeList('channelListChannelGroups'),
        handleAccept1: this.handleChannelListGroupsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active ? `${ChannelListGroupsIDS.length} Channel Group(s)` : 'All Channels Groups',
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openChannelListDialog}
          onClose={() => this.setState({ openChannelListDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>Create Channel List</DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section} style={{ paddingBottom: 10 }}>
              <InputRow rowInfo={NameRow} disableEdit={false} />
            </Grid>
            <Grid className={classes.section} style={{ paddingBottom: 10 }}>
              <InputRow rowInfo={ListChannelRow} disableEdit={false} />
            </Grid>
            <Grid className={classes.section} style={{ paddingBottom: 400 }}>
              <InputRow rowInfo={ListChannelGroupRow} disableEdit={false} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderChannelEditList = () => {
      const {
        openChannelListEditDialog,
        editChannelListName,
        EditChannelListChannelsIDS,
        EditChannelListGroupsIDS,
        editChannelListsList,
        editChannelListID,
      } = this.state;
      const { classes } = this.props;
      const onCloseFn = (openDialog?: boolean) => {
        this.clearEditChannelLists();
        this.setState({
          openChannelListEditDialog: !!openDialog,
        });
      };

      const onUpdateFn = (openDialog?: boolean) => {
        const errors = validatorFactory(channelEditListValidationSetting)(this.state);
        // Check if errors exists, if it does set state
        if (hasErrors(errors)) {
          const errorText = Object.values(errors)
            .filter((value) => value.length)
            .join('. ');
          this.setState(
            {
              errors,
              snackbarMessage: `Please fix errors before saving channel list: ${errorText}`,
              snackbarError: true,
            },
            () => {
              setTimeout(this.snackbarClose, 5000);
            },
          );
          return;
        }
        this.handleEditChannelList(
          editChannelListID,
          editChannelListName,
          EditChannelListChannelsIDS,
          EditChannelListGroupsIDS,
        );
        this.setState({
          openChannelListEditDialog: !!openDialog,
        });
      };

      const ChannelListRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: 'Channel List',
        value1: editChannelListsList,
        defaultValue1: false,
        handleChange1: this.handleChangeList('editChannelListsList'),
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active ? `${editChannelListID.length} Channel` : 'All Channels',
        materialDropdownShowPrefixID: true,
        materialDropdownEnableMultiSelect: false,
        disableSelectAll: true,
      } as IInputRow;

      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={openChannelListEditDialog}
          onClose={() => this.setState({ openChannelListEditDialog: false })}
        >
          <DialogTitle style={{ padding: 50 }}>Edit Channel List</DialogTitle>
          <DialogContent style={{ paddingLeft: 100 }}>
            <Grid className={classes.section} style={{ paddingBottom: 10 }}>
              <InputRow rowInfo={ChannelListRow} disableEdit={false} />
            </Grid>
            {this.state.editChannelListID !== 0 ? (
              this.loadSelectedEditChannelList()
            ) : (
              <Grid style={{ paddingBottom: 480 }} />
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCloseFn(false)} color='primary' autoFocus>
              Cancel
            </Button>
            <Button onClick={() => onUpdateFn(false)} color='primary' autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    loadSelectedEditChannelList = () => {
      const {
        editChannelListChannelGroups,
        editChannelListChannels,
        ChannelListChannelsIDS,
        ChannelListGroupsIDS,
        editChannelListName,
      } = this.state;
      const { classes } = this.props;

      const NameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Name',
        field1: 'editChannelListName',
        value1: editChannelListName,
        defaultValue1: 0,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        placeholderText: '',
        disabled1: false,
      } as IInputRow;
      const ListChannelRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: 'Channels',
        value1: editChannelListChannels,
        defaultValue1: false,
        handleChange1: this.handleChangeList('editChannelListChannels'),
        handleAccept1: this.handleEditChannelListChannelsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active ? `${ChannelListChannelsIDS.length} Channel(s)` : 'All Channels',
        materialDropdownShowPrefixID: true,
      } as IInputRow;
      const ListChannelGroupRow = {
        renderType: 'MaterialDropdown',
        enableSmallRow: true,
        title1: 'Channel Groups',
        value1: editChannelListChannelGroups,
        defaultValue1: false,
        handleChange1: this.handleChangeList('editChannelListChannelGroups'),
        handleAccept1: this.handleEditChannelListGroupsAcceptClick,
        isActiveValue1: () => true,
        getActiveTag1: (active: boolean) =>
          active ? `${ChannelListGroupsIDS.length} Channel Group(s)` : 'All Channels Groups',
      } as IInputRow;

      return (
        <Grid>
          <Grid className={classes.section} style={{ paddingBottom: 10 }}>
            <InputRow rowInfo={NameRow} disableEdit={false} />
          </Grid>
          <Grid className={classes.section} style={{ paddingBottom: 10 }}>
            <InputRow rowInfo={ListChannelRow} disableEdit={false} />
          </Grid>
          <Grid className={classes.section} style={{ paddingBottom: 300 }}>
            <InputRow rowInfo={ListChannelGroupRow} disableEdit={false} />
          </Grid>
        </Grid>
      );
    };

    addChannelList = () => {
      const { session } = this.props;
      // push an empty channel group to state
      this.setState(
        {
          channelLists: update(this.state.channelLists, {
            $push: [
              {
                PublisherID: session.publisher.ID,
                ID: 0,
                Name: '',
                ChannelIDs: [],
                ChannelGroupIDs: [],
                ChannelListIsAllowed: 1,
              },
            ],
          }),
        },
        () => {
          this.setState({
            newChannelListActive: true, // boolean to determine if channel group is being created
            listSettingsDialogActive: true, // boolean to determine if the channel group dialog is opened
            listSettingsDialogID: 0, // integer ID to determine what info to show in the dialog
          });
        },
      );

      return Promise.resolve();
    };

    handleCloseChannelList = () => {
      const { channelLists, newChannelListActive } = this.state;

      // if this is a new channel list, if we close editor and don't save, filter it out
      let clonedChannelLists = cloneDeep(channelLists);
      if (newChannelListActive) {
        clonedChannelLists = clonedChannelLists.filter((channelList) => channelList.ID !== 0);
      }
      this.setState({
        selectedChannelIDs: [] as string[],
        newChannelListActive: false,
        channelLists: clonedChannelLists,
        selectedChannelListLabels: [],
        listSettingsDialogActive: false,
        listSettingsDialogID: 0,
      });
    };

    clearChannelListsGroupsandChannels = () => {
      const channelListChannelGroups: IMenuList = this.state.channelListChannelGroups;
      const channelListChannels: IMenuList = this.state.channelListChannels;
      Object.values(this.state.channelListChannels).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          channelListChannels[listItem.ID].selected = false;
        }
      });
      Object.values(this.state.channelListChannelGroups).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          channelListChannelGroups[listItem.ID].selected = false;
        }
      });
      this.setState({
        channelListChannels,
        channelListChannelGroups,
        ChannelListChannelsIDS: [],
        ChannelListGroupsIDS: [],
        channelListName: '',
      });
    };

    clearEditChannelLists = () => {
      const editChannelListsList: IMenuList = cloneDeep(this.state.channelListsList);
      Object.values(editChannelListsList).forEach((listItem: IListItem) => {
        editChannelListsList[listItem.ID].selected = false;
      });
      Object.values(this.state.editChannelListChannels).forEach((listItem: IListItem) => {
        listItem.selected = false;
      });
      Object.values(this.state.editChannelListChannelGroups).forEach((listItem: IListItem) => {
        listItem.selected = false;
      });
      this.setState({
        editChannelListsList,
        editChannelListID: 0,
      });
    };

    saveChannelList = (name: string, channelIDs: string, channelGroupIDs: string) => {
      const { channelLists, listSettingsDialogID } = this.state;

      const clonedChannelLists = cloneDeep(channelLists);
      const foundChannelList = clonedChannelLists.find(
        (channelList: IChannelList) =>
          channelList.ID.toString() === listSettingsDialogID.toString(),
      );
      if (foundChannelList) {
        foundChannelList.Name = name;
        foundChannelList.ChannelIDs = channelIDs;
        foundChannelList.ChannelGroupIDs = channelGroupIDs;

        this.setState(
          {
            channelLists: clonedChannelLists,
            updatingChannelLists: true,
          },
          () => {
            // create a new channel list
            createChannelList(foundChannelList).then((response: any[]) => {
              const [channelList, err] = response;
              const newCreatedChannelListID = response[0].ID;
              if (err) {
                this.setState({
                  channelLists: clonedChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: 'Failed to create channel list',
                  snackbarError: true,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
              } else {
                const updatedChannelLists = cloneDeep(this.state.channelLists);
                channelList.SitesInfo = this.getSitesInfoForChannelList(channelList);
                updatedChannelLists.push(channelList);
                this.setState({
                  channelLists: updatedChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: 'Successfully saved channel list',
                  snackbarError: false,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
                this.genChannelLists(true, newCreatedChannelListID);
              }
            });
          },
        );
      }
    };

    handleEditChannelList = (
      channelListID: number,
      name: string,
      channelIDs: string,
      channelGroupIDs: string,
    ) => {
      const { channelLists } = this.state;

      const clonedChannelLists = cloneDeep(channelLists);
      const foundChannelList = clonedChannelLists.find(
        (channelList) => channelList.ID.toString() === channelListID.toString(),
      );
      if (foundChannelList) {
        foundChannelList.Name = name;
        foundChannelList.ChannelIDs = channelIDs;
        foundChannelList.ChannelGroupIDs = channelGroupIDs;

        this.setState(
          {
            channelLists: clonedChannelLists,
            updatingChannelLists: true,
          },
          () => {
            // update the existing channel list
            updateChannelList(foundChannelList).then((response: any[]) => {
              const [channelList, err] = response;
              if (err) {
                this.setState({
                  channelLists: clonedChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: 'Failed to update channel list',
                  snackbarError: true,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
              } else {
                const sessionChannelLists = cloneDeep(this.state.channelLists);
                for (let idx = 0; idx < sessionChannelLists.length; idx++) {
                  if (sessionChannelLists[idx].ID === foundChannelList.ID) {
                    channelList.SitesInfo = this.getSitesInfoForChannelList(channelList);
                    sessionChannelLists[idx] = channelList;
                    break;
                  }
                }
                this.setState({
                  channelLists: sessionChannelLists,
                  updatingChannelLists: false,
                  snackbarMessage: 'Successfully updated channel list',
                  snackbarError: false,
                  listSettingsDialogActive: false,
                  listSettingsDialogID: 0,
                  newChannelListActive: false,
                });
                this.genChannelLists();
              }
            });
          },
        );
      }
    };

    handleChannelListGroupsAcceptClick = (): void => {
      const ChannelListGroupsIDS: number[] = [];
      Object.values(this.state.channelListChannelGroups).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelListGroupsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        ChannelListGroupsIDS,
      });
    };

    handleChannelListChannelsAcceptClick = (): void => {
      const ChannelListChannelsIDS = [] as number[];
      Object.values(this.state.channelListChannels).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelListChannelsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        ChannelListChannelsIDS,
      });
    };

    handleChannelListsAcceptClick = (): void => {
      // update the SiteAdserverCampaignAssociations by adding and removing associations
      const ChannelListAdserverCampaignAssociations =
        [] as IChannelListAdserverCampaignAssociation[];
      const ChannelListIDS: number[] = [];
      const channelListsList: IMenuList = cloneDeep(this.state.channelListsList);
      Object.values(channelListsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelListIDS.push(+listItem.ID);
          // find the association between the campaign and site
          const matchedAsso = this.state.ChannelListAdserverCampaignAssociations.find(
            (asso: IChannelListAdserverCampaignAssociation) =>
              asso.ChannelListID === parseInt(listItem.ID, 10),
          );
          if (matchedAsso) {
            ChannelListAdserverCampaignAssociations.push(matchedAsso);
          } else {
            ChannelListAdserverCampaignAssociations.push({
              ID: 0,
              AdserverCampaignID: parseInt(this.state.ID, 10),
              ChannelListID: parseInt(listItem.ID, 10),
            });
          }
        }
      });
      this.setState({
        ChannelListIDS,
        channelListsList,
        ChannelListAdserverCampaignAssociations,
      });
    };

    handleEditChannelListGroupsAcceptClick = (): void => {
      const EditChannelListGroupsIDS: number[] = [];
      Object.values(this.state.editChannelListChannelGroups).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          EditChannelListGroupsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        EditChannelListGroupsIDS,
      });
    };

    handleEditChannelListChannelsAcceptClick = (): void => {
      const EditChannelListChannelsIDS = [] as number[];
      Object.values(this.state.editChannelListChannels).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          EditChannelListChannelsIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState({
        EditChannelListChannelsIDS,
      });
    };

    handleChannelGroupsAcceptClick = (channelGroupsList: IMenuList): void => {
      // update the SiteAdserverCampaignAssociations by adding and removing associations
      const ChannelGroupAdserverCampaignAssociations =
        [] as IChannelGroupAdserverCampaignAssociation[];
      const ChannelGroupIDS: number[] = [];
      Object.values(channelGroupsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelGroupIDS.push(+listItem.ID);
          // find the association between the campaign and site
          const matchedAsso = this.state.ChannelGroupAdserverCampaignAssociations.find(
            (asso: IChannelGroupAdserverCampaignAssociation) =>
              asso.ChannelGroupID === parseInt(listItem.ID, 10),
          );
          // if found, keep it and if not, create a new association with site weight = 1 (default)
          if (matchedAsso) {
            ChannelGroupAdserverCampaignAssociations.push(matchedAsso);
          } else if (
            (this.props.session.publisher.ID === '788' ||
              this.props.session.publisher.ID === '359') &&
            listItem.defaultWeight
          ) {
            ChannelGroupAdserverCampaignAssociations.push({
              ID: 0,
              AdserverCampaignID: parseInt(this.state.ID, 10),
              ChannelGroupID: parseInt(listItem.ID, 10),
              SiteWeight: listItem.defaultWeight,
            });
          } else {
            ChannelGroupAdserverCampaignAssociations.push({
              ID: 0,
              AdserverCampaignID: parseInt(this.state.ID, 10),
              ChannelGroupID: parseInt(listItem.ID, 10),
              SiteWeight: 1,
            });
          }
        }
      });
      this.setState({
        ChannelGroupIDS,
        channelGroupsList,
        ChannelGroupAdserverCampaignAssociations,
      });
    };

    handleTimezoneAcceptClick = (): void => {
      for (const { title, selected } of Object.values(this.state.timezonesList) as IListItem[]) {
        if (selected) {
          this.setState({
            Timezone: title,
          });
          break;
        }
      }
    };

    handleContextualSegmentsAcceptClick = (contextualSegmentList: IMenuList): void => {
      const ContextualSegmentIDS = [] as number[];
      for (const { ID, selected } of Object.values(contextualSegmentList) as IListItem[]) {
        if (selected) {
          ContextualSegmentIDS.push(parseInt(ID, 10));
        }
      }
      this.setState({
        ContextualSegmentIDS,
        contextualSegmentList,
      });
    };

    handleDaypartingDateChange = (index: number, time: string, dateType: 'start' | 'end'): void => {
      if (!time) {
        return;
      }
      // convert time string from text field to moment
      const DaypartingIntervals = handleDaypartingDateChange(
        index,
        time,
        dateType,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    handleAddFrequencyCap = (): void => {
      const { campaign } = this.props;
      const { FrequencyCaps } = this.state;
      const clonedFrequencyCaps = cloneDeep(FrequencyCaps);
      clonedFrequencyCaps.push({
        ID: 0,
        CreatedAt: '',
        DeletedAt: '',
        UpdatedAt: '',
        Active: FrequencyCapActiveActive,
        Type: FrequencyCapTypeAdserverCampaign,
        Limit: 0,
        TimeToLive: '2592000',
        EditableDuration: '30',
        DurationUnits: FrequencyCapUnitDays,
        AdserverCampaignID: parseInt(campaign.ID, 10),
        FrequencyTrackingKey: FrequencyTrackingKey.DEVICEID,
        FrequencyTargetingKey: FrequencyTargetingKey.IMPRESSION,
      });
      this.setState({
        FrequencyCaps: clonedFrequencyCaps,
      });
    };

    handleDeleteFrequencyCap = (frequencyCapIdx: number): void => {
      const { FrequencyCaps } = this.state;
      const clonedFrequencyCaps = cloneDeep(FrequencyCaps);
      clonedFrequencyCaps.splice(frequencyCapIdx, 1);
      this.setState({
        FrequencyCaps: clonedFrequencyCaps,
      });
    };

    handleDayClick = (day: Day, index: number): void => {
      const DaypartingIntervals = handleDaypartingDayClick(
        day,
        index,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    handleAddDaypartingPeriod = (): void => {
      const DaypartingIntervals = handleAddDaypartingPeriod(this.state.DaypartingIntervals);
      this.setState({ DaypartingIntervals });
    };

    handleDeleteDaypartingPeriod = (index: number): void => {
      const DaypartingIntervals = handleDeleteDaypartingPeriod(
        index,
        this.state.DaypartingIntervals,
      );
      this.setState({ DaypartingIntervals });
    };

    setStateCallback = (keys: string[], values: any[], setStateCallbacks: Array<() => void>) => {
      const stateObj = {} as IState;
      for (let i = 0; i < keys.length; i++) {
        stateObj[keys[i]] = values[i];
      }
      this.setState(stateObj, () => {
        setStateCallbacks.forEach((callback: () => void) => callback());
      });
    };

    getDisplayedDeviceTypes = (): string[] => {
      const { TargetingDeviceTypes } = this.state;
      if (TargetingDeviceTypes.length > 0) {
        return TargetingDeviceTypes.split(',');
      }
      return deviceORTBTypes.map((deviceType: IDeviceType) => deviceType.key);
    };

    handleChangeTargetingDeviceTypes = (_: string, value: string[]) => {
      if (value.length === deviceORTBTypes.length) {
        this.setState({ TargetingDeviceTypes: '' });
      } else {
        this.setState({ TargetingDeviceTypes: value.join(',') });
      }
    };

    // Convert segments list to list of objects {key, text} for displaying in segment dropdown
    getAudienceSegmentsAsItems = (): IMenuList => {
      const list = {} as IMenuList;
      const selected = this.state.TargetingAudienceSegmentID.split(',');

      this.state.segments.forEach((segment: IAudienceSegment) => {
        list[segment.ID] = {
          title:
            segment.Active === AudienceSegmentActiveActive
              ? segment.Name
              : `${segment.Name} [inactive]`,
          ID: segment.ID,
          selected: selected.includes(segment.ID),
        } as IListItem;
      });
      return list;
    };

    handleChangePacingTypeSelect = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const opt = getPacingTypeOptionByText(target.value);
      if (opt) {
        this.setState({
          PacingTypeText: target.value,
          PacingType: opt.value,
        });
      }
    };

    handleChangeLineItemTypeSelect = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const type = CAMPAIGN_TYPES.find((t) => {
        return t.label === target.value;
      });
      if (type) {
        this.setState({
          CampaignType: type.value,
        });
      }
    };

    handleCloseCreativeDialog = (saveCampaign: boolean) => {
      this.setState(
        {
          openCreativeFlightDateModal: false,
          openReactivateBiddersModal: false,
          // we want to ignore this modal popup if we want to save
          ignoreInvalidCreativeDates: saveCampaign,
          ignoreReactivateBidders: saveCampaign,
        },
        () => {
          if (saveCampaign) {
            this.saveCampaign();
          }
        },
      );
    };

    // adds "selected" to the creativeFlightModalItems in the modal
    handleSelectionChangeCreativesModal = (rows: any, dialog: string) => {
      if (dialog === FLIGHT_DATES) {
        const creativeFlightModalItems = cloneDeep(this.state.creativeFlightModalItems);
        for (const row of rows) {
          const rowID = row.ID.toString();
          for (let i = 0; i < creativeFlightModalItems.length; i++) {
            if (rowID === creativeFlightModalItems[i].ID && i !== 0) {
              creativeFlightModalItems[i] = row;
            }
          }
        }
        // don't uncheck the line item row
        if (creativeFlightModalItems.length > 0) {
          creativeFlightModalItems[0].tableData.checked = true;
        }
        this.setState({
          creativeFlightModalItems,
        });
      } else {
        const inactiveBiddersTargetingCampaign = cloneDeep(
          this.state.inactiveBiddersTargetingCampaign,
        );
        for (const row of rows) {
          const rowID = row.ID.toString();
          for (let i = 0; i < inactiveBiddersTargetingCampaign.length; i++) {
            if (rowID === inactiveBiddersTargetingCampaign[i].ID) {
              inactiveBiddersTargetingCampaign[i] = row;
            }
          }
        }

        this.setState({
          inactiveBiddersTargetingCampaign,
        });
      }
    };

    // copies the line item start and end dates to the selected creatives
    // in the creative flight date modal
    handleSelectionCopyFlightDates = () => {
      const selectedCreativeIDs = [] as string[];
      for (let i = 0; i < this.state.creativeFlightModalItems.length; i++) {
        // skip the selected creative that represents the line item
        const creative = this.state.creativeFlightModalItems[i];
        if (creative.tableData.checked && i !== 0) {
          selectedCreativeIDs.push(creative.ID);
        }
      }

      if (!this.state.dateStart || !this.state.dateEnd) {
        const errorMessages: string[] = [];
        if (!this.state.dateStart) {
          errorMessages.push('Please provide a start date');
        }
        if (!this.state.dateEnd) {
          errorMessages.push('Please provide an end date');
        }
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Cannot save: ' + errorMessages.join('. '),
        });
        return;
      }

      const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
      for (const creative of AdserverCreatives) {
        if (selectedCreativeIDs.includes(creative.ID)) {
          creative.StartDate = formatDateWithOffsetToUTC(this.state.dateStart, this.state.Timezone);
          creative.EndDate = formatDateWithOffsetToUTC(this.state.dateEnd, this.state.Timezone);
        }
      }

      this.setState(
        {
          openCreativeFlightDateModal: false,
          AdserverCreatives,
          ignoreInvalidCreativeDates: true,
        },
        this.saveCampaign,
      );
    };

    handleReactivateBidders = () => {
      const selectedBidderIDs = [] as string[];
      for (let i = 0; i < this.state.inactiveBiddersTargetingCampaign.length; i++) {
        const bidder = this.state.inactiveBiddersTargetingCampaign[i];
        if (bidder.tableData.checked) {
          selectedBidderIDs.push(bidder.ID);
        }
      }

      // 'reactivate' key triggers slack notification
      bulkUpdateBidders(
        selectedBidderIDs.join(','),
        this.props.session.publisher.ID,
        { Active: HeaderBidderActiveActive },
        'Active,reactivate',
      ).then(() => {
        this.setState(
          {
            openReactivateBiddersModal: false,
            ignoreReactivateBidders: true,
          },
          this.saveCampaign,
        );
      });
    };

    handleChangeAlias = (list: IAdserverAlias[]): void => {
      this.setState({
        Alias: list.length > 0 ? list[0].Name : '',
      });
    };

    handleGetUniqueLineItemAliases = (): void => {
      getUniqueLineItemAliases(this.props.session.publisher.ID).then((aliases) => {
        this.setState({
          uniqueLineItemAliases: aliases,
        });
      });
    };

    // generates the active tags for comma sep values for the accordions (i.e. 2 IDs, 4 Producers)
    // fieldValue represents the textfield (contentid1,contentid2,contentid3) and
    // fieldName represents the name to be shown (Content ID)
    // multi-accordion-panel will ignore an empty string active tag
    generateActiveTagForCommaSepField = (fieldValue: string, fieldName: string) => {
      if (fieldValue.length > 0) {
        // split the field and get rid of empty strings to count
        const count = fieldValue.split(',').filter((part: string) => part !== '').length;
        return count === 1 ? `1 ${fieldName}` : `${count} ${fieldName}s`;
      } else {
        return '';
      }
    };

    // Local Targeting Disallowed
    renderLocalTargetingAllowedPanel = () => {
      const writeAuthorization = this.getWriteCampaignAuthorization();
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={this.state.localTargetingAllowedParameters}
          LocalTargetingLogic={this.state.LocalTargetingAllowedLogic}
          localTargetingLogicFieldName='LocalTargetingAllowedLogic'
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed}
          addLocalTargetingParam={() => this.addLocalTargetingParam(true)}
          resourceName='Line Item'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(index: number, updates: object) =>
            this.updateLocalTargetingParam(true, index, updates)
          }
          deleteLocalTargetingParam={(index: number) => this.deleteLocalTargetingParam(true, index)}
          titleOverride={includedTitleOverride}
        />
      );
    };

    // Local Targeting Allowed
    renderLocalTargetingDisallowedPanel = () => {
      const writeAuthorization = this.getWriteCampaignAuthorization();
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={this.state.localTargetingDisallowedParameters}
          LocalTargetingLogic={this.state.LocalTargetingDisallowedLogic}
          localTargetingLogicFieldName='LocalTargetingDisallowedLogic'
          LocalTargetingIsAllowed={this.state.LocalTargetingIsAllowed}
          addLocalTargetingParam={() => this.addLocalTargetingParam(false)}
          resourceName='Line Item'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(index: number, updates: object) =>
            this.updateLocalTargetingParam(false, index, updates)
          }
          deleteLocalTargetingParam={(index: number) =>
            this.deleteLocalTargetingParam(false, index)
          }
          titleOverride={excludedTitleOverride}
        />
      );
    };

    renderDaypartingPanel = () => {
      const { DaypartingIntervals, DaypartingIsAllowed, enableViewerTimezone, isDaypartingActive } =
        this.state;

      const { classes } = this.props;

      return (
        <Grid style={{ width: '100%', padding: '20px' }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={0}>
            <Grid item xs={3}></Grid>
            <Grid item xs={9}>
              <Grid>
                <span className={classes.spanSubHeader}>
                  {isDaypartingActive ? 'Active' : 'Inactive'}
                  <Tooltip
                    title={
                      'Use dayparting to set days of the week and hours when you want this campaign to run. Adding multiple options will provide extra granularity.'
                    }
                  >
                    <InfoIcon
                      style={{
                        verticalAlign: 'center',
                        width: '1rem',
                        color: '#dedede',
                        marginLeft: '5px',
                      }}
                    />
                  </Tooltip>
                </span>
                <span className={classes.centeredSwitchNoLeftMargin}>
                  <Switch
                    className={classes.centeredSwitchNoLeftMargin}
                    checked={isDaypartingActive}
                    name='DaypartingActive'
                    onChange={this.handleChangeSwitch}
                    value={isDaypartingActive}
                    color='secondary'
                  />
                </span>
              </Grid>
              {isDaypartingActive && (
                <>
                  <Grid>
                    <span className={classes.spanSubHeader}>Logic</span>
                    <span className={classes.centeredSwitchNoLeftMargin}>
                      <span className={classes.spanActive}>
                        {DaypartingIsAllowed === EAllowStatus.ALLOW ? 'Include' : 'Exclude'}
                      </span>
                      <ConfirmationDialogButton
                        title='Dayparting Include/Exclude'
                        description={makeCampaignDaypartingTargetingChangeDescription(
                          DaypartingIsAllowed === EAllowStatus.ALLOW,
                        )}
                        triggerComponentInfo={makeTargetingChangeInfoHover(
                          DaypartingIsAllowed === EAllowStatus.ALLOW,
                        )}
                        acceptButtonTitle='Confirm'
                        acceptButtonCallBack={() =>
                          this.handleChange({
                            target: {
                              name: 'DaypartingIsAllowed',
                              value:
                                DaypartingIsAllowed === EAllowStatus.ALLOW
                                  ? EAllowStatus.DENY
                                  : (EAllowStatus.ALLOW as any),
                            },
                          } as any)
                        }
                        disabled={!this.getWriteCampaignAuthorization().isAuthorized}
                        refuseButtonTitle='Cancel'
                      >
                        <IconButton>
                          {DaypartingIsAllowed === EAllowStatus.ALLOW ? (
                            <CheckIcon style={{ color: publicaColors.green }} />
                          ) : (
                            <BlockIcon style={{ color: publicaColors.red }} />
                          )}
                        </IconButton>
                      </ConfirmationDialogButton>
                      <Grid style={{ width: '300px' }}>
                        {DaypartingIsAllowed === EAllowStatus.ALLOW ? (
                          <span style={{ fontSize: 10 }}>
                            Campaign <strong>will deliver </strong> during the selected hours and
                            days.
                          </span>
                        ) : (
                          <span style={{ fontSize: 10 }}>
                            Campaign <strong>will not deliver </strong> during the selected hours
                            and days.
                          </span>
                        )}
                      </Grid>
                    </span>
                  </Grid>
                  <Grid
                    style={{
                      display: 'inline-flex',
                      marginTop: '6px',
                      marginBottom: '6px',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span className={classes.spanSubHeader}>Timezone</span>
                    <Grid>
                      <PillSwitcher
                        currentText={daypartingTimezonesTypeToString(
                          enableViewerTimezone,
                          EDaypartingTimezonesType.LineItem,
                        )}
                        pills={DAYPARTING_TIMEZONES_PILLS}
                        customStyle={{ width: '170px', height: '40px', padding: '10px' }}
                        onChange={(value: string) => {
                          const enableViewerTimezone = daypartingTimezonesTypeToBoolean(value);
                          this.setState({
                            enableViewerTimezone,
                          });
                        }}
                      />
                    </Grid>
                    <Grid>
                      {enableViewerTimezone ? (
                        <span style={{ fontSize: 10, padding: '5px' }}>
                          Dayparting will adhere to the viewer's timezone using their{' '}
                          <strong>device location</strong>.
                        </span>
                      ) : (
                        <span style={{ fontSize: 10, padding: '5px' }}>
                          Dayparting will adhere to the timezone set for the line item.
                        </span>
                      )}
                    </Grid>
                  </Grid>
                  <Grid
                    style={{
                      display: 'inline-flex',
                      alignItems: 'flex-start',
                    }}
                  >
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'start',
                        width: 100,
                        fontSize: 15,
                      }}
                    >
                      Period
                    </span>
                    <DaypartingSelector
                      DaypartingIntervals={DaypartingIntervals}
                      handleDateChange={this.handleDaypartingDateChange}
                      handleDayClick={this.handleDayClick}
                      handleDeleteDaypartingPeriod={this.handleDeleteDaypartingPeriod}
                      handleAddDaypartingPeriod={this.handleAddDaypartingPeriod}
                      classes={classes}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // custom render for audience segment panel
    renderAudienceSegmentRow = () => {
      const { classes } = this.props;
      const writeAuthorization = IS_AUTHORIZED(['write_campaign'], this.props.user.user);
      const isActive =
        this.state.TargetingAudienceSegmentID.length &&
        this.state.TargetingAudienceSegmentID.split(',').length;
      return (
        <Grid item style={{ width: '100%', marginBottom: 5 }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Typography
                className={isActive ? classes.insideAccordionTextBold : classes.insideAccordionText}
              >
                Audience Segments
              </Typography>
            </Grid>
            {/* Grid for extra space/can be replaced with optional icon */}
            <Grid item xs={1}>
              <Tooltip title={'Not currently included in forecast'}>
                <img src='/assets/shared/svg/strikethrough_flag.svg' />
              </Tooltip>
            </Grid>
            <Grid item xs={1}>
              <ConfirmationDialogButton
                title='Targeting Change'
                description={makeTargetingChangeDescription(
                  this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY,
                )}
                triggerComponentInfo={makeTargetingChangeInfoHover(
                  this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY,
                )}
                acceptButtonTitle='Confirm'
                acceptButtonCallBack={() =>
                  this.handleChange({
                    target: {
                      name: 'TargetingAudienceSegmentIDIsAllowed',
                      value: reverseEAllowStatus(
                        this.state.TargetingAudienceSegmentIDIsAllowed,
                      ) as any,
                    },
                  } as any)
                }
                refuseButtonTitle='Cancel'
                disabled={!writeAuthorization.isAuthorized}
              >
                <IconButton>
                  {this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY ? (
                    <CheckIcon style={{ color: publicaColors.green }} />
                  ) : (
                    <BlockIcon style={{ color: publicaColors.red }} />
                  )}
                </IconButton>
              </ConfirmationDialogButton>
            </Grid>
            <Grid item xs={4}>
              <MaterialSearchDropdownMulti
                getValueFromSearchElement={(src: IListItem) => src.title}
                enableMultiSelect={true}
                selectAll={true}
                menuTitle='Audience Segments'
                list={this.getAudienceSegmentsAsItems()}
                disabled={!writeAuthorization.isAuthorized}
                onChange={(values: IMenuList) => {
                  this.setState({
                    TargetingAudienceSegmentID: Object.values(values)
                      .filter((src: IListItem) => {
                        return src.selected;
                      })
                      .map((src: IListItem) => src.ID)
                      .join(','),
                  });
                }}
                handleMenuAcceptClick={() => null}
                allowDenyLogicEnabled={true}
                isAllowedSelected={
                  this.state.TargetingAudienceSegmentIDIsAllowed !== EAllowStatus.DENY
                }
                onChangeAllowDenyToggle={(isAllowed: boolean) => {
                  this.setState({
                    TargetingAudienceSegmentIDIsAllowed: isAllowed
                      ? EAllowStatus.ALLOW
                      : EAllowStatus.DENY,
                  });
                }}
                isNoneSelectedAllSelected={false}
                helperText='Choose which audience segment to bid on.'
              />
            </Grid>
            <Grid item xs={3}>
              <FormControl component='fieldset'>
                <RadioGroup
                  row
                  aria-label='position'
                  name='SegmentTargeting'
                  defaultValue='top'
                  value={this.state.SegmentTargeting}
                  onChange={this.handleChange}
                >
                  <Tooltip title='Targeted request can be in any chosen segment'>
                    <FormControlLabel
                      disabled={!writeAuthorization.isAuthorized}
                      value={SegmentTargetingOR}
                      control={<Radio color='primary' size='small' />}
                      label={
                        <Typography className={this.props.classes.formControlLabel}>Or</Typography>
                      }
                      labelPlacement='top'
                    />
                  </Tooltip>
                  <Tooltip title='Targeted request must be in every chosen segment'>
                    <FormControlLabel
                      disabled={!writeAuthorization.isAuthorized}
                      value={SegmentTargetingAND}
                      control={<Radio color='primary' size='small' />}
                      label={
                        <Typography className={this.props.classes.formControlLabel}>And</Typography>
                      }
                      labelPlacement='top'
                    />
                  </Tooltip>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // custom render for contextual segment panel
    renderContextualSegmentRow = () => {
      const { classes } = this.props;
      const writeAuthorization = IS_AUTHORIZED(['write_campaign'], this.props.user.user);
      const isActive = this.state.ContextualSegmentIDS.length > 0;
      return (
        <Grid item style={{ width: '100%', marginBottom: 5 }}>
          <Grid container direction='row' justify='flex-start' alignItems='center' spacing={1}>
            <Grid item xs={3}>
              <Typography
                className={isActive ? classes.insideAccordionTextBold : classes.insideAccordionText}
              >
                Contextual Segment
              </Typography>
            </Grid>
            {/* Grid for extra space/can be replaced with optional icon */}
            <Grid item xs={1}>
              <Tooltip title={'Not currently included in forecast'}>
                <img src='/assets/shared/svg/strikethrough_flag.svg' />
              </Tooltip>
            </Grid>
            <Grid item xs={4}>
              <MaterialSearchDropdownMulti
                getValueFromSearchElement={(src: IListItem) => src.title}
                enableMultiSelect={false}
                selectLimit={1}
                menuTitle='Contextual Segments'
                list={this.state.contextualSegmentList}
                disabled={!writeAuthorization.isAuthorized}
                onChange={(contextualSegmentList: IMenuList) =>
                  this.setState({ contextualSegmentList })
                }
                handleMenuAcceptClick={this.handleContextualSegmentsAcceptClick}
                isNoneSelectedAllSelected={false}
                helperText='Choose which contextual segment to bid on.'
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // create mediafile from URL modal handlers
    handleCloseCreateMediafileModal = () => {
      this.setState({
        openCreateDialog: false,
      });
    };

    handleOpenCreateModal = (cidx: number, sgidx?: number) => {
      const creative =
        this.state.EnableFlightDateSubgroups === EBool.EBool_TRUE && sgidx !== undefined
          ? this.state.AdserverCreativeFlightDatesSubgroups[sgidx].AdserverCreatives[cidx]
          : this.state.AdserverCreatives[cidx];
      if (creative) {
        this.setState({
          openCreateDialog: true,
          newCreateURL: '',
          newCreateName: '',
          creativeIDForCreateModal: creative.ID,
        });
      }
    };

    handleOpenCreateCheckpointModal = (creativeID: string) => {
      this.setState({
        openCreateDialog: true,
        newCreateURL: '',
        newCreateName: '',
        creativeIDForCreateModal: creativeID,
      });
    };

    handleChangeBanner = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.name === 'newCreateBannerName') {
        this.setState({
          newCreateBannerName: target.value,
        });
      } else if (target.name === 'newCreateBannerURL') {
        this.setState({
          newCreateBannerURL: target.value,
        });
      }
    };

    handleOpenCreateBannerModal = (name?: string, url?: string, advertiserId?: number) => {
      this.setState({
        openCreateBannerDialog: true,
        newCreateBannerURL: url || '',
        newCreateBannerName: name || '',
        BannerAdvertiserID: advertiserId || 0,
      });
    };

    areCurrentCreativesAssets = (): boolean => {
      return this.state.CreativeType === CreativeTypeMediafile;
    };

    // determines if a new creative should be created for the mediafile before creating the mediafile
    handleCreateFromURL = () => {
      const { newCreateName, newCreateURL } = this.state;
      if (this.state.updating) {
        return;
      }
      // validations
      if (newCreateName.length === 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage: this.areCurrentCreativesAssets()
            ? 'Asset must have a name.'
            : 'VAST must have a name.',
        });
        return;
      } else if (newCreateURL.length === 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage: this.areCurrentCreativesAssets()
            ? 'Asset must have a URL.'
            : 'VAST must have a URL.',
        });
        return;
      } else if (isPBSDomain(newCreateURL)) {
        this.setState({
          snackbarError: true,
          snackbarMessage: this.areCurrentCreativesAssets()
            ? `Asset cannot target a domain with that root.`
            : `VAST cannot target a domain with that root.`,
        });
        return;
      }
      if (
        this.areCurrentCreativesAssets() &&
        !isValidBannerURL(newCreateURL) &&
        this.state.newCreateURL.indexOf('.mp4') === -1
      ) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Mediafile URL must end in .mp4, .jpg, .png, or .gif.',
        });
        return;
      }

      // upload mediafile requires that new creatives have the line item's ID since the mediafile also
      // requires the creative's ID, so it is required that the line item is saved first
      const isNewCampaign = isExistingCampaign(this.state);
      if (!isNewCampaign) {
        this.setState({
          snackbarMessage:
            'Please remove this creative and save the line item before uploading a new asset.',
          snackbarError: true,
        });
        return;
      }

      // if the creative is new, we need to create a new creative first so we have a creative ID
      const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
      let cidx = -1;
      const creative = AdserverCreatives.find((c: IAdserverCreative, i: number) => {
        if (c.ID === this.state.creativeIDForCreateModal) {
          cidx = i;
          return true;
        }
        return false;
      });
      if (creative && creative.ID === '0') {
        createCreative({
          query: {
            publisher_id: this.props.session.publisher.ID,
            creative,
          },
        })
          .then((creative: IAdserverCreative) => {
            // update the creative with its new id and also save it for mediafile creation
            AdserverCreatives[cidx].ID = creative.ID;
            AdserverCreatives[cidx].UUID = creative.UUID;
            AdserverCreatives[cidx].AdserverGlobalMediafileIDs = [];
            this.setState(
              {
                AdserverCreatives,
                creativeIDForCreateModal: creative.ID,
              },
              () => {
                this.createMediafileFromURL();
              },
            );
          })
          .catch(() => {
            this.setState({
              snackbarError: true,
              snackbarMessage: 'Error creating new creative for create mediafile from url.',
            });
          });
        return;
      }
      this.createMediafileFromURL();
    };

    // calls the api to create the mediafile and validate it, then adds it to the creative
    createMediafileFromURL = () => {
      this.setState(
        {
          updating: true,
        },
        () => {
          if (this.areCurrentCreativesAssets()) {
            // MEDIAFILE
            createMediafileFromURL({
              query: {
                publisher_id: this.props.session.publisher.ID,
                name: this.state.newCreateName,
                url: this.state.newCreateURL,
                creative_id: this.state.creativeIDForCreateModal,
                advertiser_id: 0,
              },
            })
              .then((mf: IAdserverGlobalMediafile) => {
                // push the new mediafile in and assign it to the creative
                const GlobalMediafiles = cloneDeep(this.state.GlobalMediaFiles);
                const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
                GlobalMediafiles.push(mf);
                for (const creative of AdserverCreatives) {
                  if (creative.ID === this.state.creativeIDForCreateModal) {
                    creative.AdserverGlobalMediafileIDs.push(mf.ID);
                  }
                }

                this.setState(
                  {
                    updating: false,
                    GlobalMediafiles,
                    AdserverCreatives,
                    openCreateDialog: false,
                    snackbarMessage: 'Successfully created asset from URL',
                  },
                  this.fetchGlobalMediaFilesAndVasts,
                );
              })
              .catch((error: any) => {
                this.setState({
                  updating: false,
                  openCreateDialog: false,
                  snackbarMessage: `Failed to create asset from URL: ${error}`,
                  snackbarError: true,
                });
              });
          } else {
            // VAST
            const { newCreateName, newCreateURL } = this.state;
            const vast = {
              ID: 0,
              PublisherID: parseInt(this.props.session.publisher.ID, 10),
              URL: newCreateURL,
              Name: newCreateName,
              AdserverCreatives: [],
              CampaignIDS: [],
              UpdatedAt: '',
              AdvertiserID: 0,
            } as IAdserverGlobalVast;

            createGlobalVast(
              vast,
              this.props.session.publisher.ID,
              this.state.creativeIDForCreateModal,
            )
              .then((resp) => {
                let updatedCreative = {} as IAdserverCreative;
                if (resp && resp.parsedBody) {
                  // swap out the updated creative in state
                  updatedCreative = (resp.parsedBody as ICreateGlobalVastResponse).AdserverCreative;
                  updatedCreative.AdserverGlobalMediafileIDs = [];
                  const AdserverCreatives = cloneDeep(this.state.AdserverCreatives);
                  for (let i = 0; i < AdserverCreatives.length; i++) {
                    if (AdserverCreatives[i].ID === this.state.creativeIDForCreateModal) {
                      AdserverCreatives[i] = updatedCreative;
                    }
                  }
                  this.setState(
                    {
                      AdserverCreatives,
                      updating: false,
                      openCreateDialog: false,
                      snackbarMessage: 'Successfully created VAST from URL',
                    },
                    this.fetchGlobalMediaFilesAndVasts,
                  );
                } else {
                  this.setState({
                    updating: false,
                    openCreateDialog: false,
                    snackbarMessage: 'Failed to parse response.',
                  });
                }
              })
              .catch(() => {
                this.setState({
                  updating: false,
                  openCreateDialog: false,
                  snackbarMessage: `Failed to create VAST from URL`,
                  snackbarError: true,
                });
              });
          }
        },
      );
    };

    // handles changes to a material search dropdown list
    handleChangeList = (name: string) => {
      if (name === 'TargetingDevices') {
        return (values: IMenuList) => {
          const selectedDevices = Object.values(values).filter((src: IListItem) => src.selected);
          let TargetingDevices = '0';
          // if all or no devices are selected, return '0' as the value, otherwise join the values
          if (
            selectedDevices.length !==
              Object.keys(getDeviceEnvironmentAsItems(this.state.TargetingDevices)).length ||
            selectedDevices.length === 0
          ) {
            TargetingDevices = selectedDevices.map((src: IListItem) => src.ID).join(',');
          }
          this.setState({
            TargetingDevices,
          });
        };
      } else if (name === 'TargetingDeviceSubTypes') {
        return (values: IMenuList) => {
          const selectedDeviceSubTypes = Object.values(values).filter(
            (src: IListItem) => src.selected,
          );
          let TargetingDeviceSubTypes = '0';
          // if all or no devices are selected, return '0' as the value, otherwise join the values
          if (
            selectedDeviceSubTypes.length !==
              Object.keys(
                getDeviceEnvironmentSubTypesAsItems(
                  this.state.TargetingDeviceSubTypes,
                  this.props.session.publisher.ID,
                  hasRoleSuperUser(this.props.user.user),
                ),
              ).length ||
            selectedDeviceSubTypes.length === 0
          ) {
            TargetingDeviceSubTypes = selectedDeviceSubTypes
              .map((src: IListItem) => src.ID)
              .join(',');
          }
          this.setState({
            TargetingDeviceSubTypes,
          });
        };
      } else if (name === 'TargetingDeviceModels') {
        return (values: IMenuList) => {
          const selectedDeviceModels = Object.values(values).filter(
            (src: IListItem) => src.selected,
          );
          let TargetingDeviceModels = '0';
          // if all or no devices are selected, return '0' as the value, otherwise join the values
          if (
            selectedDeviceModels.length !==
              Object.keys(
                getDeviceEnvironmentModelsAsItems(
                  this.state.TargetingDeviceModels,
                  this.props.session.publisher.ID,
                  hasRoleSuperUser(this.props.user.user),
                ),
              ).length ||
            selectedDeviceModels.length === 0
          ) {
            TargetingDeviceModels = selectedDeviceModels.map((src: IListItem) => src.ID).join(',');
          }
          this.setState({
            TargetingDeviceModels,
          });
        };
      } else if (name === 'editChannelListsList') {
        return (menuList: IMenuList) => {
          let editChannelListName = '';
          let editChannelListID: number = 0;
          const EditChannelListChannelsIDS = [] as number[];
          const EditChannelListGroupsIDS = [] as number[];
          const { editChannelListChannelGroups, editChannelListChannels } = this.state;
          Object.values(menuList).forEach((listItem: IListItem) => {
            if (listItem.selected) {
              editChannelListID = parseInt(listItem.ID, 10);
            }
          });
          const clonedChannelLists = cloneDeep(this.state.channelLists);
          const foundChannelList = clonedChannelLists.find(
            (channelList: IChannelList) =>
              channelList.ID.toString() === editChannelListID.toString(),
          );
          if (foundChannelList !== undefined) {
            const ChannelGroupIDs: number[] =
              foundChannelList.ChannelGroupIDs.split(',').map(Number);
            const ChannelIDs: number[] = foundChannelList.ChannelIDs.split(',').map(Number);
            Object.values(editChannelListChannelGroups).forEach((listItem: IListItem) => {
              if (ChannelGroupIDs.includes(parseInt(listItem.ID, 10))) {
                listItem.selected = true;
                EditChannelListGroupsIDS.push(parseInt(listItem.ID, 10));
              } else {
                listItem.selected = false;
              }
            });
            Object.values(editChannelListChannels).forEach((listItem: IListItem) => {
              if (ChannelIDs.includes(parseInt(listItem.ID, 10))) {
                listItem.selected = true;
                EditChannelListChannelsIDS.push(parseInt(listItem.ID, 10));
              } else {
                listItem.selected = false;
              }
            });
            editChannelListName = foundChannelList.Name;
          }
          this.setState({
            editChannelListsList: menuList,
            editChannelListID,
            editChannelListName,
            editChannelListChannels,
            editChannelListChannelGroups,
            EditChannelListChannelsIDS,
            EditChannelListGroupsIDS,
          });
        };
      }
      return (list: IMenuList) => {
        this.setState(
          Object.assign({
            [name]: list,
          }),
        );
      };
    };

    doesFlightDateCheckpointOverlap = (index: number): boolean => {
      const checkpoint = cloneDeep(this.state.FlightDateCheckpoints[index]);
      const startDateToCheck = formatDateFromUTCToOffset(
        checkpoint.StartDate,
        this.state.Timezone || this.props.session.publisher.Timezone,
      );
      const endDateToCheck = formatDateFromUTCToOffset(
        checkpoint.EndDate,
        this.state.Timezone || this.props.session.publisher.Timezone,
      );
      const allOtherCheckpoints = cloneDeep(this.state.FlightDateCheckpoints);
      allOtherCheckpoints.splice(index, 1);

      for (const flightDate of allOtherCheckpoints) {
        const startDate = formatDateFromUTCToOffset(
          flightDate.StartDate,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
        const endDate = formatDateFromUTCToOffset(
          flightDate.EndDate,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
        if (
          startDateToCheck.isBetween(startDate, endDate, 'minute', '()') ||
          endDateToCheck.isBetween(startDate, endDate, 'minute', '()')
        ) {
          return true;
        }
      }

      return false;
    };

    isValidCheckpointQuantity = (index: number): boolean => {
      if (!this.state.CRONQuantityCount) {
        return true;
      }

      let totalExpectedImpressions = 0;
      for (let i = 0; i <= index; i++) {
        totalExpectedImpressions += this.state.FlightDateCheckpoints[i].Quantity;
      }

      if (totalExpectedImpressions > parseInt(this.state.CRONQuantityCount, 10)) {
        return true;
      }

      return false;
    };

    // runs as a set state callback whenever there are changes to the line item flight dates or the checkpoints
    // creates error messages for the checkpoints
    validateFlightDateCheckpoints = (): void => {
      // sort the flight date checkpoints by end date, the order matters since we use the previous checkpoint to check each one
      const FlightDateCheckpoints = cloneDeep(this.state.FlightDateCheckpoints);
      FlightDateCheckpoints.sort((a, b) => {
        const endA = formatDateFromUTCToOffset(
          a.EndDate,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
        const endB = formatDateFromUTCToOffset(
          b.EndDate,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
        return endA.isBefore(endB) ? -1 : 1;
      });

      this.setState(
        {
          FlightDateCheckpoints,
        },
        () => {
          for (let index = 0; index < FlightDateCheckpoints.length; index++) {
            let errors = '';
            const start = formatDateFromUTCToOffset(
              FlightDateCheckpoints[index].StartDate,
              this.state.Timezone || this.props.session.publisher.Timezone,
            );
            const end = formatDateFromUTCToOffset(
              FlightDateCheckpoints[index].EndDate,
              this.state.Timezone || this.props.session.publisher.Timezone,
            );

            if (!end || !start) {
              errors += 'Checkpoints must have start and end date. ';
            } else {
              if (this.doesFlightDateCheckpointOverlap(index)) {
                errors += 'Checkpoints cannot overlap. ';
              }
              if (start && start.isBefore(this.state.dateStart, 'minute')) {
                errors +=
                  'Checkpoint start date must be the same or after the line item start date. ';
              }
              if (end && end.isAfter(this.state.dateEnd)) {
                errors += 'Checkpoint end date must be same or before the line item end date. ';
              }
              if (start && end && end.isBefore(start, 'minute')) {
                errors +=
                  'Checkpoint end date must be after or same as previous checkpoint start date. ';
              }
              if (FlightDateCheckpoints[index].Quantity === 0) {
                errors += 'Checkpoint quantity cannot be 0. ';
              }
              if (end && end.isAfter(moment()) && !this.isValidCheckpointQuantity(index)) {
                errors +=
                  'Checkpoint quantity plus the sum of previous checkpoint quantities must be less than impressions delivered. ';
              }
            }
            if (FlightDateCheckpoints[index].Name === '') {
              errors += 'Checkpoints must have a name. ';
            }
            FlightDateCheckpoints[index].errors = errors;
          }

          this.setState({
            FlightDateCheckpoints,
          });
        },
      );
    };

    // runs as a set state callback whenever there are changes to the line item flight dates or the checkpoints
    // creates error messages for the checkpoints
    validateFlightDateCreativeCheckpoints = (
      creativeCheckpoints: IAdserverCreativeFlightDatesSubgroup[],
    ): void => {
      const timezone = this.getTimezone();
      const checkpointFlightDates = creativeCheckpoints.map(
        (checkpoint: IAdserverCreativeFlightDatesSubgroup) => ({
          startDate: formatDateFromUTCToOffset(checkpoint.StartDate, timezone),
          endDate: formatDateFromUTCToOffset(checkpoint.EndDate, timezone),
        }),
      );

      const doesFlightDateCreativeCheckpointOverlap = (index: number): boolean => {
        const { startDate, endDate } = checkpointFlightDates[index];
        for (let idx = 0; idx < checkpointFlightDates.length; idx++) {
          if (idx === index) continue;
          const currFlightDates = checkpointFlightDates[idx];
          if (
            startDate.isBetween(
              currFlightDates.startDate,
              currFlightDates.endDate,
              'minute',
              '()',
            ) ||
            endDate.isBetween(currFlightDates.startDate, currFlightDates.endDate, 'minute', '()')
          ) {
            return true;
          }
        }
        return false;
      };

      for (let index = 0; index < checkpointFlightDates.length; index++) {
        let errors = '';
        const { startDate, endDate } = checkpointFlightDates[index];
        if (!endDate || !startDate) {
          errors += 'Checkpoints must have start and end date. ';
        } else {
          if (doesFlightDateCreativeCheckpointOverlap(index)) {
            errors += 'Checkpoints cannot overlap. ';
          }
          if (startDate && startDate.isBefore(this.state.dateStart, 'minute')) {
            errors += 'Checkpoint start date must be the same or after the line item start date. ';
          }
          if (endDate && endDate.isAfter(this.state.dateEnd)) {
            errors += 'Checkpoint end date must be same or before the line item end date. ';
          }
          if (startDate && endDate && endDate.isBefore(startDate, 'minute')) {
            errors +=
              'Checkpoint end date must be after or same as previous checkpoint start date. ';
          }
        }
        creativeCheckpoints[index].errors = errors.trim();
      }

      this.setState({
        AdserverCreativeFlightDatesSubgroups: creativeCheckpoints,
      });
    };

    handleChangeCheckpointDates = ({ start, end }: IDateRangeChangeEvent, index: number) => {
      const FlightDateCheckpoints = cloneDeep(this.state.FlightDateCheckpoints);
      if (start !== undefined) {
        FlightDateCheckpoints[index].StartDate = formatDateWithOffsetToUTC(
          start.second(0),
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      } else {
        FlightDateCheckpoints[index].StartDate = 'null';
      }
      if (end !== undefined) {
        FlightDateCheckpoints[index].EndDate = formatDateWithOffsetToUTC(
          end.second(0),
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      } else {
        FlightDateCheckpoints[index].EndDate = 'null';
      }
      this.setState(
        {
          FlightDateCheckpoints,
        },
        this.validateFlightDateCheckpoints,
      );
    };

    // when adding a new checkpoint, the start date should be the same as the line item start date OR the previous checkpoint's end date
    // the checkpoint's new end date should be 1 week from the last checkpoint's end date OR line item's start date
    // if this new end date is past the line item's end date, the new end date should be the line item's end date
    handleAddCheckpoint = () => {
      const LineItemEndDate = formatDateFromUTCToOffset(
        this.state.EndDate,
        this.state.Timezone || this.props.session.publisher.Timezone,
      );
      const today = getToday(this.state.Timezone || this.props.session.publisher.Timezone);

      // if an user attempt to add a checkpoint while the line item's end date is in the past, a snackbar error message will show up.
      if (LineItemEndDate.isBefore(today)) {
        this.setState({
          snackbarError: true,
          snackbarMessage:
            'Line item flight date is in the past, please first update the line item flight date before adding a checkpoint',
        });
        return;
      }

      const FlightDateCheckpoints = cloneDeep(this.state.FlightDateCheckpoints);
      const tomorrow = getFutureStartDate(
        this.state.Timezone || this.props.session.publisher.Timezone,
      );
      let StartDate = '';
      if (FlightDateCheckpoints.length > 0) {
        // if the last checkpoint's end date is before today+1, then the new checkpoint should be today+1
        if (
          formatDateFromUTCToOffset(
            FlightDateCheckpoints[FlightDateCheckpoints.length - 1].EndDate,
            this.state.Timezone || this.props.session.publisher.Timezone,
          ).isSameOrBefore(tomorrow)
        ) {
          StartDate = formatDateWithOffsetToUTC(
            tomorrow,
            this.state.Timezone || this.props.session.publisher.Timezone,
          );
        } else {
          const newCheckpointStartDate = formatDateFromUTCToOffset(
            FlightDateCheckpoints[FlightDateCheckpoints.length - 1].EndDate,
            this.state.Timezone || this.props.session.publisher.Timezone,
          ).add(1, 'minute');
          StartDate = formatDateWithOffsetToUTC(
            newCheckpointStartDate,
            this.state.Timezone || this.props.session.publisher.Timezone,
          );
        }
      } else if (this.state.StartDate) {
        if (
          formatDateFromUTCToOffset(
            this.state.StartDate,
            this.state.Timezone || this.props.session.publisher.Timezone,
          ).isSameOrBefore(today)
        ) {
          StartDate = formatDateWithOffsetToUTC(
            tomorrow,
            this.state.Timezone || this.props.session.publisher.Timezone,
          );
        } else {
          StartDate = this.state.StartDate;
        }
      }
      const newStartDate = formatDateFromUTCToOffset(
        StartDate,
        this.state.Timezone || this.props.session.publisher.Timezone,
      );

      let EndDate = '';
      let newEndDate = formatDateFromUTCToOffset(
        StartDate,
        this.state.Timezone || this.props.session.publisher.Timezone,
      )
        .add(1, 'week')
        .subtract(1, 'minute');

      // the new checkpoint end date should be whichever comes first: one week or the line items end date
      if (this.state.dateEnd && newEndDate.isSameOrBefore(this.state.dateEnd)) {
        EndDate = formatDateWithOffsetToUTC(
          newEndDate,
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      } else if (this.state.EndDate && this.state.dateEnd) {
        EndDate = this.state.EndDate;
        newEndDate = cloneDeep(this.state.dateEnd);
      }

      if (newStartDate.isSameOrAfter(newEndDate, 'minute')) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'No more time is available in line item flight, cannot add checkpoint',
        });
        return;
      }

      FlightDateCheckpoints.push({
        ID: 0,
        AdserverCampaignID: 0,
        StartDate,
        EndDate,
        Quantity: 0,
        Name: `Checkpoint ${FlightDateCheckpoints.length + 1}`,
        errors: '',
      });

      this.setState(
        {
          FlightDateCheckpoints,
        },
        this.validateFlightDateCheckpoints,
      );
    };

    handleDeleteFlightDateCheckpoint = (index: number) => {
      const FlightDateCheckpoints = cloneDeep(this.state.FlightDateCheckpoints);

      FlightDateCheckpoints.splice(index, 1);

      this.setState(
        {
          FlightDateCheckpoints,
        },
        this.validateFlightDateCheckpoints,
      );
    };

    handleChangeCheckpoint = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const FlightDateCheckpoints = cloneDeep(this.state.FlightDateCheckpoints);
      if (e.target.name === 'Name') {
        FlightDateCheckpoints[index].Name = e.target.value;
      } else if (e.target.name === 'Quantity') {
        let value = parseInt(e.target.value, 10);
        if (e.target.value === '') {
          value = 0;
        } else if (Number.isNaN(value)) {
          return;
        }
        FlightDateCheckpoints[index].Quantity = value;
      }
      this.setState(
        {
          FlightDateCheckpoints,
          Quantity: FlightDateCheckpoints.map((c) => c.Quantity)
            .reduce((prev, curr) => prev + curr)
            .toString(),
        },
        this.validateFlightDateCheckpoints,
      );
    };

    // [LocalTargeting] updateLocalTargetingParam handles type or value change for local targeting params
    updateLocalTargetingParam = (allowed: boolean, index: number, updates: object) => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            [index]: {
              $set: { ...this.state.localTargetingAllowedParameters[index], ...updates },
            },
          }),
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              [index]: {
                $set: { ...this.state.localTargetingDisallowedParameters[index], ...updates },
              },
            },
          ),
        });
      }
    };

    // [LocalTargeting] deleteLocalTargetingParam handles deleting a local targeting param
    deleteLocalTargetingParam = (allowed: boolean, index: number) => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            $splice: [[index, 1]],
          }),
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              $splice: [[index, 1]],
            },
          ),
        });
      }
    };

    // [LocalTargeting] addLocalTargetingParam handles adding a new local targeting param
    addLocalTargetingParam = (allowed: boolean) => {
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: update(this.state.localTargetingAllowedParameters, {
            $push: [
              {
                type: 'country',
                country: '',
                states: '',
                cities: '',
                zips: '',
                dmas: '',
                isInputInCommaSeparatedMode: false,
              } as ILocalTargetingParameter,
            ],
          }),
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: update(
            this.state.localTargetingDisallowedParameters,
            {
              $push: [
                {
                  type: 'country',
                  country: '',
                  states: '',
                  cities: '',
                  zips: '',
                  dmas: '',
                  isInputInCommaSeparatedMode: false,
                } as ILocalTargetingParameter,
              ],
            },
          ),
        });
      }
    };

    // [LocalTargeting] exportLocalTargetingParamToJSON exports all the local targeting params to a json string
    exportLocalTargetingParamToJSON = (allowed: boolean): string => {
      const params = allowed
        ? this.state.localTargetingAllowedParameters
        : this.state.localTargetingDisallowedParameters;
      const filteredList = exportLocalTargetingToJSON(params);
      return JSON.stringify(filteredList);
    };

    // [LocalTargeting] importLocalTargetingParamFromJSON imports JSON to local targeting params
    importLocalTargetingParamFromJSON = (allowed: boolean, inputJSON: string): void => {
      if (inputJSON === undefined || inputJSON.length === 0) {
        return;
      }
      let localParams: ILocalTargetingParameter[] = [];
      try {
        localParams = (JSON.parse(inputJSON) as object[]).map((o: ILocalTargetingParameter) => ({
          ...o,
          currentValue: '',
        }));
      } catch (e) {
        // Ignore JSON parse errors
      }
      if (allowed) {
        this.setState({
          localTargetingAllowedParameters: localParams,
        });
      } else {
        this.setState({
          localTargetingDisallowedParameters: localParams,
        });
      }
    };

    renderDisableLowPacingDialog = (): JSX.Element => {
      return (
        <Dialog
          open={this.state.openDisableLowPacingDialog}
          onClose={() => {
            this.setState({
              openDisableLowPacingDialog: false,
            });
          }}
        >
          <DialogTitle>Disable Low Pacing Confirmation</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please note that turning off Low pacing may result in your campaign to over pace in
              case of a spike in requests.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({
                  openDisableLowPacingDialog: false,
                });
              }}
              color='primary'
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                this.setState({
                  openDisableLowPacingDialog: false,
                  DisableLowPacing: EBool.EBool_TRUE,
                });
              }}
              color='primary'
              autoFocus
            >
              Turn Off Low Pacing
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderServerRightAwayPacingDialog = () => {
      return (
        <Dialog
          open={this.state.openServeRightAwayDialog}
          onClose={() => {
            this.setState({
              openServeRightAwayDialog: false,
            });
          }}
        >
          <DialogTitle>{'Enable Serve Right Away Pacing Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please note that turning on Start Serving Without Pacing Data may result in your
              campaign to over pace in case of a spike in requests, especially at the start of the
              campaign.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                this.setState({
                  openServeRightAwayDialog: false,
                });
              }}
              color='primary'
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                this.setState({
                  openServeRightAwayDialog: false,
                  ServeRightAway: EBool.EBool_TRUE,
                });
              }}
              color='primary'
              autoFocus
            >
              Turn ON Serve Right Away
            </Button>
          </DialogActions>
        </Dialog>
      );
    };

    renderExchangeAdornment = (value: string) => {
      const currencySymbol = convertECurrencyTypeToSymbol(
        this.props.session.publisher.CurrencyDisplayed,
      );
      if (value === undefined || value === '' || currencySymbol === '$') {
        return <></>;
      }

      return (
        <InputAdornment position='end'>
          {`${currencySymbol} ${(
            parseFloat(value.replace(/,/g, '')) *
            this.props.session.publisher.ExchangeRate.ExchangeValueToUSD
          ).toFixed(2)}`}
        </InputAdornment>
      );
    };

    renderCheckpoints = (classes: { [key: string]: string }, disableCheckpoints: boolean) => {
      const {
        CRONQuantityCount,
        dateEnd,
        FlightDateCheckpoints,
        FlightDateCheckpointsRolloverEnabled,
      } = this.state;

      const enableCheckpointsRollover = FlightDateCheckpointsRolloverEnabled === EBool.EBool_TRUE;
      return (
        <Grid>
          {
            <InputGridRow
              text='Rollover Impressions'
              infoIconText='If a checkpoint does not meet its impression goal, the remaining goal will rollover into the next checkpoint.'
              subRowNumber={1}
              style={{ marginTop: 20 }}
            >
              <span className={classes.spanActive}>
                {enableCheckpointsRollover ? 'Active' : 'Inactive'}
              </span>
              <Tooltip
                title={
                  disableCheckpoints
                    ? 'Checkpoints Rollover cannot be toggled once the line item has started serving impressions'
                    : ''
                }
              >
                <Grid>
                  <Switch
                    disabled={disableCheckpoints}
                    className={classes.centeredSwitchNoLeftMargin}
                    checked={enableCheckpointsRollover}
                    name='FlightDateCheckpointsRolloverEnabled'
                    onChange={this.handleChangeSwitch}
                    color='secondary'
                  />
                </Grid>
              </Tooltip>
            </InputGridRow>
          }
          {FlightDateCheckpoints.map((checkpoint: IFlightDateCheckpoint, index: number) => {
            const checkpointDateStart = ['', 'null'].includes(checkpoint.StartDate)
              ? undefined
              : formatDateFromUTCToOffset(
                  checkpoint.StartDate,
                  this.state.Timezone || this.props.session.publisher.Timezone,
                );
            const checkpointDateEnd = ['', 'null'].includes(checkpoint.EndDate)
              ? undefined
              : formatDateFromUTCToOffset(
                  checkpoint.EndDate,
                  this.state.Timezone || this.props.session.publisher.Timezone,
                );
            // checkpoints in the past cannot be updated
            // active flight dates cannot change their start date or be deleted
            const isFlightDatePast =
              checkpointDateEnd && CRONQuantityCount !== '0'
                ? moment().isAfter(checkpointDateEnd)
                : false;
            const isFlightDateActive =
              this.state.ID === ''
                ? false
                : checkpointDateStart && checkpointDateEnd && CRONQuantityCount !== '0'
                ? moment().isBetween(checkpointDateStart, checkpointDateEnd)
                : false;
            const noWriteOrDatePast =
              !this.state.writeAuthorization.isAuthorized || isFlightDatePast;
            return (
              <InputGridRow subRowNumber={2} text={checkpoint.ID ? `ID ${checkpoint.ID}` : 'New'}>
                <Grid
                  container
                  direction='column'
                  style={{
                    padding: 15,
                    marginBottom: 20,
                    backgroundColor: '#F5F5F5',
                    borderRadius: 3,
                  }}
                >
                  <Grid item>
                    <Grid container direction='row' justify='space-between' alignItems='center'>
                      <Grid item>
                        <FocusedTextfield
                          fullWidth
                          multiline
                          label='Name'
                          name='Name'
                          value={checkpoint.Name}
                          onChange={(e) => this.handleChangeCheckpoint(e, index)}
                          style={{
                            marginLeft: '5px',
                            width: 250,
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <FocusedTextfield
                          fullWidth
                          multiline
                          label={`Imp. Goal (${
                            checkpoint.CRONQuantityCount ? checkpoint.CRONQuantityCount : 0
                          } served)`}
                          name='Quantity'
                          value={checkpoint.Quantity.toString()}
                          onChange={(e) => this.handleChangeCheckpoint(e, index)}
                          disabled={noWriteOrDatePast}
                          style={{
                            marginLeft: '5px',
                            width: 250,
                          }}
                        />
                      </Grid>
                      <Tooltip
                        title={
                          isFlightDatePast
                            ? 'Past checkpoints cannot be deleted'
                            : isFlightDateActive
                            ? 'Cannot delete active checkpoint'
                            : ''
                        }
                      >
                        <Grid item>
                          <DeleteIcon
                            style={{
                              cursor: 'pointer',
                              fill: deleteColor,
                            }}
                            onClick={() => {
                              if (
                                this.state.writeAuthorization.isAuthorized &&
                                !isFlightDateActive &&
                                !isFlightDatePast
                              ) {
                                this.handleDeleteFlightDateCheckpoint(index);
                              }
                            }}
                          />
                        </Grid>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Grid container direction='row' alignItems='center' justify='space-between'>
                      <Grid item className={`checkpoint-date-${index}`}>
                        <DateTimeRangeComponent
                          enableClearSelection={true}
                          disabled={noWriteOrDatePast}
                          disabledStart={isFlightDateActive}
                          timezone={this.getTimezone()}
                          minDate={moment()}
                          maxDate={dateEnd}
                          start={checkpointDateStart}
                          end={checkpointDateEnd}
                          // @ts-ignore
                          onChange={(e) => this.handleChangeCheckpointDates(e, index)}
                          openDirection={'up'}
                          enableSelectAll={!!this.props.campaign.ID}
                          enablePresets={true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {checkpoint.errors !== '' && (
                    <Grid item>
                      <Grid
                        container
                        direction='row'
                        alignItems='flex-start'
                        justify='space-between'
                      >
                        <Grid item>
                          <Typography style={{ fontSize: 11, color: 'red' }}>
                            {checkpoint.errors}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </InputGridRow>
            );
          })}
          <InputGridRow subRowNumber={2} text=''>
            <Button
              className={'pb-button-add-checkpoint'}
              style={{ color: '#5865E8', paddingLeft: 15, paddingRight: 15, marginTop: -15 }}
              onClick={this.handleAddCheckpoint}
            >
              + Add Checkpoint
            </Button>
          </InputGridRow>
        </Grid>
      );
    };

    renderDeliveryTab(classes: { [key: string]: string }) {
      const {
        CampaignType,
        CPM,
        CRONQuantityCount,
        dateEnd,
        dateStart,
        errors,
        FlightDateCheckpoints,
        FlightDateCheckpointsEnabled,
        FrequencyCaps,
        GrossCPM,
        EnableGrossCPM,
        GuaranteedDeliveryEnabled,
        ID,
        impressions,
        PacingTypeText,
        Quantity,
        SkipEnabled,
        SkipOffset,
        timezonesList,
        writeAuthorization,
      } = this.state;

      const { campaign, session } = this.props;
      // Net CPM and Gross CPM only available to Premion (HB-2214)
      const isPremion = this.props.session.publisher.ID === '788';
      const enableCheckpoints = FlightDateCheckpointsEnabled === EBool.EBool_TRUE;
      // we should only be able to enable checkpoints if the campaign has not start OR does not have impressions yet
      const disableCheckpoints =
        this.state.ID === '' || (this.state.dateStart && this.state.dateStart.isAfter(moment()))
          ? false
          : CRONQuantityCount !== '0';
      const lineItemFlightDatesSelected = !!dateEnd && !!dateStart;

      let quantityCount = Quantity;
      if (enableCheckpoints) {
        if (FlightDateCheckpoints.length > 0) {
          quantityCount = FlightDateCheckpoints.map((c) => c.Quantity)
            .reduce((prev, curr) => prev + curr)
            .toString();
        } else {
          quantityCount = '0';
        }
      }
      const impressionCountText =
        impressions || campaign.CRONQuantityCount
          ? `impressions (${(
              impressions || parseInt(campaign.CRONQuantityCount, 10)
            ).toLocaleString('en', { minimumFractionDigits: 0 })} delivered to date)`
          : 'impressions';

      return (
        <Grid item className={classes.mainGridItem}>
          <Grid container direction='column'>
            <Grid
              style={{
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                boxShadow: '0px 3px 6px #CBCBCB',
                borderRadius: bigRadius,
                opacity: '1',
                paddingLeft: '2%',
                paddingRight: '2%',
                marginBottom: '25px',
                minHeight: '50px',
                paddingTop: '20px',
              }}
            >
              <Grid>
                <Grid
                  className={classes.section}
                  style={{
                    marginBottom: '15px',
                  }}
                >
                  {this.isSuperUser && !!ID && this.renderDebugCampaignInfos()}
                  <InputGridRow text='Overview' children={undefined}></InputGridRow>
                  {/* Name */}
                  <InputGridRow text='Name' subRowNumber={1}>
                    <Grid item xs={8}>
                      <Typography>
                        {obfuscateAdserverCampaign(
                          this.state,
                          this.props.user.user.Username,
                          this.state.Name,
                        )}
                      </Typography>
                    </Grid>
                  </InputGridRow>
                  {/* Alias */}
                  <InputGridRow
                    text='Alias'
                    infoIconText='Creating an alias allows you to filter and group by that alias in reporting. NOTE: an alias cannot include commas'
                    subRowNumber={1}
                  >
                    <Grid xs={8}>
                      {
                        <div className={classes.optionRow}>
                          <MaterialLabelDropdownMulti
                            menuTitle='allows for one alias input'
                            list={this.state.uniqueLineItemAliases}
                            selected={
                              this.state.Alias && this.state.Alias.length > 0
                                ? [{ Name: this.state.Alias } as IAdserverAlias]
                                : []
                            }
                            disableMultiSelect={EBool.EBool_TRUE}
                            onChange={(list: IAdserverAlias[]) => {
                              this.handleChangeAlias(list);
                            }}
                          />
                        </div>
                      }
                    </Grid>
                  </InputGridRow>
                  {/* Line Item Type */}
                  <InputGridRow text='Line Item Type' subRowNumber={1}>
                    <TextField
                      fullWidth
                      label=''
                      select={true}
                      name='CampaignType'
                      value={getCampaignTextByType(CampaignType)}
                      onChange={this.handleChangeLineItemTypeSelect}
                      margin='normal'
                      style={{ width: '200px' }}
                    >
                      {CAMPAIGN_TYPES.map(({ label, value }) => {
                        return (
                          <MenuItem key={value} value={label}>
                            {label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </InputGridRow>
                  {/* Net CPM */}
                  <InputGridRow text='Net CPM' subRowNumber={1}>
                    <Grid style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      {EBool.isTrue(this.props.session.publisher.EnableOtherCurrency) ? (
                        <Grid>
                          <CurrencyConverter
                            className='pb-bidder-settings-form-view_textfield-bid-floor'
                            currencies={CurrencyDisplayedItem}
                            currency={
                              convertECurrencyTypeToString(this.state.CurrencyDisplayed) ||
                              CurrencyTypeUSD
                            }
                            isDisabled={!this.state.writeAuthorization.isAuthorized}
                            isErrored={!!errors.CPM}
                            onChange={({ uiPrice, uiCurrency }) =>
                              this.handleChangeCPMAndCurrency(uiPrice, uiCurrency)
                            }
                            price={CPM}
                            displayCurrencyLabel={false}
                          />
                        </Grid>
                      ) : (
                        <>
                          {'$'}
                          <FocusedTextfield
                            key='CPM'
                            fullWidth
                            multiline
                            label=''
                            name='CPM'
                            value={CPM}
                            onChange={this.handleChange}
                            style={{
                              marginLeft: '5px',
                              width: 60,
                            }}
                          />
                          {this.renderExchangeAdornment(CPM)}
                        </>
                      )}

                      <Grid item>
                        <Tooltip
                          title={'This is the CPM that will compete in the auction'}
                          placement='bottom-start'
                        >
                          <InfoIcon className={classes.infoIcon} />
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </InputGridRow>
                  <InputGridRow text='Enable Gross CPM' subRowNumber={1}>
                    <span className={classes.spanActive}>
                      {EnableGrossCPM === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                    </span>
                    <Switch
                      disabled={!writeAuthorization.isAuthorized}
                      className={classes.centeredSwitchNoLeftMargin}
                      checked={EnableGrossCPM === EBool.EBool_TRUE}
                      name='EnableGrossCPM'
                      onChange={this.handleChangeSwitch}
                      color='secondary'
                    />
                  </InputGridRow>

                  {/* Gross CPM  - Super User only until prebid changes are implemented (HB-2165)*/}
                  {EnableGrossCPM === EBool.EBool_TRUE && (
                    <InputGridRow
                      text={
                        isPublisherTegna(this.props.session.publisher.ID)
                          ? 'Gross CPM (Reporting CPM)'
                          : 'Gross CPM'
                      }
                      subRowNumber={1}
                    >
                      <Grid
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          width: '150px',
                          marginRight: '20px',
                        }}
                      >
                        {convertECurrencyTypeToSymbol(this.state.CurrencyDisplayed)}
                        <FocusedTextfield
                          key='GrossCPM'
                          fullWidth
                          multiline
                          label=''
                          name='GrossCPM'
                          value={GrossCPM}
                          onChange={this.handleChange}
                        />
                        <Grid item>
                          <Tooltip
                            title={
                              'The CPM will be used in reporting to reflect the publisher’s actual CPM on the line item'
                            }
                            placement='bottom-start'
                          >
                            <InfoIcon className={classes.infoIcon} />
                          </Tooltip>
                        </Grid>
                      </Grid>
                    </InputGridRow>
                  )}
                </Grid>

                <Grid
                  className={classes.section}
                  style={{
                    marginBottom: '15px',
                  }}
                >
                  <InputGridRow
                    text='Delivery Schedule'
                    style={{ marginTop: 35 }}
                    children={undefined}
                  />
                  {/* Flight Dates  */}
                  <InputGridRow
                    text='Flight Dates'
                    subRowNumber={1}
                    style={{ alignItems: 'center' }}
                  >
                    {/* <Grid item className='flight-date'> */}
                    <DateTimeRangeComponent
                      timezone={this.getTimezone()}
                      start={dateStart}
                      end={dateEnd}
                      onChange={this.handleDateChange}
                      enableSelectAll={!!this.props.campaign.ID}
                      enablePresets={true}
                      timezoneComponent={
                        <div style={{ padding: '16px 0 0 30px' }}>
                          <SearchDropdownSingle
                            menuTitle={'Timezone'}
                            list={timezonesList}
                            onChange={this.setStateCallback}
                            stateKey={'timezonesList'}
                            menuAcceptClickCallbacks={[]}
                            handleMenuAcceptClick={this.handleTimezoneAcceptClick}
                            style={{ width: 180 }}
                          />
                        </div>
                      }
                    />
                    {/* </Grid> */}
                  </InputGridRow>
                  {/* Impression Goal  */}
                  <InputGridRow text='Impression Goal' subRowNumber={1}>
                    <Tooltip
                      title={
                        enableCheckpoints ? 'Quantity set by sum of checkpoint quantities' : ''
                      }
                    >
                      <NumberFormat
                        label=''
                        name='Quantity'
                        value={quantityCount}
                        onChange={this.handleChange}
                        helperText={errors.Quantity}
                        error={!!errors.Quantity}
                        customInput={TextField}
                        thousandSeparator={true}
                        width={300}
                        disabled={enableCheckpoints}
                      />
                    </Tooltip>
                    {/* if we have queried the impressions, it is more accurate than the cron count but it should default to the CronQuantityCount for speed since the query is slow */}
                    <span className={classes.textCenteredSpan}>{impressionCountText}</span>
                  </InputGridRow>
                  {/* Checkpoints - line item's start and end must be selected  */}
                  <InputGridRow
                    text='Checkpoints'
                    infoIconText='Use checkpoints to sequence your delivery per desired periods of time and allocate impression goals per period'
                    subRowNumber={1}
                    style={{ marginTop: 20 }}
                  >
                    <span className={classes.spanActive}>
                      {enableCheckpoints ? 'Active' : 'Inactive'}
                    </span>
                    <Tooltip
                      title={
                        disableCheckpoints
                          ? 'Checkpoints cannot be toggled once the line item has started serving impressions'
                          : lineItemFlightDatesSelected
                          ? ''
                          : 'Line item start and end date must be selected'
                      }
                    >
                      <Grid>
                        <Switch
                          disabled={
                            !writeAuthorization.isAuthorized ||
                            !lineItemFlightDatesSelected ||
                            disableCheckpoints
                          }
                          className={classes.centeredSwitchNoLeftMargin}
                          checked={enableCheckpoints}
                          name='FlightDateCheckpointsEnabled'
                          onChange={this.handleChangeSwitch}
                          color='secondary'
                        />
                      </Grid>
                    </Tooltip>
                  </InputGridRow>
                  {/* Checkpoints - line item's start and end must be selected  */}
                  {enableCheckpoints &&
                    lineItemFlightDatesSelected &&
                    this.renderCheckpoints(classes, disableCheckpoints)}
                  {/* Category Exclusivity */}
                  <InputGridRow
                    text='Enforce Category Exclusivity'
                    infoIconText='Gives this Line Item the exclusive ability to serve ads within the categories defined in the Creatives tab.'
                    subRowNumber={1}
                  >
                    <Checkbox
                      checked={this.state.CategoryExclusivityEnabled === EBool.EBool_TRUE}
                      onChange={() =>
                        this.handleChangeEBool(
                          'CategoryExclusivityEnabled',
                          this.state.CategoryExclusivityEnabled,
                        )
                      }
                    />
                  </InputGridRow>
                </Grid>

                <Grid
                  className={classes.section}
                  style={{
                    marginBottom: '15px',
                  }}
                >
                  <InputGridRow
                    text='Delivery Options'
                    style={{ marginTop: 35 }}
                    children={undefined}
                  ></InputGridRow>
                  {/* Pacing  */}
                  <InputGridRow
                    text='Pacing'
                    infoIconText='Set the pacing mode will define how to deliver the impression goal within the flight defined above. For more details on the pacing options, please check our documentation.'
                    subRowNumber={1}
                  >
                    <TextField
                      fullWidth
                      label=''
                      select={true}
                      name='PacingType'
                      value={PacingTypeText}
                      onChange={this.handleChangePacingTypeSelect}
                      margin='normal'
                      style={{ width: '200px' }}
                    >
                      {pacingTypeOptions.map(({ text, value }) => {
                        return (
                          <MenuItem key={value} value={text}>
                            {text}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </InputGridRow>

                  {/* Enable Low Pacing  */}
                  <InputGridRow
                    text='Disable Low Pacing'
                    infoIconText='Disabling Low Pacing means that you are bypassing our low pacing algorithm that gauges incoming volumes for this campaign before ramping up and clicking into the selected pacing mode in order to better meet delivery goals.'
                    subRowNumber={1}
                  >
                    <span className={classes.spanActive}>
                      {EBool.isTrue(this.state.DisableLowPacing) ? 'Active' : 'Inactive'}
                    </span>
                    <Switch
                      disabled={!writeAuthorization.isAuthorized}
                      className={classes.centeredSwitchNoLeftMargin}
                      checked={EBool.isTrue(this.state.DisableLowPacing)}
                      name='DisableLowPacing'
                      onChange={() => {
                        if (EBool.toBool(this.state.DisableLowPacing)) {
                          this.setState({
                            DisableLowPacing: EBool.EBool_FALSE,
                          });
                        } else {
                          this.setState({
                            openDisableLowPacingDialog: true,
                          });
                        }
                      }}
                      value={EBool.toBool(this.state.DisableLowPacing)}
                      color='secondary'
                    />
                  </InputGridRow>
                  {/* Enable Serve Right Away  */}
                  {hasRoleSuperUser(this.props.user.user) && (
                    <InputGridRow
                      text='Start Serving Without Pacing Data *'
                      infoIconText='Defaulted to inactive. When active, the campaign will serve without historic pacing data for the first hour. When inactive, this option allows our algorithms to gauge incoming volumes for this campaign before ramping up and clicking into the selected pacing mode in order to better meet delivery goals.'
                      subRowNumber={1}
                    >
                      <span className={classes.spanActive}>
                        {this.state.ServeRightAway === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                      </span>
                      <Switch
                        disabled={!writeAuthorization.isAuthorized}
                        className={classes.centeredSwitchNoLeftMargin}
                        checked={EBool.toBool(this.state.ServeRightAway)}
                        name='ServeRightAway'
                        onChange={() => {
                          if (!EBool.toBool(this.state.ServeRightAway)) {
                            this.setState({
                              openServeRightAwayDialog: true,
                            });
                          } else {
                            this.setState({
                              ServeRightAway: EBool.EBool_FALSE,
                            });
                          }
                        }}
                        value={EBool.toBool(this.state.ServeRightAway)}
                        color='secondary'
                      />
                    </InputGridRow>
                  )}
                  {/* Guaranteed Delivery*/}
                  {
                    <InputGridRow
                      text='Guaranteed Delivery'
                      infoIconText='Use this option to prioritize the delivery of the campaign. When active, the bidder associated with this campaign will be automatically set to the next highest sub-tier within its tier to effectively guarantee delivery.'
                      subRowNumber={1}
                    >
                      <span className={classes.spanActive}>
                        {GuaranteedDeliveryEnabled === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                      </span>
                      <Grid>
                        <Switch
                          checked={GuaranteedDeliveryEnabled === EBool.EBool_TRUE}
                          className={classes.centeredSwitchNoLeftMargin}
                          color='secondary'
                          name='GuaranteedDeliveryEnabled'
                          onChange={this.handleChangeSwitch}
                        />
                      </Grid>
                    </InputGridRow>
                  }
                  {/* Ensure Slight Over-Delivery  */}
                  <InputGridRow
                    text='Ensure Slight Over-Delivery'
                    infoIconText='If activated, the campaign is set to marginally surpass 100% delivery to fully achieve the impressions goal.'
                    subRowNumber={1}
                  >
                    <span className={classes.spanActive}>
                      {this.state.EnableOverDelivery === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                    </span>
                    <Switch
                      disabled={!writeAuthorization.isAuthorized}
                      className={classes.centeredSwitchNoLeftMargin}
                      checked={EBool.toBool(this.state.EnableOverDelivery)}
                      name='EnableOverDelivery'
                      onChange={() => {
                        this.setState({
                          EnableOverDelivery: EBool.toBool(this.state.EnableOverDelivery)
                            ? EBool.EBool_FALSE
                            : EBool.EBool_TRUE,
                        });
                      }}
                      value={EBool.toBool(this.state.EnableOverDelivery)}
                      color='secondary'
                    />
                  </InputGridRow>
                  {/* Frequency Capping  */}
                  <InputGridRow
                    text='Frequency Capping'
                    infoIconText='Use frequency capping to define the viewer experience and set the exposure for this campaign over a given period of time.'
                    subRowNumber={1}
                  >
                    <Grid container direction='column' alignItems='flex-start'>
                      <Grid item>
                        {FrequencyCaps.map(
                          (frequencyCap: IFrequencyCap, frequencyCapIdx: number) => {
                            const frequencyTargetingKeys =
                              frequencyCap.FrequencyTargetingKey === FrequencyTargetingKey.DURATION
                                ? getFrequencyTargetingKeysForPublisher(session.publisher.ID)
                                : getFrequencyTargetingKeysWithoutDurationForPublisher(
                                    session.publisher.ID,
                                  );
                            return (
                              <Grid
                                container
                                direction='column'
                                style={{
                                  padding: 15,
                                  marginBottom: 20,
                                  backgroundColor: '#F5F5F5',
                                  borderRadius: 3,
                                }}
                              >
                                <Grid item style={{ display: 'flex', flexDirection: 'row' }}>
                                  <span
                                    className={classes.spanActive}
                                    style={{ padding: '20px 0 15px 0', margin: '5px 0' }}
                                  >
                                    {frequencyCap.Active === FrequencyCapActiveActive
                                      ? 'Active'
                                      : 'Inactive'}
                                  </span>

                                  <Grid item style={{ marginTop: 15, marginLeft: 18 }}>
                                    <Switch
                                      disabled={!writeAuthorization.isAuthorized}
                                      className={classes.centeredSwitchNoLeftMargin}
                                      checked={frequencyCap.Active === FrequencyCapActiveActive}
                                      onChange={(event) =>
                                        this.handleChangeFrequencyCap(
                                          event,
                                          'Switch',
                                          frequencyCapIdx,
                                        )
                                      }
                                      value={frequencyCap.Active}
                                      color='secondary'
                                    />
                                  </Grid>
                                  <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                                    <span style={{ marginTop: 25, fontWeight: 'bold' }}>
                                      Enforce by:
                                    </span>
                                    <Grid item style={{ margin: '20px 0 0 10px' }}>
                                      <Select
                                        disabled={
                                          frequencyCap.Active === FrequencyCapActiveInactive
                                        }
                                        name='FrequencyTrackingKey'
                                        onChange={(event: React.ChangeEvent<{ value: string }>) =>
                                          this.handleChangeFrequencyCap(
                                            event,
                                            'FrequencyTrackingKey',
                                            frequencyCapIdx,
                                          )
                                        }
                                        value={frequencyCap.FrequencyTrackingKey}
                                      >
                                        {FrequencyTrackingKeys.map((item, index) => {
                                          return (
                                            <MenuItem key={index} value={item.value}>
                                              {item.label}
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </Grid>
                                  </Grid>
                                  <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                                    <span style={{ marginTop: 25, fontWeight: 'bold' }}>
                                      Target by:
                                    </span>
                                    <Grid item style={{ margin: '20px 0 0 10px' }}>
                                      <Select
                                        disabled={
                                          frequencyCap.FrequencyTargetingKey ===
                                          FrequencyTargetingKey.DURATION
                                        }
                                        name='FrequencyTargetingKey'
                                        onChange={(event: React.ChangeEvent<{ value: string }>) =>
                                          this.handleChangeFrequencyCap(
                                            event,
                                            'FrequencyTargetingKey',
                                            frequencyCapIdx,
                                          )
                                        }
                                        value={frequencyCap.FrequencyTargetingKey}
                                      >
                                        {frequencyTargetingKeys.map((item, index) => {
                                          return (
                                            <MenuItem key={index} value={item.value}>
                                              {item.label}
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                                  <span
                                    className={classes.spanDescription}
                                    style={{ marginTop: 20 }}
                                  >
                                    Set limit to
                                  </span>

                                  <Grid item style={{ maxWidth: 75, marginTop: 5 }}>
                                    <FocusedTextfield
                                      label='Frequency'
                                      style={{ width: '100%' }}
                                      value={frequencyCap.Limit}
                                      disabled={frequencyCap.Active === FrequencyCapActiveInactive}
                                      onChange={(event) =>
                                        this.handleChangeFrequencyCap(
                                          event,
                                          'Limit',
                                          frequencyCapIdx,
                                        )
                                      }
                                    />
                                  </Grid>

                                  <span
                                    className={classes.spanDescription}
                                    style={{ marginTop: 20 }}
                                  >
                                    {frequencyCap.FrequencyTargetingKey ===
                                    FrequencyTargetingKey.IMPRESSION
                                      ? 'impressions'
                                      : frequencyCap.FrequencyTargetingKey ===
                                        FrequencyTargetingKey.DURATION
                                      ? 'seconds'
                                      : 'bids won'}{' '}
                                    per user per
                                  </span>

                                  <Grid item style={{ maxWidth: 75, marginTop: 5 }}>
                                    <FocusedTextfield
                                      label='Duration'
                                      style={{ width: '100%' }}
                                      value={frequencyCap.EditableDuration}
                                      disabled={frequencyCap.Active === FrequencyCapActiveInactive}
                                      onChange={(event) =>
                                        this.handleChangeFrequencyCap(
                                          event,
                                          'TimeToLive',
                                          frequencyCapIdx,
                                        )
                                      }
                                    />
                                  </Grid>

                                  <Grid item style={{ width: 75, margin: '10px 0 0 10px' }}>
                                    <Select
                                      style={{ width: 75 }}
                                      value={frequencyCap.DurationUnits || FrequencyCapUnitDays}
                                      disabled={frequencyCap.Active === FrequencyCapActiveInactive}
                                      onChange={(event: React.ChangeEvent<{ value: any }>) =>
                                        this.handleChangeFrequencyCap(
                                          event,
                                          'Unit',
                                          frequencyCapIdx,
                                        )
                                      }
                                    >
                                      <MenuItem
                                        key={FrequencyCapUnitHours}
                                        value={FrequencyCapUnitHours}
                                        style={{ width: '100%' }}
                                      >
                                        Hours
                                      </MenuItem>
                                      <MenuItem
                                        key={FrequencyCapUnitDays}
                                        value={FrequencyCapUnitDays}
                                        style={{ width: '100%' }}
                                      >
                                        Days
                                      </MenuItem>
                                    </Select>
                                  </Grid>

                                  {FrequencyCaps.length > 1 && (
                                    <Tooltip title='Delete'>
                                      <IconButton
                                        style={{
                                          margin: '5px 0',
                                          cursor: 'pointer',
                                          fill: deleteColor,
                                        }}
                                        aria-label='delete'
                                        onClick={() =>
                                          this.handleDeleteFrequencyCap(frequencyCapIdx)
                                        }
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                              </Grid>
                            );
                          },
                        )}
                      </Grid>
                      <Grid item>
                        <Button
                          style={{ color: '#5865E8', paddingLeft: 15, paddingRight: 15 }}
                          onClick={this.handleAddFrequencyCap}
                        >
                          + Add Frequency Cap
                        </Button>
                      </Grid>
                    </Grid>
                  </InputGridRow>
                  {/* Skip  */}
                  <InputGridRow
                    text='Skip'
                    infoIconText='Use skip to allow the viewer to skip the ad after a given duration defined with the offset, in seconds.'
                    subRowNumber={1}
                  >
                    <span className={classes.spanActive}>
                      {SkipEnabled === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                    </span>
                    <Switch
                      checked={SkipEnabled === EBool.EBool_TRUE}
                      className={classes.centeredSwitchNoLeftMargin}
                      color='secondary'
                      name='SkipEnabled'
                      onChange={this.handleChangeSwitch}
                    />
                  </InputGridRow>
                  {/* Skip Offset  */}
                  {SkipEnabled === EBool.EBool_TRUE && (
                    <InputGridRow text='Skip Offset' subRowNumber={1}>
                      <FocusedTextfield
                        enableIntegersOnly={true}
                        enableNumbersOnly={true}
                        enablePositiveValuesOnly={true}
                        key='SkipOffset'
                        multiline
                        label=''
                        name='SkipOffset'
                        value={SkipOffset}
                        onChange={this.handleChange}
                        style={{
                          width: 60,
                        }}
                      />
                    </InputGridRow>
                  )}
                  {/* Channel Weights Active */}
                  {(this.isSuperUser ||
                    this.props.session.publisher.ID === '788' ||
                    this.props.session.publisher.ID === '359') && (
                    <InputGridRow text='Channel Weights' subRowNumber={1}>
                      <span className={classes.spanActive}>
                        {this.state.SiteWeightsActive === EBool.EBool_TRUE ? 'Active' : 'Inactive'}
                      </span>
                      <Grid style={{ display: 'inline-block', marginTop: '6px' }}>
                        <Switch
                          className={classes.centeredSwitchNoLeftMargin}
                          checked={this.state.SiteWeightsActive === EBool.EBool_TRUE}
                          name='SiteWeightsActive'
                          onChange={this.handleChangeSwitch}
                          color='secondary'
                        />
                      </Grid>
                    </InputGridRow>
                  )}
                </Grid>
                {this.isSuperUser &&
                  this.props.session.publisher.LogSamplingEnabled === EBool.EBool_TRUE &&
                  this.state.ID !== '' && (
                    <Grid
                      className={classes.section}
                      style={{
                        marginBottom: '15px',
                      }}
                    >
                      <InputGridRow
                        text='Disable Sampling *'
                        style={{ marginTop: 35 }}
                        children={undefined}
                      ></InputGridRow>
                      <Grid container direction='column' style={{ paddingLeft: 27 }}>
                        <Grid item>
                          <TextField
                            label='Sampling Days Disabled'
                            name='disable sampling (max 8 days)'
                            style={{ width: '180px' }}
                            value={this.state.samplingPercentageDisabledUntilDays}
                            onChange={this.handleChangeSamplingDays}
                          />
                        </Grid>
                        <Grid item>
                          <Typography>
                            Sampling Disabled Until *: {this.state.SamplingPercentageDisabledUntil}
                          </Typography>
                          <Typography>
                            Sampling Percentage: {this.state.SamplingPercentage}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
              </Grid>
            </Grid>

            {this.renderDisableLowPacingDialog()}
            {this.renderServerRightAwayPacingDialog()}
          </Grid>
        </Grid>
      );
    }

    deleteCountryGroupFunc = (countryGroupID: string, reloadBidder: boolean) => {
      const { publisherCountryGroups, targetingCountryGroupList } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      if (foundCountryGroup) {
        const clonedPublisherCountryGroups = cloneDeep(publisherCountryGroups);
        const filteredPublisherCountryGroups = clonedPublisherCountryGroups.filter(
          (countryGroup) => countryGroup.ID !== foundCountryGroup.ID,
        );

        const clonedTargetingCountryGroupList = cloneDeep(targetingCountryGroupList);
        delete clonedTargetingCountryGroupList[foundCountryGroup.ID];

        deleteCountryGroup(foundCountryGroup).then(() => {
          this.setState(
            {
              openRegionCreateEditDialog: false,
              openRegionSelectTable: false,
              publisherCountryGroups: filteredPublisherCountryGroups,
              targetingCountryGroupList: clonedTargetingCountryGroupList,
              updatingCountryGroup: false,
              snackbarMessage: 'Sucessfully deleted country group',
              snackbarError: false,
            },
            reloadBidder ? this.getCountryGroupsByPublisherID : undefined,
          );
        });
      }

      return Promise.resolve(undefined);
    };

    renderCreateEditRegionDialog = () => {
      const { classes, session } = this.props;
      const {
        createEditRegionID,
        createEditRegionList,
        createEditRegionName,
        errors,
        openRegionCreateEditDialog,
        writeAuthorization,
        commonRegionGroups,
      } = this.state;

      const onCloseFn = (reloadCampaign: boolean, redirectToAllRegions?: boolean) => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadCampaign ? this.getCountryGroupsByPublisherID : undefined,
        );
      };

      const newCountryIsos = Object.keys(createEditRegionList).filter(
        (key) => createEditRegionList[key].selected,
      );
      const newCountryGroup = {
        CountryIsos: newCountryIsos.map((countryIso) => countryIso.toUpperCase()).join(','),
        Name: createEditRegionName,
        PublisherID: parseInt(session.publisher.ID, 10),
      } as ICountryGroup;

      // clicking on pre-selectable common region selects all default countries in that region
      const onCommonRegionClick = (countryGroup: ICountryGroup) => {
        this.setState({
          createEditRegionList: generateCountryMenuListFromIsos(
            countryGroup.CountryIsos.split(','),
          ),
          createEditRegionName: countryGroup.Name,
        });
      };

      return openRegionCreateEditDialog ? (
        <Grid item style={{ width: '100%' }}>
          <Dialog
            fullWidth
            maxWidth='sm'
            keepMounted
            open={openRegionCreateEditDialog}
            onClose={() => onCloseFn(false, false)}
          >
            <Grid item style={{ width: '100%' }}>
              <Typography
                className={classes.parameterHeaders}
                style={{ marginTop: 30, fontSize: 20 }}
              >
                {!createEditRegionID ? 'Create New Region' : 'Edit Region'}
              </Typography>
              <Grid item style={{ marginLeft: 50 }}>
                <TextField
                  label='Region Name'
                  name='createEditRegionName'
                  value={createEditRegionName}
                  onChange={this.handleChange}
                  error={!!errors.createEditRegionName}
                  helperText={errors.createEditRegionName}
                />
                <Grid>
                  {(commonRegionGroups || []).map((countryGroup: ICountryGroup) => {
                    return (
                      <Button
                        key={countryGroup.ID}
                        style={{ marginTop: 10 }}
                        onClick={() => onCommonRegionClick(countryGroup)}
                      >
                        {countryGroup.Name}
                      </Button>
                    );
                  })}
                </Grid>
              </Grid>

              <Divider style={{ margin: 10, height: 1, color: 'black' }} />

              <Typography className={classes.headingCategorySubtitle} style={{ paddingLeft: 50 }}>
                Select countries to include in region
              </Typography>
              <Grid item style={{ marginLeft: 50, height: 500 }}>
                <MaterialSearchDropdownMulti
                  forceOpen={true}
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  fontSize='14px'
                  selectAll={true}
                  menuTitle={''}
                  list={createEditRegionList}
                  disabled={!writeAuthorization.isAuthorized}
                  onChange={this.handleChangeList('createEditRegionList')}
                  handleMenuAcceptClick={() => null}
                  isNoneSelectedAllSelected={true}
                  keepDropdownOpen={true}
                />
              </Grid>
              <DialogActions>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => {
                    const regionValidationErrors = validatorFactory(regionValidationSetting)(
                      this.state,
                    );
                    if (hasErrors(regionValidationErrors)) {
                      const errorText = Object.values(errors)
                        .filter((value) => value.length)
                        .join('. ');
                      this.setState(
                        {
                          errors: regionValidationErrors,
                          snackbarMessage: `Please fix errors before saving region: ${errorText}`,
                          snackbarError: true,
                        },
                        () => {
                          setTimeout(() => {
                            this.setState({
                              errors: {} as IErrors,
                            });
                            this.snackbarClose();
                          }, 6000);
                        },
                      );
                      return;
                    }

                    if (!createEditRegionID) {
                      createCountryGroup(newCountryGroup).then(() => {
                        this.setState({
                          snackbarError: false,
                          snackbarMessage: 'Successfully created region',
                        });
                        onCloseFn(true, false);
                      });
                    } else {
                      newCountryGroup.ID = parseInt(createEditRegionID, 10);
                      this.setState(
                        {
                          updatingCountryGroup: true,
                        },
                        () => {
                          updateCountryGroup(newCountryGroup).then(() => {
                            this.setState(
                              {
                                snackbarError: false,
                                snackbarMessage: 'Successfully updated region',
                                updatingCountryGroup: false,
                              },
                              this.getCampaign,
                            );
                            onCloseFn(true, false);
                          });
                        },
                      );
                    }
                  }}
                >
                  Save
                </Button>
                <Button autoFocus color='primary' onClick={() => onCloseFn(false, true)}>
                  Cancel
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      ) : null;
    };

    // renderCustomToolbar renders the toolbar at the top of the list table
    renderCustomToolbar = (props: any): ReactElement => {
      const { classes } = this.props;
      const { updatingCountryGroup } = this.state;

      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '300px' },
      };

      return (
        <Grid item className={classes.toolbarRow}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid item>
              <MTableToolbar {...copyProps} />
            </Grid>
            <RowButton
              right={
                <ButtonView
                  onClick={() => {
                    this.setState({
                      openRegionSelectTable: false,
                      openRegionCreateEditDialog: true,
                    });
                  }}
                  text='+ New Region'
                  active={updatingCountryGroup}
                />
              }
            />
          </Grid>
        </Grid>
      );
    };

    renderRegionListTableDialog = () => {
      const { user } = this.props;
      const { publisherCountryGroups, updatingCountryGroup } = this.state;

      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: 'Region Name',
          renderType: 'modal3',
          searchable: true,
          maxWidth: '200px',
        },
        {
          field: 'CountriesTargeted',
          title: 'Countries Targeted',
          renderType: 'normal',
          searchable: false,
          maxWidth: '100px',
        },
        { field: 'Actions', title: 'Actions', renderType: 'delete', searchable: false },
      ];

      const listTableData: ICountryGroupRowData[] = publisherCountryGroups.map(
        (countryGroup: ICountryGroup) => {
          const countryGroupName = checkUserInfoMasked(user.user)
            ? `demo_site_${countryGroup.ID}`
            : countryGroup.Name;
          return {
            ID: countryGroup.ID.toString(),
            Name: countryGroupName,
            CountriesTargeted:
              (countryGroup.CountryIsos && countryGroup.CountryIsos.split(',').length) || 0,
          };
        },
      );

      return (
        <Grid item style={{ margin: '20px 15px 5px 15px', width: '97%' }}>
          <ListTable
            title={''}
            columns={listTableColumns}
            data={listTableData}
            isUpdating={updatingCountryGroup}
            handleSetUpdating={this.handleSetUpdatingCountryGroup}
            handleDeleteItem={(countryGroupID: string) =>
              this.deleteCountryGroupFunc(countryGroupID, true)
            }
            handleOpenModal3={this.handleOpenRegionSelectDialog}
            fixedEnabled={true}
            renderCustomToolbar={this.renderCustomToolbar}
            pageSize={10}
            readRoleName={'read_channel'}
            writeRoleName={'write_channel'}
          />
        </Grid>
      );
    };

    renderAllRegionsDialog = (regionRow: IInputRow) => {
      const { openRegionSelectTable, writeAuthorization } = this.state;

      const onCloseFn = (reloadCampaign: boolean, redirectToAllRegions?: boolean) => {
        this.setState(
          {
            createEditRegionID: '',
            createEditRegionList: generateCountriesMenuList(),
            createEditRegionName: '',
            openRegionCreateEditDialog: false,
            openRegionSelectTable: !!redirectToAllRegions,
          },
          reloadCampaign ? this.getCountryGroupsByPublisherID : undefined,
        );
      };

      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={regionRow} disableEdit={!writeAuthorization.isAuthorized} />
          {openRegionSelectTable ? (
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={openRegionSelectTable}
              onClose={() => this.setState({ openRegionSelectTable: false })}
            >
              {this.renderRegionListTableDialog()}
              <DialogActions>
                <Button autoFocus color='primary' onClick={() => onCloseFn(false, false)}>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            this.renderCreateEditRegionDialog()
          )}
        </Grid>
      );
    };

    getFrequencyCapDurationString(timeToLive: string) {
      const timeToLiveInt = parseInt(timeToLive, 10);
      if (timeToLiveInt % 86400 === 0) {
        if (timeToLiveInt === 86400) {
          return (timeToLiveInt / 86400).toString() + ' day';
        } else {
          return (timeToLiveInt / 86400).toString() + ' days';
        }
      } else if (timeToLiveInt % 3600 === 0) {
        if (timeToLiveInt === 3600) {
          return (timeToLiveInt / 3600).toString() + ' hour';
        } else {
          return (timeToLiveInt / 3600).toString() + ' hours';
        }
      } else {
        if (timeToLiveInt > 86400) {
          const numDays = Math.floor(timeToLiveInt / 86400);
          const timeRemaining = timeToLiveInt - numDays * 86400;
          const approxHours = (timeRemaining / 3600).toFixed(1);
          if (numDays === 1) {
            return '~' + numDays.toString() + ' day and ' + approxHours + ' hours';
          } else {
            return '~' + numDays.toString() + ' days and ' + approxHours + ' hours';
          }
        } else {
          const approxHours = (timeToLiveInt / 3600).toFixed(1);
          return '~' + approxHours + ' hours';
        }
      }
    }

    renderTargetingRequestedPodDuration = (): ReactElement => {
      const { TargetingRequestedPodDurationMin, TargetingRequestedPodDurationMax } = this.state;
      const shouldBold =
        TargetingRequestedPodDurationMin !== TargetingRequestedPodDurationNoMin ||
        TargetingRequestedPodDurationMax !== TargetingRequestedPodDurationNoMax;
      return (
        <Grid
          container
          direction='row'
          alignItems='center'
          spacing={2}
          style={{ marginTop: '-20px' }}
        >
          <Grid item xs={3} style={{ marginTop: '25px' }}>
            <Text
              small
              style={{
                fontWeight: shouldBold ? FONT_WEIGHT.bold : FONT_WEIGHT.none,
                marginLeft: '5px',
              }}
            >
              Requested Pod Duration (seconds)
              <Tooltip
                title={`Enter min and max ad duration in seconds to be targeted. Targeting is inclusive, for example if you want to exclude 60 from 0-60 enter 0-59. If maximum duration is 1000s or higher defaults to no max unless defined.`}
                placement='bottom-start'
              >
                <InfoIcon
                  style={{
                    width: '1rem',
                    color: publicaColors.mediumLightGray,
                    position: 'relative',
                    top: 8,
                    left: 8,
                  }}
                />
              </Tooltip>
            </Text>
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={6}>
            <MinMaxEditor
              min={TargetingRequestedPodDurationMin}
              max={TargetingRequestedPodDurationMax}
              handleOnChangeMinMax={this.handleChangeMinMaxPodDurationSelection}
              onClear={this.clearMinMaxPodDuration}
              minLimit={TargetingRequestedPodDurationNoMin}
              maxLimit={TargetingRequestedPodDurationNoMax}
            />
          </Grid>
        </Grid>
      );
    };

    handleChangeMinMaxPodDurationSelection = (value: string, name: string) => {
      const { TargetingRequestedPodDurationMax } = this.state;
      const parsedValue = parseInt(value, 10);
      if (!Number.isNaN(parsedValue)) {
        if (name === 'Min') {
          this.setState({
            TargetingRequestedPodDurationMin:
              parsedValue >= TargetingRequestedPodDurationMax
                ? TargetingRequestedPodDurationNoMin
                : parsedValue,
          });
        } else {
          this.setState({
            TargetingRequestedPodDurationMax:
              parsedValue >= TargetingRequestedPodDurationNoMax
                ? TargetingRequestedPodDurationNoMax
                : parsedValue,
          });
        }
      }
    };

    clearMinMaxPodDuration = () => {
      this.setState({
        TargetingRequestedPodDurationMin: TargetingRequestedPodDurationNoMin,
        TargetingRequestedPodDurationMax: TargetingRequestedPodDurationNoMax,
      });
    };

    renderTargetingTab(classes: { [key: string]: string }) {
      // Presets

      const { TargetingRequestedPodDurationMin, TargetingRequestedPodDurationMax } = this.state;
      // INVENTORY PANEL AND ROWS - Channels, Channel Groups, Slots
      const ChannelRow = {
        renderType: 'MaterialDropdown',
        title1: 'Channels',
        value1: this.state.siteList,
        handleChange1: this.handleChangeList('siteList'),
        handleAccept1: this.handleChannelAcceptClick,
        isActiveValue1: () => this.state.Sites.length !== Object.values(this.state.siteList).length,
        getActiveTag1: (active: boolean) =>
          active ? `${this.state.Sites.length} Channel(s)` : 'All Channels',
        quickFilterOptions: this.state.quickFilterOptions,
      } as IInputRow;
      const ChannelGroupRow = {
        renderType: 'MaterialDropdown',
        title1: 'Channel Groups',
        value1: this.state.channelGroupsList,
        handleChange1: this.handleChangeList('channelGroupsList'),
        handleAccept1: this.handleChannelGroupsAcceptClick,
        isActiveValue1: () => this.state.ChannelGroupIDS.length !== 0,
        getActiveTag1: (active: boolean) =>
          active ? `${this.state.ChannelGroupIDS.length} Channel Group(s)` : 'All Channels Groups',
      } as IInputRow;
      const ChannelListRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderChannelListDialog({
            renderType: 'MaterialDropdown',
            title1: 'Channel Lists',
            value1: this.state.channelListsList,
            defaultValue1: false,
            handleChange1: this.handleChangeList('channelListsList'),
            handleAccept1: this.handleChannelListsAcceptClick,
            isActiveValue1: () => this.state.ChannelListIDS.length !== 0,
            getActiveTag1: (active: boolean) =>
              active ? `${this.state.ChannelListIDS.length} Channel List(s)` : 'All Channels Lists',
            value2: false,
            defaultValue2: true,
            showStaticTargetingIcon: true,
            showModalButtonUnderDropdown: this.state.channelLists.length > 0,
            showModalButton: this.state.channelLists.length === 0,
            modalButton: (
              <Grid>
                <ModelSecondaryButton
                  onClick={() => {
                    this.setState({ openChannelListDialog: true });
                    this.addChannelList().then();
                  }}
                  disabled={false}
                >
                  + Channel List
                </ModelSecondaryButton>
                <ModelSecondaryButton
                  style={{ color: publicaColors.gray }}
                  onClick={() => {
                    this.setState({ openChannelListEditDialog: true });
                    this.clearEditChannelLists();
                  }}
                  disabled={false}
                >
                  <EditIcon style={{ fontSize: 20, padding: 3 }} />
                  Edit Channel List
                </ModelSecondaryButton>
              </Grid>
            ),
            showDropdown: !!(this.state.channelLists.length > 0),
            optionalIcon: 'flag',
            optionalIconInfo: 'Not currently included in forecast',
          });
        },
        title1: '',
        isActiveValue1: () => countryGroupCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? countryGroupCount === 1
              ? '1 Region'
              : `${countryGroupCount} Regions`
            : 'All Regions',
      } as IInputRow;
      const minText = `${TargetingRequestedPodDurationMin}s`;
      const maxText =
        TargetingRequestedPodDurationMax !== TargetingRequestedPodDurationNoMax
          ? `${TargetingRequestedPodDurationMax}s`
          : 'No Max';
      const TargetingRequestedPodDurationRow = {
        renderType: 'custom',
        customRender: () => this.renderTargetingRequestedPodDuration(),
        title1: '',
        isActiveValue1: () =>
          TargetingRequestedPodDurationMin !== TargetingRequestedPodDurationNoMin ||
          TargetingRequestedPodDurationMax !== TargetingRequestedPodDurationNoMax,
        getActiveTag1: (active: boolean) =>
          active ? `${minText}-${maxText} Pod Durations` : 'All Pod Durations',
      } as IInputRow;
      const TargetGvinQueryParamRow = {
        renderType: 'SimpleSwitch',
        title1: 'Givn Targeting',
        value1: this.state.TargetingGvinParamExists === EBool.EBool_TRUE,
        handleChange1: () =>
          this.handleChangeEBool('TargetingGvinParamExists', this.state.TargetingGvinParamExists),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      const InventoryPanel = {
        title: 'Inventory',
        panelInactiveRowTag: '',
        panelActiveChipTitle: 'Custom',
        rows: [ChannelRow, ChannelGroupRow, TargetingRequestedPodDurationRow],
      } as IAccordionPanel;
      // Only visible for Samsung and AnsulTest publishers
      if (
        isSamsungPublisher(this.props.session.publisher.ID) ||
        this.props.session.publisher.ID === '922'
      ) {
        InventoryPanel.rows.push(ChannelListRow);
        InventoryPanel.rows.push(TargetGvinQueryParamRow);
      }

      // CONTENT PANEL AND ROWS
      const contentRows = [
        'Channel',
        'Distributor',
        'Genre',
        'ID',
        'Network',
        'Producer',
        'Rating',
        'Series',
        'Title',
        'Language',
      ].map((contentItem: string) => {
        const field = `TargetingContent${contentItem}`;
        const isAllowedName = `TargetingContent${contentItem}IsAllowed`;
        const isAllowed = this.state[isAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndIncludeV2',
          tooltipText: `Content ${contentItem} to bid on, can be comma separated`,
          title1: 'Content ' + contentItem,
          field1: field,
          value1: this.state[field],
          handleChange1: (value: string) =>
            this.handleChange({
              target: {
                name: field,
                value,
              },
            } as any),
          isActiveValue1: () => this.state[`TargetingContent${contentItem}`].length > 0,
          getActiveTag1: () =>
            this.generateActiveTagForCommaSepField(
              this.state[`TargetingContent${contentItem}`],
              contentItem,
            ),
          value2: isAllowed,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: isAllowedName,
                value:
                  this.state[isAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : (EAllowStatus.ALLOW as any),
              },
            } as any),
          placeholderText: `Enter Content ${contentItem} to be bid on here, comma separated`,
        } as IInputRow;
      });

      const ContentPanel = {
        title: 'Content',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: contentRows,
        StaticTooltip: StaticAdvancedTargetingTooltip,
      } as IAccordionPanel;

      // GEO PANEL AND ROWS
      const countriesCount = Object.values(this.state.targetingCountriesList).filter(
        (item) => item.selected,
      ).length;
      const countryGroupCount = Object.values(this.state.targetingCountryGroupList).filter(
        (item) => item.selected,
      ).length;
      const TargetedCountriesRow = {
        renderType: 'MaterialDropdown',
        title1: 'Targeted Countries',
        value1: this.state.targetingCountriesList,
        handleChange1: this.handleChangeList('targetingCountriesList'),
        handleAccept1: () => null,
        isActiveValue1: () => countriesCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? countriesCount === 1
              ? '1 Country'
              : `${countriesCount} Countries`
            : 'All Countries',
        value2: this.state.deviceTargetingCountrySelectMode === SelectMode.Allowlist,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'deviceTargetingCountrySelectMode',
              value:
                this.state.deviceTargetingCountrySelectMode === SelectMode.Allowlist
                  ? SelectMode.Denylist
                  : (SelectMode.Allowlist as any),
            },
          } as any),
        // if no countries are selected, all countries are selected (optional material search dropdown param)
        isNoneSelectedAllSelected: true,
      } as IInputRow;

      const TargetedRegionsRow = {
        renderType: 'custom',
        customRender: () => {
          return this.renderAllRegionsDialog({
            renderType: 'MaterialDropdown',
            title1: 'Targeted Regions',
            value1: this.state.targetingCountryGroupList,
            handleChange1: this.handleChangeList('targetingCountryGroupList'),
            isActiveValue1: () => countryGroupCount > 0,
            getActiveTag1: (active: boolean) =>
              active
                ? countryGroupCount === 1
                  ? '1 Region'
                  : `${countryGroupCount} Regions`
                : 'All Regions',
            value2: this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW,
            handleChange2: () =>
              this.handleChange({
                target: {
                  name: 'TargetingCountryGroupIDsIsAllowed',
                  value:
                    this.state.TargetingCountryGroupIDsIsAllowed === EAllowStatus.ALLOW
                      ? EAllowStatus.DENY
                      : (EAllowStatus.ALLOW as any),
                },
              } as any),
            // if no country groups are selected, all country groups are selected by default
            isNoneSelectedAllSelected: true,
            showModalButton: true,
            modalButton: (
              <ModelSecondaryButton
                onClick={() => this.setState({ openRegionSelectTable: true })}
                disabled={!this.state.writeAuthorization.isAuthorized}
              >
                See Regions
              </ModelSecondaryButton>
            ),
            optionalIcon: 'flag',
            optionalIconInfo: 'Not currently included in forecast',
          });
        },
        title1: '',
        isActiveValue1: () => countryGroupCount > 0,
        getActiveTag1: (active: boolean) =>
          active
            ? countryGroupCount === 1
              ? '1 Region'
              : `${countryGroupCount} Regions`
            : 'All Regions',
      } as IInputRow;

      const LocalTargetingAllowedRow = {
        renderType: 'custom',
        customRender: this.renderLocalTargetingAllowedPanel,
        title1: '',
        field1: '',
        value1: this.state.LocalTargetingAllowed,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.localTargetingAllowedParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return this.state.localTargetingAllowedParameters.length === 1
            ? '1 Local Target Included'
            : `${this.state.localTargetingAllowedParameters.length} Local Targets Included`;
        },
      } as IInputRow;

      const LocalTargetingDisallowedRow = {
        renderType: 'custom',
        customRender: this.renderLocalTargetingDisallowedPanel,
        title1: '',
        field1: '',
        value1: this.state.LocalTargetingDisallowed,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.localTargetingDisallowedParameters.length !== 0,
        getActiveTag1: (active: boolean) => {
          if (!active) {
            return '';
          }
          return this.state.localTargetingDisallowedParameters.length === 1
            ? '1 Local Target Excluded'
            : `${this.state.localTargetingDisallowedParameters.length} Local Targets Excluded`;
        },
      } as IInputRow;

      const GeoPanel = {
        title: 'Geo',
        panelInactiveRowTag: 'All Geos',
        panelActiveChipTitle: 'Custom',
        rows: [
          TargetedRegionsRow,
          TargetedCountriesRow,
          LocalTargetingAllowedRow,
          LocalTargetingDisallowedRow,
        ],
      } as IAccordionPanel;

      // DAYPARTING
      const DaypartingRow = {
        renderType: 'custom',
        customRender: this.renderDaypartingPanel,
        title1: '',
        field1: '',
        value1: this.state.Dayparting,
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.isDaypartingActive,
        getActiveTag1: (active: boolean) => {
          return active ? 'All Daypartings' : 'None';
        },
      } as IInputRow;
      const DaypartingPanel = {
        title: 'Dayparting',
        panelInactiveRowTag: 'All Daypartings',
        panelActiveChipTitle: 'Custom',
        rows: [DaypartingRow],
      } as IAccordionPanel;

      // PRIVACY PANEL AND ROWS
      const CoppaRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: coppaOptions || [],
        title1: 'COPPA',
        field1: 'TargetingCoppa',
        value1: this.state.TargetingCoppa,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingCoppa !== TargetingCoppaAll,
        getActiveTag1: (active: boolean) =>
          active ? (this.state.TargetingCoppa === TargetingCoppa0 ? 'COPPA = 0' : 'COPPA = 1') : '',
        optionalIcon: 'flag',
        optionalIconInfo: 'Not currently included in forecast',
      } as IInputRow;
      const LATRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: latOptions || [],
        title1: 'Limited Ad Tracking',
        field1: 'TargetingLimitedAdTracking',
        value1: this.state.TargetingLimitedAdTracking,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingLimitedAdTracking !== TargetBoolTypeAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingLimitedAdTracking === TargetBoolTypeTrue
              ? 'LAT = True'
              : 'LAT = False'
            : '',
      };

      const CCPARow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: ccpaOptions || [],
        title1: 'CCPA',
        field1: 'TargetingCCPA',
        value1: this.state.TargetingCCPA,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingCCPA !== TargetingCCPAAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingCCPA !== TargetingCCPAAll
              ? 'CCPA Targeted'
              : 'CCPA All'
            : '',
      };

      const GDPRRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: GDPROptions || [],
        title1: 'GDPR',
        field1: 'TargetingGDPR',
        value1: this.state.TargetingGDPR,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingGDPR !== TargetingGDPRAll,
        getActiveTag1: (active: boolean) =>
          active ? (this.state.TargetingGDPR === TargetingGDPR0 ? 'GDPR = 0' : 'GDPR = 1') : '',
      } as IInputRow;

      const GDPRConsentRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: GDPRConsentOptions || [],
        title1: 'GDPR Consent',
        field1: 'TargetingGDPRConsent',
        value1: this.state.TargetingGDPRConsent,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingGDPRConsent !== TargetBoolTypeAll,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingGDPRConsent === TargetBoolTypeTrue
              ? 'GDPR Consent = True'
              : 'GDPR Consent = False'
            : '',
      };

      const TargetingDeviceIDTypeRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: targetingDeviceIDTypeOptions || [],
        title1: 'Targeting Device ID Type',
        field1: 'TargetingDeviceIDType',
        value1: this.state.TargetingDeviceIDType,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingDeviceIDType !== ETargetingDeviceIDTypes.ALL,
        getActiveTag1: (active: boolean) =>
          active
            ? this.state.TargetingDeviceIDType !== ETargetingDeviceIDTypes.ORIGINAL
              ? 'Synthetic DIDs'
              : 'Original DIDs'
            : '',
      };

      const PrivacyPanel = {
        title: 'Privacy',
        panelInactiveRowTag: 'All Values',
        panelActiveChipTitle: 'Custom',
        rows:
          this.state.TargetingGDPR === TargetingGDPR1
            ? [CoppaRow, LATRow, CCPARow, GDPRRow, GDPRConsentRow, TargetingDeviceIDTypeRow]
            : [CoppaRow, LATRow, CCPARow, GDPRRow, TargetingDeviceIDTypeRow],
      } as IAccordionPanel;

      // CUSTOM PANEL AND ROWS
      const customRows = [
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        'Targeting',
      ].map((customItem: string) => {
        let title = `Custom ${customItem}`;
        let field = `TargetingCustom${customItem}`;
        if (customItem === 'Targeting') {
          title = `Custom ${customItem}`;
          field = `Custom${customItem}`;
        }
        const isAllowedName = field + 'Inclusion';
        const isAllowed = this.state[isAllowedName] === EAllowStatus.ALLOW;
        return {
          renderType: 'TextfieldAndIncludeV2',
          tooltipText: `Checks for custom param set in your request to ${getResellerTitle()}\'s endpoint and includes or excludes the bidder. Can be comma separated`,
          title1: title,
          field1: field,
          value1: this.state[field],
          handleChange1: (value: string) =>
            this.handleChange({
              target: {
                name: field,
                value,
              },
            } as any),
          isActiveValue1: () => this.state[field].length > 0,
          getActiveTag1: () => this.generateActiveTagForCommaSepField(this.state[field], title),
          value2: isAllowed,
          defaultValue2: true,
          handleChange2: () =>
            this.handleChange({
              target: {
                name: isAllowedName,
                value:
                  this.state[isAllowedName] === EAllowStatus.ALLOW
                    ? EAllowStatus.DENY
                    : (EAllowStatus.ALLOW as any),
              },
            } as any),
          placeholderText: `Enter Custom ${customItem} here, can be comma separated`,
          optionalIcon: 'flag',
          optionalIconInfo: 'Not currently included in forecast',
        } as IInputRow;
      });

      const CustomPanel = {
        title: 'Custom',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: customRows,
        StaticTooltip: StaticAdvancedTargetingTooltip,
      } as IAccordionPanel;

      // DEVICE PANEL AND ROWS
      const TargetedDevicesRow = {
        renderType: 'MaterialDropdown',
        title1: 'Targeted Devices',
        value1: getDeviceEnvironmentAsItems(this.state.TargetingDevices),
        handleChange1: this.handleChangeList('TargetingDevices'),
        handleAccept1: () => null,
        isActiveValue1: () => {
          const devices = this.state.TargetingDevices.split(',');
          if (devices.length === 0) {
            return false;
          }
          return !devices.includes('0');
        },
        getActiveTag1: (active: boolean) => {
          if (active) {
            let deviceCount = 0;
            if (this.state.TargetingDevices !== '') {
              deviceCount = this.state.TargetingDevices.split(',').length;
            }
            return `${deviceCount} Device(s)`;
          }
          return 'All Devices';
        },
        value2: this.state.TargetingDevicesIsAllowed !== EAllowStatus.DENY,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDevicesIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDevicesIsAllowed) as any,
            },
          } as any),
      } as IInputRow;
      const TargetedDeviceSubTypesRow = {
        renderType: 'MaterialDropdown',
        title1: 'Targeted Device Subtypes',
        value1: getDeviceEnvironmentSubTypesAsItems(
          this.state.TargetingDeviceSubTypes,
          this.props.session.publisher.ID,
          hasRoleSuperUser(this.props.user.user),
        ),
        defaultValue1: true,
        handleChange1: this.handleChangeList('TargetingDeviceSubTypes'),
        handleAccept1: () => null,
        isActiveValue1: () => !this.state.TargetingDeviceSubTypes.split(',').includes('0'),
        getActiveTag1: (active: boolean) => {
          if (active) {
            let subTypeCount = 0;
            if (this.state.TargetingDeviceSubTypes !== '') {
              subTypeCount = this.state.TargetingDeviceSubTypes.split(',').length;
            }
            return subTypeCount > 1 || subTypeCount === 0
              ? `${subTypeCount} Subtypes`
              : `1 SubType`;
          }
          return 'All Subtypes';
        },
        value2: this.state.TargetingDeviceSubTypesIsAllowed !== EAllowStatus.DENY,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDeviceSubTypesIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDeviceSubTypesIsAllowed) as any,
            },
          } as any),
      } as IInputRow;
      const TargetedDeviceModelsRow = {
        renderType: 'MaterialDropdown',
        title1: ct('TargetedDeviceModels'),
        value1: getDeviceEnvironmentModelsAsItems(
          this.state.TargetingDeviceModels,
          this.props.session.publisher.ID,
          hasRoleSuperUser(this.props.user.user),
        ),
        defaultValue1: true,
        handleChange1: this.handleChangeList('TargetingDeviceModels'),
        handleAccept1: () => null,
        isActiveValue1: () => {
          const devices = this.state.TargetingDeviceModels.split(',');
          if (devices.length === 0 || this.state.TargetingDeviceModels === '') {
            return false;
          }
          return !devices.includes('0');
        },
        getActiveTag1: (active: boolean) => {
          if (active) {
            let modelCount = 0;
            if (this.state.TargetingDeviceModels !== '') {
              modelCount = this.state.TargetingDeviceModels.split(',').length;
            }
            return modelCount > 1 || modelCount === 0 ? `${modelCount} Models` : `1 Model`;
          }
          return 'All Models';
        },
        value2: this.state.TargetingDeviceModelsIsAllowed !== EAllowStatus.DENY,
        handleChange2: () => {
          const newValue =
            this.state.TargetingDeviceModelsIsAllowed === EAllowStatus.ALLOW
              ? EAllowStatus.DENY
              : EAllowStatus.ALLOW;
          this.setState({ TargetingDeviceModelsIsAllowed: newValue });
        },
      } as IInputRow;
      const TargetedDeviceTypesRow = {
        renderType: 'SimpleMultiSelect',
        simpleSelectItems: deviceORTBTypes || [],
        title1: 'Targeted Device Types',
        field1: 'TargetingDeviceTypes',
        value1: this.getDisplayedDeviceTypes(),
        handleChange1: this.handleChangeTargetingDeviceTypes,
        isActiveValue1: () =>
          this.state.TargetingDeviceTypes !== '' &&
          this.state.TargetingDeviceTypes.split(',').length !== deviceORTBTypes.length,
        getActiveTag1: (active: boolean) => {
          if (active) {
            const deviceTypesCount = this.state.TargetingDeviceTypes.split(',').length;
            return `${deviceTypesCount} Device Type(s)`;
          }
          return 'All Device Types';
        },
        value2: this.state.TargetingDeviceTypesIsAllowed !== EAllowStatus.DENY,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingDeviceTypesIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingDeviceTypesIsAllowed) as any,
            },
          } as any),
      } as IInputRow;

      const IPFilterRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: 'IP Filter *',
        field1: 'IPFilter',
        value1: this.state.IPFilter,
        handleChange1: (value: string) =>
          this.handleChange({
            target: {
              name: 'IPFilter',
              value,
            },
          } as any),
        isActiveValue1: () => this.state.IPFilter.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.IPFilter, 'IP Filter'),
        tooltipText: `Match this value to the ip set in your request to Publica's endpoint.Can be comma separated`,
        placeholderText: 'Enter IP Filters here, comma separated',
        optionalIcon: 'flag',
        optionalIconInfo: 'Not currently included in forecast',
      } as IInputRow;

      const DevicePanel = {
        title: 'Device',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: [TargetedDevicesRow, TargetedDeviceTypesRow],
      } as IAccordionPanel;
      const deviceEnvironmentSubTypes = getDeviceEnvironmentSubTypes(
        this.props.session.publisher.ID,
        hasRoleSuperUser(this.props.user.user),
      );
      const deviceEnvironmentModels = getDeviceEnvironmentModels(
        this.props.session.publisher.ID,
        hasRoleSuperUser(this.props.user.user),
      );
      const deviceRowsToInsert = [];
      if (deviceEnvironmentSubTypes.length > 0) {
        deviceRowsToInsert.push(TargetedDeviceSubTypesRow);
      }
      if (
        deviceEnvironmentModels.length > 0 &&
        isSamsungPublisher(this.props.session.publisher.ID)
      ) {
        deviceRowsToInsert.push(TargetedDeviceModelsRow);
      }
      if (hasRoleSuperUser(this.props.user.user)) {
        DevicePanel.rows.push(IPFilterRow);
      }
      DevicePanel.rows.splice(1, 0, ...deviceRowsToInsert);

      // STREAM PANEL AND ROWS
      const LivestreamRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: livestreamOptions || [],
        title1: 'Livestream',
        field1: 'TargetingLivestream',
        value1: this.state.TargetingLivestream,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.TargetingLivestream !== 0,
        getActiveTag1: (active: boolean) => {
          if (active) {
            if (this.state.TargetingLivestream === 1) {
              return 'Live';
            }
            if (this.state.TargetingLivestream === 2) {
              return 'VOD';
            }
            if (this.state.TargetingLivestream === 3) {
              return 'DVR';
            }
          }
          return '';
        },
      } as IInputRow;
      const StreamPanel = {
        title: 'Stream',
        panelInactiveRowTag: 'All Stream Types',
        panelActiveChipTitle: 'Custom',
        rows: [LivestreamRow],
      } as IAccordionPanel;

      // AUDIENCE SEGMENT PANEL AND ROWS
      const AudienceSegmentRow = {
        renderType: 'custom',
        customRender: this.renderAudienceSegmentRow,
        title1: '',
        field1: '',
        handleChange1: noopVoid,
        isActiveValue1: () =>
          this.state.TargetingAudienceSegmentID.length &&
          this.state.TargetingAudienceSegmentID.split(',').length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(
            this.state.TargetingAudienceSegmentID,
            'Audience Segment',
          ),
      } as IInputRow;
      const ContextualSegmentRow = {
        renderType: 'custom',
        customRender: this.renderContextualSegmentRow,
        title1: '',
        field1: '',
        handleChange1: noopVoid,
        isActiveValue1: () => this.state.ContextualSegmentIDS.length > 0,
        getActiveTag1: () =>
          this.state.ContextualSegmentIDS.length > 0 ? 'Contextual Segment' : '',
      } as IInputRow;
      const AudienceSegmentPanel = {
        title: 'Segments',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: [AudienceSegmentRow, ContextualSegmentRow],
      } as IAccordionPanel;

      // APP PANEL AND ROWS
      const AppBundleIDRow = {
        renderType: 'TextfieldAndIncludeV2AndLogic',
        title1: 'App Bundle ID',
        field1: 'TargetingAppBundleID',
        value1: this.state.TargetingAppBundleID,
        handleChange1: (value: string) =>
          this.handleChange({
            target: {
              name: 'TargetingAppBundleID',
              value,
            },
          } as any),
        isActiveValue1: () => this.state.TargetingAppBundleID.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingAppBundleID, 'App Bundle ID'),
        value2: this.state.TargetingAppBundleIDIsAllowed !== EAllowStatus.DENY,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingAppBundleIDIsAllowed',
              value: reverseEAllowStatus(this.state.TargetingAppBundleIDIsAllowed) as any,
            },
          } as any),
        tooltipText: (
          <div>
            App Bundle ID to bid on, comma separated
            <br /> More info{' '}
            <a
              href='https://iabtechlab.com/wp-content/uploads/2020/08/IAB-Tech-Lab-OTT-store-assigned-App-Identification-Guidelines-2020.pdf'
              rel='noopener'
              target='_blank'
            >
              here
            </a>
          </div>
        ),
        placeholderText: 'Enter App Bundle IDs here, comma separated',
        value3: this.state.TargetingAppBundleSitePagesLogic,
        defaultValue3: ELogicalOperator.AND,
        handleChange3: () =>
          this.handleChange({
            target: {
              name: 'TargetingAppBundleSitePagesLogic',
              value:
                this.state.TargetingAppBundleSitePagesLogic === ELogicalOperator.OR
                  ? ELogicalOperator.AND
                  : ELogicalOperator.OR,
            },
          } as any),
      } as IInputRow;

      // SITE PAGE PANEL AND ROWS
      const SitePagesRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: 'Site Pages',
        field1: 'TargetingSitePages',
        value1: this.state.TargetingSitePages,
        handleChange1: (value: string) =>
          this.handleChange({
            target: {
              name: 'TargetingSitePages',
              value,
            },
          } as any),
        isActiveValue1: () => this.state.TargetingSitePages.length > 0,
        getActiveTag1: () =>
          this.generateActiveTagForCommaSepField(this.state.TargetingSitePages, 'Site Pages'),
        value2: this.state.TargetingSitePagesIsAllowed !== EAllowStatus.DENY,
        handleChange2: () =>
          this.handleChange({
            target: {
              name: 'TargetingSitePagesIsAllowed',
              value:
                this.state.TargetingSitePagesIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as any),
            },
          } as any),
        tooltipText: 'Site Pages to bid on. Can be comma-separated.',
        placeholderText: 'Enter Site Pages here, comma separated',
      } as IInputRow;

      const AppBundleSitePagesPanel = {
        title: 'App and Site',
        panelInactiveRowTag: 'None',
        panelActiveChipTitle: 'Custom',
        rows: [AppBundleIDRow, SitePagesRow],
      } as IAccordionPanel;

      const extendedIDTargetingTypeSelectItems = [
        { key: ExtendedIDTargetingTypeDisabled, text: ct('Disabled') },
        { key: ExtendedIDTargetingTypeEnabledIfPresent, text: ct('TargetIfPresent') },
        { key: ExtendedIDTargetingTypeEnabledIfMissing, text: ct('TargetIfMissing') },
      ];

      const UID20Row = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'UID 2.0',
        field1: 'TargetingUID20TargetingType',
        value1: this.state.TargetingUID20TargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingUID20TargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'UID 2.0' : ''),
      } as IInputRow;

      const GooglePairIDRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'Google Pair ID',
        field1: 'TargetingGooglePairIDTargetingType',
        value1: this.state.TargetingGooglePairIDTargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingGooglePairIDTargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'Google Pair ID' : ''),
      } as IInputRow;

      const LiveRampATSRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'LiveRamp ATS',
        field1: 'TargetingLiveRampATSTargetingType',
        value1: this.state.TargetingLiveRampATSTargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingLiveRampATSTargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'LiveRamp ATS' : ''),
      } as IInputRow;

      const IrisSignalRow = {
        renderType: 'SimpleSingleSelect',
        simpleSelectItems: extendedIDTargetingTypeSelectItems,
        title1: 'Iris Signal',
        field1: 'TargetingIrisSignalTargetingType',
        value1: this.state.TargetingIrisSignalTargetingType,
        defaultValue1: ExtendedIDTargetingTypeDisabled,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          this.state.TargetingIrisSignalTargetingType !== ExtendedIDTargetingTypeDisabled,
        getActiveTag1: (active: boolean) => (active ? 'Iris Signal' : ''),
      } as IInputRow;

      // const SamsungIdentityRow = {
      //   renderType: 'SimpleSingleSelect',
      //   simpleSelectItems: extendedIDTargetingTypeSelectItems,
      //   title1: 'Samsung Identity',
      //   field1: 'TargetingSamsungIdentityTargetingType',
      //   value1: this.state.TargetingSamsungIdentityTargetingType,
      //   defaultValue1: ExtendedIDTargetingTypeDisabled,
      //   handleChange1: this.handleChange,
      //   isActiveValue1: () =>
      //     this.state.TargetingSamsungIdentityTargetingType !== ExtendedIDTargetingTypeDisabled,
      //   getActiveTag1: (active: boolean) => (active ? 'Samsung Identity' : ''),
      // } as IInputRow;

      // const SamsungEPGMetadataRow = {
      //   renderType: 'SimpleSingleSelect',
      //   simpleSelectItems: extendedIDTargetingTypeSelectItems,
      //   title1: 'Samsung EPG Metadata',
      //   field1: 'TargetingSamsungEPGMetadataTargetingType',
      //   value1: this.state.TargetingSamsungEPGMetadataTargetingType,
      //   defaultValue1: ExtendedIDTargetingTypeDisabled,
      //   handleChange1: this.handleChange,
      //   isActiveValue1: () =>
      //     this.state.TargetingSamsungEPGMetadataTargetingType !== ExtendedIDTargetingTypeDisabled,
      //   getActiveTag1: (active: boolean) => (active ? 'Samsung EPG Metadata' : ''),
      // } as IInputRow;

      const extendedIDsRows = [UID20Row, GooglePairIDRow, LiveRampATSRow, IrisSignalRow];

      // if (isPublisherSamsung(this.props.session.publisher.ID)) {
      //   extendedIDsRows.push(SamsungIdentityRow, SamsungEPGMetadataRow);
      // }

      const ExtendedIDsPanel = {
        title: ct('ExtendedIDs'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: extendedIDsRows,
        StaticTooltip: StaticExtendedIDTooltip,
      } as IAccordionPanel;

      const DealIDRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: ct('DealID'),
        field1: 'TargetingDealID',
        value1: this.state.TargetingDealID,
        defaultValue1: '',
        handleChange1: (value: string): void =>
          this.handleChange({
            target: {
              name: 'TargetingDealID',
              value,
            },
          } as React.ChangeEvent<HTMLInputElement>),
        isActiveValue1: (): boolean => this.state.TargetingDealID.length > 0,
        getActiveTag1: (): string =>
          this.generateActiveTagForCommaSepField(this.state.TargetingDealID, 'Deal ID'),
      } as IInputRow;

      const FWSectionIDsRow = {
        renderType: 'TextfieldAndIncludeV2',
        title1: 'FW Section IDs',
        field1: 'TargetingFWSectionIDs',
        value1: this.state.TargetingFWSectionIDs,
        defaultValue1: '',
        handleChange1: (value: string): void =>
          this.handleChange({
            target: {
              name: 'TargetingFWSectionIDs',
              value,
            },
          } as React.ChangeEvent<HTMLInputElement>),
        isActiveValue1: (): boolean => this.state.TargetingFWSectionIDs.length > 0,
        getActiveTag1: (): string =>
          this.generateActiveTagForCommaSepField(
            this.state.TargetingFWSectionIDs,
            'FW Section IDs',
          ),
        value2: this.state.TargetingFWSectionIDsIsAllowed !== EAllowStatus.DENY,
        handleChange2: (): void =>
          this.handleChange({
            target: {
              name: 'TargetingFWSectionIDsIsAllowed',
              value:
                this.state.TargetingFWSectionIDsIsAllowed === EAllowStatus.ALLOW
                  ? EAllowStatus.DENY
                  : (EAllowStatus.ALLOW as unknown),
            },
          } as React.ChangeEvent<HTMLInputElement>),
      } as IInputRow;

      // DEALS PANEL
      const DealsPanel = {
        title: ct('Deals'),
        panelInactiveRowTag: ct('None'),
        panelActiveChipTitle: ct('Custom'),
        rows: [DealIDRow, FWSectionIDsRow],
      } as IAccordionPanel;

      const panels = [
        InventoryPanel,
        ContentPanel,
        GeoPanel,
        DaypartingPanel,
        PrivacyPanel,
        DevicePanel,
        AppBundleSitePagesPanel,
        DealsPanel,
        StreamPanel,
        AudienceSegmentPanel,
        CustomPanel,
        ExtendedIDsPanel,
      ];

      return (
        <Grid item className={classes.mainGridItem}>
          <Grid container direction='column'>
            <Grid item>
              <Typography
                className={classes.headingCategorySubtitle}
                style={{ padding: '6px 8px', marginBottom: '10px' }}
              >
                Set targeting parameters below to define which requests should reach this line item.
              </Typography>
            </Grid>
            <Rows>
              {this.state.Bidder !== DemandSources.publicaCampaign && (
                <Row noHorizontalPadding>
                  <TargetingIntegration
                    generateCustomTargeting={this.generateCustomTargetingPayload}
                    handleApplySelectedPresets={this.handleApplySelectedPresets}
                    presetIDs={this.state.PresetIDs}
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    presetOptions={this.state.PresetList}
                    conflicts={this.state.presetConflicts}
                    conflictedParamKeys={this.state.presetConflictedParamKeys}
                    key={'campaignIntegrationString'}
                    parentType='Campaign'
                  />
                </Row>
              )}
              <Row noPadding>
                <Cols
                  paddingBottom={spacing.small}
                  gap={spacing.small}
                  style={{ alignItems: 'center' }}
                >
                  <Col width={32} displayFlex>
                    <IconV2 name='code' small />
                  </Col>
                  <Col>
                    <Text small bold>
                      Custom Targeting
                    </Text>
                  </Col>
                </Cols>
              </Row>
              {/* Targeting Accordion */}
              <Row noPadding>
                <MultiAccordion
                  title='Targeting Parameters'
                  panels={panels}
                  disableEdit={!this.state.writeAuthorization.isAuthorized}
                />
              </Row>
            </Rows>
          </Grid>
          {/* Forecast */}
          {this.renderForecast(classes)}
        </Grid>
      );
    }

    renderSqlTextBox(text: string) {
      return (
        <Editor
          placeholder={''}
          value={text}
          highlight={(code) => highlight(code, languages.sql, 'sql')}
          padding={0}
          maxLength={1000}
          onValueChange={() => null}
          readOnly={true}
        />
      );
    }

    renderForecast(classes: { [key: string]: string }) {
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      const missingDate = !this.state.dateStart || !this.state.dateEnd;
      const activeFCaps = this.state.FrequencyCaps.filter(
        (fCap) => fCap.Active === FrequencyCapActiveActive,
      );
      const moreThanOneActiveFCap = activeFCaps.length > 1;
      return (
        <Grid>
          <div className={classes.section}>
            <div
              style={{
                display: 'flex',
                marginTop: '40px',
              }}
            >
              <FlagIcon />
              &nbsp;&nbsp;
              <Typography style={{ fontWeight: 500 }}>Forecasting Tool</Typography>
            </div>
            <p>
              Forecasting takes historical data from the previous 30 days of data to estimate the
              number of impressions the current line item targeting will receive. Forecasting will
              match the time and day of the week for the start and end of the line item to ensure
              dayparting is properly estimated. For line items with a duration longer than 30 days,
              30 days of data will be analyzed and extrapolated. This forecasting assumes that line
              items will always win auctions when their targeting is met. This may be skewed if line
              items have a lower than average CPM. To help ensure the forecasted delivery is
              achieved, consider placing the direct campaign bidder at a higher tier than other
              demand so the line item wins the auction.
            </p>
            <div>
              <Paper className={classes.table}>
                <Table size='small'>
                  <TableBody>
                    <TableRow>
                      <TableCell>Start Date:</TableCell>
                      <TableCell>End Date:</TableCell>
                      <TableCell>Dayparting:</TableCell>
                      <TableCell>Freq. Cap Limit:</TableCell>
                      <TableCell>Freq. Cap Duration:</TableCell>
                      <TableCell>Delivery Goal (Imps):</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        {printDate(
                          this.state.dateStart ? toStartDate(this.state.dateStart) : undefined,
                          this.props.session.publisher.Localization,
                        )}
                      </TableCell>
                      <TableCell>
                        {printDate(
                          this.state.dateEnd ? toEndDate(this.state.dateEnd) : undefined,
                          this.props.session.publisher.Localization,
                        )}
                      </TableCell>
                      <TableCell>{this.state.isDaypartingActive ? 'Active' : 'Inactive'}</TableCell>
                      <TableCell>
                        {!moreThanOneActiveFCap && activeFCaps.length > 0
                          ? activeFCaps[0].Limit
                          : 'N/A'}
                      </TableCell>
                      <TableCell>
                        {!moreThanOneActiveFCap && activeFCaps.length > 0
                          ? this.getFrequencyCapDurationString(activeFCaps[0].TimeToLive)
                          : 'N/A'}
                      </TableCell>
                      <TableCell>{this.state.Quantity}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Paper>
            </div>
            {moreThanOneActiveFCap && (
              <div
                style={{
                  display: 'flex',
                  marginBottom: '10px',
                }}
              >
                <WarningIcon />
                &nbsp;&nbsp;
                <Typography style={{ fontWeight: 500 }}>
                  You can only use the forecasting tool with one active frequency cap.
                </Typography>
              </div>
            )}
            <Tooltip
              title='Unable to run forecast without start and end date'
              placement='bottom-start'
              disableTouchListener={missingDate ? false : true}
              disableFocusListener={missingDate ? false : true}
              disableHoverListener={missingDate ? false : true}
            >
              <span>
                <ModelPrimaryButton
                  variant={'contained'}
                  disabled={this.state.checkingForecast || missingDate || moreThanOneActiveFCap}
                  onClick={this.checkForecast}
                  style={{
                    marginBottom: '12px',
                    marginRight: '8px',
                  }}
                >
                  {this.state.checkingForecast && (
                    <div>
                      <CircularProgress size={12} />
                      &nbsp;&nbsp;
                    </div>
                  )}
                  Run Forecast
                </ModelPrimaryButton>
              </span>
            </Tooltip>
            <Tooltip
              title='Unable to schedule report without start and end date'
              placement='bottom-start'
              disableTouchListener={missingDate ? false : true}
              disableFocusListener={missingDate ? false : true}
              disableHoverListener={missingDate ? false : true}
            >
              <span>
                <ModelPrimaryButton
                  variant='contained'
                  disabled={this.state.checkingForecast || missingDate || moreThanOneActiveFCap}
                  onClick={this.scheduleReport}
                  style={{
                    marginBottom: '12px',
                  }}
                >
                  {this.state.schedulingReport && (
                    <div>
                      <CircularProgress size={12} />
                      &nbsp;&nbsp;
                    </div>
                  )}
                  Email Forecast
                </ModelPrimaryButton>
              </span>
            </Tooltip>
            {this.state.forecast.Success && (
              <div>
                <Paper className={classes.table}>
                  <Table size='small'>
                    <TableBody>
                      <TableRow>
                        <TableCell component='th'>
                          <strong>Delivery Goal Met %</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Forecasted Supply / Delivery Goal</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Render Rate</strong>
                        </TableCell>
                        <TableCell>
                          <strong>Notes From Forecaster</strong>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={
                            this.state.forecastRatio < 1 ? classes.danger : classes.success
                          }
                        >
                          {(this.state.forecastRatio * 100).toFixed(2)}%
                        </TableCell>
                        <TableCell
                          className={
                            this.state.forecastRatio < 1 ? classes.danger : classes.success
                          }
                        >
                          {this.state.forecast.Forecast.toLocaleString(navigator.language)} /{' '}
                          {this.state.forecastGoal.toLocaleString(navigator.language)}
                        </TableCell>
                        <TableCell
                          className={
                            this.state.forecastRatio < 1 ? classes.danger : classes.success
                          }
                        >
                          {(this.state.forecast.RenderRate * 100).toFixed(2)}%
                        </TableCell>
                        <TableCell
                          className={
                            this.state.forecastNotes !== 'Successful forecast'
                              ? classes.danger
                              : classes.success
                          }
                        >
                          {this.state.forecastNotes}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Paper>
                {isSuperUser && (
                  <Paper>
                    <Grid>
                      <Typography>
                        <strong>Forecasting Queries *</strong>
                      </Typography>
                      {this.renderSqlTextBox(this.state.forecastQuery)}
                    </Grid>
                  </Paper>
                )}
              </div>
            )}
          </div>
        </Grid>
      );
    }

    renderAppBar() {
      const { Name, ID, updating, CRONQuantityCount, Quantity } = this.state;
      const delivered = parseInt(CRONQuantityCount, 10);
      const goal = parseInt(Quantity, 10);
      let progress = 'Progress: 0%';
      if (delivered && goal) {
        progress = `Progress: ${Math.round((delivered * 100) / goal).toFixed(0)}%`;
      }
      return (
        <Grid item>
          <SettingsAppBar
            name={this.isUserInfoMasked() ? `demo_campaign_${ID}` : Name}
            progress={progress}
            isActive={this.state.Active === CampaignActiveActive}
            hasWriteRights={this.getWriteCampaignAuthorization().isAuthorized}
            isUpdating={updating}
            handleNameChange={this.handleNameChange}
            handleSave={this.saveCampaign}
            handleClose={this.goToOrderListView}
            handleDelete={this.handleDelete}
            handleChangeActive={this.handleActiveChange}
            handlePreviewXML={this.exportCampaign}
            renderStatus={this.renderCampaignStatus}
            resourceID={ID}
            relative
          />
        </Grid>
      );
    }

    renderDebugCampaignInfos() {
      return (
        <Paper
          style={{
            width: 'auto',
            backgroundColor: adminDebugColor,
            boxShadow: 'none',
            borderRadius: smallRadius,
            opacity: '1',
            paddingBottom: '1px',
            marginBottom: '20px',
          }}
        >
          <Grid container direction='row' justify='flex-start' alignItems='center'>
            <Grid xs={10} container item direction='row' justify='flex-start' alignItems='center'>
              <CopyButton text={'Line Item ID *: ' + this.state.ID} copy={this.state.ID} />
              <CopyButton text={'Line Item UUID *: ' + this.state.UUID} copy={this.state.UUID} />
            </Grid>
          </Grid>
        </Paper>
      );
    }

    renderTrackersTab = () => {
      const { classes } = this.props;
      return (
        <Grid className={classes.mainGridItem}>
          <Typography
            className={classes.headingCategorySubtitle}
            style={{ padding: '6px 8px', marginBottom: '10px' }}
          >
            Use any third party tracker to fire events at the line item level and/or the creative
            level.
          </Typography>
          {this.renderTrackerManager()}
          <Button
            disabled={!this.state.writeAuthorization.isAuthorized}
            onClick={this.addNewTracker}
            style={{
              color: getColorTheme('secondaryButtonText'),
              marginBottom: '20px',
            }}
          >
            + Add a New Tracker
          </Button>
        </Grid>
      );
    };

    handleChangeSiteWeight = (siteWeight: string, siteID: number) => {
      const SiteAdserverCampaignAssociations = cloneDeep(
        this.state.SiteAdserverCampaignAssociations,
      );
      const siteWeightNumber = parseInt(siteWeight, 10);
      for (const asso of SiteAdserverCampaignAssociations) {
        if (asso.SiteID === siteID && siteWeightNumber) {
          asso.SiteWeight = siteWeightNumber;
          break;
        }
      }
      this.setState({
        SiteAdserverCampaignAssociations,
      });
    };

    handleChangeChannelGroupWeight = (cgWeight: string, cgID: number) => {
      const ChannelGroupAdserverCampaignAssociations = cloneDeep(
        this.state.ChannelGroupAdserverCampaignAssociations,
      );
      const cgWeightNumber = parseInt(cgWeight, 10);
      for (const asso of ChannelGroupAdserverCampaignAssociations) {
        if (asso.ChannelGroupID === cgID && cgWeightNumber) {
          asso.SiteWeight = cgWeightNumber;
          break;
        }
      }
      this.setState({
        ChannelGroupAdserverCampaignAssociations,
      });
    };

    renderSiteWeightCell = (siteWeight: number, siteID: number) => {
      return (
        <Grid container direction='row' alignItems='center' justify='center'>
          <Select
            style={{ marginRight: 20 }}
            value={siteWeight}
            onChange={(event: React.ChangeEvent<{ _: string; value: string }>) => {
              this.handleChangeSiteWeight(event.target.value, siteID);
            }}
          >
            {siteWeightOptions.map((w) => {
              return <MenuItem value={w.value}>{w.label}</MenuItem>;
            })}
          </Select>
        </Grid>
      );
    };

    renderChannelGroupWeightCell = (cgWeight: number, cgID: number) => {
      return (
        <Grid container direction='row' alignItems='center' justify='center'>
          <Select
            style={{ marginRight: 20 }}
            value={cgWeight}
            onChange={(event: React.ChangeEvent<{ _: string; value: string }>) => {
              this.handleChangeChannelGroupWeight(event.target.value, cgID);
            }}
          >
            {siteWeightOptions.map((w) => {
              return <MenuItem value={w.value}>{w.label}</MenuItem>;
            })}
          </Select>
        </Grid>
      );
    };

    renderPacingTab = () => {
      const { classes } = this.props;
      return (
        <Grid className={classes.mainGridItem}>
          <CampaignDebugPacingTable
            campaignID={this.state.ID}
            publisherID={this.props.session.publisher.ID}
            totalGoal={this.state.Quantity}
            prebidInfo={(this.props.campaignPrebidInfo || []).find(
              (c: ICampaignPrebidInfo) => c.campaign_id === +this.state.ID,
            )}
          />
        </Grid>
      );
    };

    generateCampaignPacingTooltipText = (): string => {
      return 'To prevent over-delivery, raw requests are being sampled to determine the rate of traffic. This happens when either channel weights are used, or overall scheduled impressions is beneath 150 per hour.';
    };

    shouldEnableCampaignPacingTooltip = (campaign: IAdserverCampaign): boolean => {
      if (this.props.campaignPrebidInfo === undefined || this.props.campaignPrebidInfo === null) {
        return false;
      }

      const campaignInfo = this.props.campaignPrebidInfo.find(
        (c: ICampaignPrebidInfo) => c.campaign_id === +campaign.ID,
      );

      if (campaignInfo === undefined) {
        return false;
      }

      return campaignInfo.low_pacing || campaignInfo.site_weight_enabled;
    };

    renderCampaignStatus = () => {
      // try to use the impressions from the query first, but if the query hasnt resolved use CronQuantityCount since it's faster but less accurate
      const campaign_status = computeCampaignStatus(
        this.state,
        this.props.session.publisher.Timezone,
        this.state.impressions || parseInt(this.state.CRONQuantityCount, 10),
      );
      const chip = campaignStatusToChip(campaign_status);

      if (chip === undefined) {
        return <div />;
      }

      const ChipComponent = chip.component;

      const notEnoughData = this.shouldEnableCampaignPacingTooltip(this.props.campaign);

      return (
        <Grid container direction='row' justify='center' alignItems='center'>
          {notEnoughData && (
            <Grid item style={{ paddingRight: '5px' }}>
              <Tooltip title={this.generateCampaignPacingTooltipText()}>
                <img src='/assets/shared/svg/Reco.svg' style={{ width: '20px' }} />
              </Tooltip>
            </Grid>
          )}
          <Grid item>
            <Tooltip title={chip.tooltip} placement='right'>
              <ChipComponent label={campaignStatusToString(campaign_status)} />
            </Tooltip>
          </Grid>
        </Grid>
      );
    };

    // initializes the list of IAB when loading an existing rule
    initializeIABList(iabcats: string): void {
      // checks if rule is IAB type
      if (iabcats === undefined || iabcats === '') {
        return;
      }
      // rule is an IAB rule
      this.setState({
        iabList: iabcats.split(',').map(
          (iabCode: string) =>
            ({
              ID: iabCode,
              title: iabCode,
              name: IABCategoryCodeToName(iabCode),
              included: true,
            }) as IIncludeExcludeTableElement,
        ),
      });
    }

    renderSiteWeightsTab = () => {
      const { classes } = this.props;
      const { loading, updating } = this.state;

      // Site
      const columns: IListTableColumn[] = [
        { field: 'SiteID', title: 'Channel ID', renderType: 'normal' },
        { field: 'SiteName', title: 'Channel Name', renderType: 'normal' },
        {
          field: 'SiteWeight',
          title: 'Channel Weight',
          render: (rowData: any) => this.renderSiteWeightCell(rowData.SiteWeight, rowData.SiteID),
          searchable: false,
        },
        { field: 'Percentage', title: 'Percentage Of Impressions', renderType: 'percent' },
      ];

      // weights
      let weights = 0;
      for (const asso of this.state.SiteAdserverCampaignAssociations) {
        weights += asso.SiteWeight;
      }
      for (const asso of this.state.ChannelGroupAdserverCampaignAssociations) {
        const cg = Object.values(this.state.ChannelGroups).find(
          (cg: IChannelGroup) => cg.ID === asso.ChannelGroupID,
        );
        weights +=
          asso.SiteWeight * ((cg || { ChannelIDs: '' }).ChannelIDs.split(',') || [1]).length;
      }

      // generate row data, the object keys here need to match the fields above
      const data: ISiteAdserverCampaignAssociationRowData[] =
        this.state.SiteAdserverCampaignAssociations.map(
          (asso: ISiteAdserverCampaignAssociation) => {
            const site = Object.values(this.state.siteList).find(
              (menuItem: IListItem) => menuItem.ID === asso.SiteID.toString(),
            ) as IListItem;
            return {
              ID: '',
              Name: '',
              SiteID: asso.SiteID,
              SiteName: (site || { title: 'Unknown' }).title,
              SiteWeight: asso.SiteWeight,
              Percentage: getPercentageNumber(asso.SiteWeight, weights),
            };
          },
        );

      // Channel Groups
      const columnsCG: IListTableColumn[] = [
        { field: 'SiteID', title: 'Channel Group ID', renderType: 'normal' },
        { field: 'SiteName', title: 'Channel Group Name', renderType: 'normal' },
        { field: 'GroupedChannels', title: 'Grouped Channels', renderType: 'normal' },
        {
          field: 'SiteWeight',
          title: 'Channel Group Weight',
          render: (rowData: any) =>
            this.renderChannelGroupWeightCell(rowData.SiteWeight, rowData.SiteID),
          searchable: false,
        },
        { field: 'Percentage', title: 'Percentage Of Impressions', renderType: 'percent' },
      ];
      // generate row data, the object keys here need to match the fields above
      const dataCG: ISiteAdserverCampaignAssociationRowData[] =
        this.state.ChannelGroupAdserverCampaignAssociations.map(
          (asso: IChannelGroupAdserverCampaignAssociation) => {
            const cg = Object.values(this.state.ChannelGroups).find(
              (cg: IChannelGroup) => cg.ID === asso.ChannelGroupID,
            );
            const channelsInThisGroup = ((cg || { ChannelIDs: '' }).ChannelIDs.split(',') || [1])
              .length;
            return {
              ID: '',
              Name: '',
              SiteID: asso.ChannelGroupID,
              SiteName: (cg || { Name: 'Unknown' }).Name,
              SiteWeight: asso.SiteWeight,
              GroupedChannels: channelsInThisGroup,
              Percentage: getPercentageNumber(asso.SiteWeight * channelsInThisGroup, weights),
            };
          },
        );

      return (
        <Grid className={classes.mainGridItem}>
          <ListTable
            title={''}
            columns={columns}
            data={data}
            isLoading={loading}
            isUpdating={updating}
            readRoleName={'read_campaign'}
            writeRoleName={'write_campaign'}
          />
          <div style={{ marginBottom: '25px' }} />
          <ListTable
            title={''}
            columns={columnsCG}
            data={dataCG}
            isLoading={loading}
            isUpdating={updating}
            readRoleName={'read_campaign'}
            writeRoleName={'write_campaign'}
          />
        </Grid>
      );
    };

    // define tabs and corresponding render functions
    renderTabs = (): ReactElement => {
      const { classes } = this.props;
      const tabs: ITab[] = [
        {
          label: 'Delivery',
          render: () => this.renderDeliveryTab(classes),
        },
        {
          label: 'Targeting',
          render: () => this.renderTargetingTab(classes),
        },
        {
          label: 'Creatives',
          render: this.renderCreativesTab,
        },
        {
          label: 'Trackers',
          render: this.renderTrackersTab,
        },
      ];
      // also check if there are channel groups since you cannot have channel weights and channel groups
      if (
        this.state.SiteWeightsActive === EBool.EBool_TRUE &&
        (hasRoleSuperUser(this.props.user.user) ||
          this.props.session.publisher.ID === '788' ||
          this.props.session.publisher.ID === '359')
      ) {
        tabs.push({
          label: 'Channel Weights *',
          render: this.renderSiteWeightsTab,
        });
      }

      if (hasRoleSuperUser(this.props.user.user) && isExistingCampaign(this.state)) {
        tabs.push({
          label: 'Pacing Data *',
          render: this.renderPacingTab,
        });
      }

      return <SettingsTabs marginTop={0} marginBottom={15} maxTabWidth='1200px' tabs={tabs} />;
    };

    // renders the custom tool bar for the line item modal
    renderCreativesDialog = (dialog: string) => {
      return (
        // weird margins to make the search box align
        <Grid item style={{ marginLeft: -10 }}>
          <Grid container direction='row' justify='space-between'>
            <Grid item xs={11}>
              <Typography style={{ fontSize: 24, fontWeight: 500, marginLeft: 22 }}>
                {dialog === FLIGHT_DATES
                  ? 'Flight Date Mismatch'
                  : 'Reactivate Bidders Targeting This Campaign'}
              </Typography>
            </Grid>
            <Grid item xs={1} style={{ textAlign: 'right' }}>
              <CloseIcon
                style={{ cursor: 'pointer', color: publicaColors.gray }}
                onClick={() => this.handleCloseCreativeDialog(false)}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            style={{ cursor: 'pointer', marginBottom: 10, marginTop: 10 }}
            onClick={
              dialog === FLIGHT_DATES
                ? this.handleSelectionCopyFlightDates
                : this.handleReactivateBidders
            }
          >
            <SaveIcon style={{ color: '#5D66FA', marginLeft: 22 }} />
            <Typography style={{ color: '#5D66FA', fontWeight: 500, marginLeft: 10 }}>
              {dialog === FLIGHT_DATES
                ? 'Copy Line Item Flight Dates To Selected Creatives'
                : 'Reactivate Selected Bidders'}
            </Typography>
          </Grid>
          <Grid
            container
            direction='row'
            style={{ cursor: 'pointer', marginBottom: 10, marginTop: 10 }}
            onClick={() => this.handleCloseCreativeDialog(true)}
          >
            <SaveIcon style={{ color: '#5D66FA', marginLeft: 22 }} />
            <Typography style={{ color: '#5D66FA', fontWeight: 500, marginLeft: 10 }}>
              No Changes And Save Line Item
            </Typography>
          </Grid>
        </Grid>
      );
    };

    // Renders Creatives Checkpoints functionality
    renderAdserverCreativeFlightDatesSubgroupsConfig = () => {
      const isDemo = isDemoAccount(this.props.user.user.Username);
      const mediaFileOptions: ISelectOption[] = Object.values(this.state.blankMediaFileList)
        .filter((file) => isValidVideoMimetype(file.mimeType ?? ''))
        .map((file) => ({
          id: file.ID,
          label: isDemo ? obfuscateCampaignCreative(file.ID) : file.title,
        }));
      const vastOptions: ISelectOption[] = Object.values(this.state.blankVastList).map((vast) => ({
        id: vast.ID,
        label: vast.title,
      }));

      return (
        <CreativeSubGroups
          adserverCampaignID={this.state.ID}
          blankMediaFileList={this.state.blankMediaFileList}
          blankVastList={this.state.blankVastList}
          campaignID={this.props.campaign.ID}
          classes={this.props.classes}
          creativeType={this.state.CreativeType}
          defaultEndDate={this.state.dateEnd}
          defaultStartDate={this.state.dateStart}
          forceMenuButtonClosed={this.state.forceMenuButtonClosed}
          globalMediaFiles={this.state.GlobalMediaFiles}
          handleChangeVariantActive={this.handleChangeVariantActive}
          handleOpenCreateCheckpointModal={this.handleOpenCreateCheckpointModal}
          handleVastEditEnabled={this.handleVastEditEnabled}
          isLoadingMediaFilesAndVasts={this.state.isLoadingMediaFilesAndVasts}
          isNativeVastAuthorized={this.isNativeVastAuthorized}
          onSubgroupsChange={(newSubgroups: IAdserverCreativeFlightDatesSubgroup[]) => {
            this.validateFlightDateCreativeCheckpoints(newSubgroups);
          }}
          mediaFileOptions={mediaFileOptions}
          removeGlobalMediafile={this.removeGlobalMediafile}
          renderCreateBannerFromAssetURLRow={this.renderCreateBannerFromAssetURLRow}
          renderCreateFromAssetURLRow={this.renderCreateFromAssetURLRow}
          renderMenuTitle={this.renderMenuTitle}
          renderUploadBannerRow={this.renderUploadBannerRow}
          renderUploadRow={this.renderUploadRow}
          setState={(newState) => {
            this.setState(
              {
                ...newState,
              },
              () => {
                if (hasErrors(this.state.errors)) {
                  this.validateForm();
                }
              },
            );
          }}
          subgroups={this.state.AdserverCreativeFlightDatesSubgroups || []}
          tempVastURL={this.state.tempVastURL}
          timezone={this.state.Timezone || this.props.session.publisher.Timezone}
          user={this.props.user}
          vastEditIndex={this.state.vastEditIndex}
          vasts={this.state.vasts}
          vastOptions={vastOptions}
          writeAuthorization={this.state.writeAuthorization}
        />
      );
    };

    // Renders Creatives Checkpoints functionality
    renderAdserverCreativeFlightDatesConfig = (
      shouldDisplayCreative: (creative: IAdserverCreative) => boolean,
    ) => {
      const { writeAuthorization, AdserverCreatives, CreativeType } = this.state;
      const { classes, user } = this.props;
      return (
        <>
          {AdserverCreatives.map((c: IAdserverCreative, index: number) => {
            if (!shouldDisplayCreative(c)) return null;
            const dateStart = ['', 'null'].includes(c.StartDate)
              ? undefined
              : formatDateFromUTCToOffset(
                  c.StartDate,
                  this.state.Timezone || this.props.session.publisher.Timezone,
                );
            const dateEnd = ['', 'null'].includes(c.EndDate)
              ? undefined
              : formatDateFromUTCToOffset(
                  c.EndDate,
                  this.state.Timezone || this.props.session.publisher.Timezone,
                );

            const obfuscatedCreativeName = obfuscateAdserverCreative(c, user.user.Username, c.Name);

            return (
              <Grid
                container
                style={{
                  background: '#FFFFFF 0% 0% no-repeat padding-box',
                  boxShadow: '0px 3px 6px #CBCBCB',
                  borderRadius: bigRadius,
                  opacity: '1',
                  marginBottom: '10px',
                }}
              >
                {/* creative name, id and delete */}
                <Grid item className={classes.creativeRow}>
                  <Grid container direction='row' justify='flex-start' alignItems='center'>
                    <Grid item xs={2} style={{ marginLeft: -10 }}>
                      <ModernTextField
                        value={obfuscatedCreativeName}
                        onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                          this.setState({
                            AdserverCreatives: update(AdserverCreatives, {
                              [index]: { Name: { $set: target.value } },
                            }),
                          });
                        }}
                        disabled={!writeAuthorization.isAuthorized}
                        disableAllUppercase={true}
                      />
                    </Grid>
                    <Grid item xs={9}>
                      <Grid
                        container
                        direction='row'
                        alignItems='center'
                        justifyContent='space-between'
                      >
                        <Grid item>
                          <Grid container direction='row' alignItems='center'>
                            <Grid item>
                              <CopyButton
                                text={
                                  'Creative ID: ' +
                                  (AdserverCreatives[index].ID === ''
                                    ? 'New'
                                    : AdserverCreatives[index].ID)
                                }
                                copy={AdserverCreatives[index].ID}
                              />
                            </Grid>
                            {hasRoleSuperUser(this.props.user.user) &&
                              !!AdserverCreatives[index].ID && (
                                <Grid item>
                                  <CopyButton
                                    text={
                                      'Creative UUID *: ' +
                                      (AdserverCreatives[index].UUID === ''
                                        ? 'New'
                                        : AdserverCreatives[index].UUID)
                                    }
                                    copy={AdserverCreatives[index].UUID}
                                  />
                                </Grid>
                              )}
                          </Grid>
                        </Grid>
                        {c?.CreativeType === EAdserverCreativeType.Banner && (
                          <ChipAdserverCreativeBannerTier
                            label={
                              c?.BannerRank === EBannerRank.Primary
                                ? 'Primary Banner'
                                : 'Secondary Banner'
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      spacing={6}
                      className='pb-campaign-form-view_creative_delete_button'
                    >
                      <Grid container justify='flex-end' direction='row' alignItems='center'>
                        <Button
                          onClick={() => {
                            this.removeCreative(index);
                          }}
                          disabled={!writeAuthorization.isAuthorized}
                        >
                          <DeleteIcon
                            style={{
                              cursor: 'pointer',
                              fill: deleteColor,
                            }}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* creative weight, only for non-banner */}
                {!isBannerType(c) && (
                  <Grid item className={classes.creativeRow}>
                    <Grid container alignItems='center' spacing={2}>
                      <Grid item xs={2}>
                        <Text bold small>
                          Weight
                          <Tooltip
                            title={
                              'Creative weight must be a number 1-100 which represents a percentage of all impressions this creative will receive. Note that Companion Ads are exempt from this.'
                            }
                          >
                            <InfoIcon
                              style={{
                                verticalAlign: 'bottom',
                                width: '1rem',
                                color: publicaColors.mediumLightGray,
                                marginLeft: '5px',
                              }}
                            />
                          </Tooltip>
                        </Text>
                      </Grid>
                      <Grid item xs={1}>
                        <TextInput
                          key={this.state.reactKey}
                          inputSize='small'
                          type='number'
                          max={100}
                          min={1}
                          msDelay={800}
                          initialValue={c.Weight}
                          className='pb-campaign-form-view_creative_weight_button'
                          handleOnChange={(value: string) =>
                            this.handleAdserverCreativeChange('Weight', value, index)
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                <Grid item className={classes.creativeRow}>
                  <Grid container alignItems='center' spacing={2}>
                    <Grid item xs={2}>
                      <Text bold small>
                        ClickThrough URL
                      </Text>
                    </Grid>
                    <Grid item xs={1}>
                      <TextInput
                        key={this.state.reactKey}
                        inputSize='small'
                        msDelay={800}
                        initialValue={c.ClickThroughURL}
                        handleOnChange={(value: string) =>
                          this.handleAdserverCreativeChange('ClickThroughURL', value, index)
                        }
                        inputStyle={{
                          minWidth: '480px',
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* start and end date */}
                <Grid item className={classes.creativeRow}>
                  <Grid container alignItems='center' spacing={2}>
                    <Grid item xs={2}>
                      <Typography
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        Flight Dates
                      </Typography>
                    </Grid>
                    <Grid item xs={6} className={`creative-date-${index}`}>
                      <DateTimeRangeComponent
                        enableClearSelection={true}
                        disabled={!this.state.writeAuthorization.isAuthorized}
                        timezone={this.getTimezone()}
                        start={dateStart}
                        end={dateEnd}
                        // @ts-ignore
                        onChange={(e) => this.handleCreativeDateChange(e, index)}
                        openDirection={'up'}
                        enableSelectAll={!!this.props.campaign.ID}
                        enablePresets={true}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <ModelSecondaryButton
                        disabled={!this.state.writeAuthorization.isAuthorized}
                        style={{ padding: '6px 12px', marginTop: '16px' }}
                        onClick={() => this.clearCreativeDates(index)}
                      >
                        <Typography
                          noWrap
                          style={{
                            textTransform: 'uppercase',
                            fontSize: 14,
                            fontWeight: 500,
                            marginLeft: 5,
                          }}
                        >
                          Clear Dates
                        </Typography>
                      </ModelSecondaryButton>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Vast URL */}
                {CreativeType === CreativeTypeVast && this.renderVast(c, index)}
                {/* mediafiles */}
                {CreativeType !== CreativeTypeVast && (
                  <Grid item className={classes.creativeRow}>
                    <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
                      {this.renderMediafiles(c, index, isBannerType(c))}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            );
          })}
        </>
      );
    };

    handleApplySelectedPresets = (presetIDs: Set<number>) => {
      this.setState({
        PresetIDs: Array.from(presetIDs),
      });
    };

    generateCustomTargetingPayload = () => {
      const selectedCountryGroupItems = Object.values(this.state.targetingCountryGroupList).filter(
        (item) => item.selected,
      );
      const selectedCountryGroupIDs = selectedCountryGroupItems.map((item) => item.ID).join(',');
      const isCountryExcluded = this.state.deviceTargetingCountrySelectMode === SelectMode.Denylist;
      const customTargeting: ITargetingPresetVars = {
        // CONTENT
        TargetingContentChannel: this.state.TargetingContentChannel,
        TargetingContentChannelIsAllowed: this.state.TargetingContentChannelIsAllowed,
        TargetingContentDistributor: this.state.TargetingContentDistributor,
        TargetingContentDistributorIsAllowed: this.state.TargetingContentDistributorIsAllowed,
        TargetingContentGenre: this.state.TargetingContentGenre,
        TargetingContentGenreIsAllowed: this.state.TargetingContentGenreIsAllowed,
        TargetingContentID: this.state.TargetingContentID,
        TargetingContentIDIsAllowed: this.state.TargetingContentIDIsAllowed,
        TargetingContentNetwork: this.state.TargetingContentNetwork,
        TargetingContentNetworkIsAllowed: this.state.TargetingContentNetworkIsAllowed,
        TargetingContentProducer: this.state.TargetingContentProducer,
        TargetingContentProducerIsAllowed: this.state.TargetingContentProducerIsAllowed,
        TargetingContentRating: this.state.TargetingContentRating,
        TargetingContentRatingIsAllowed: this.state.TargetingContentRatingIsAllowed,
        TargetingContentSeries: this.state.TargetingContentSeries,
        TargetingContentSeriesIsAllowed: this.state.TargetingContentSeriesIsAllowed,
        TargetingContentTitle: this.state.TargetingContentTitle,
        TargetingContentTitleIsAllowed: this.state.TargetingContentTitleIsAllowed,
        TargetingContentLanguage: this.state.TargetingContentLanguage,
        TargetingContentLanguageIsAllowed: this.state.TargetingContentLanguageIsAllowed,
        // GEO
        TargetingCountryGroupIDs: convertIDStringToNumberArray(selectedCountryGroupIDs),
        TargetingCountryGroupIDsIsAllowed: this.state.TargetingCountryGroupIDsIsAllowed,
        TargetingDeviceCountry: Object.values(this.state.targetingCountriesList)
          .filter((item: IListItem) => item.selected)
          .map((item: IListItem) => item.ID.toUpperCase())
          .join(','),
        TargetingDeviceCountryIsAllowed: isCountryExcluded ? EAllowStatus.DENY : EAllowStatus.ALLOW,
        LocalTargetingAllowed: this.exportLocalTargetingParamToJSON(true),
        LocalTargetingAllowedLogic: this.state.LocalTargetingIsAllowed
          ? this.state.LocalTargetingLogic
          : ELogicalOperator.OR,
        LocalTargetingDisallowed: this.exportLocalTargetingParamToJSON(false),
        LocalTargetingDisallowedLogic: !this.state.LocalTargetingIsAllowed
          ? this.state.LocalTargetingLogic
          : ELogicalOperator.OR,
        // DAYPARTING
        Dayparting: this.state.Dayparting,
        DaypartingIsAllowed: this.state.DaypartingIsAllowed,
        // PRIVACY
        TargetingCoppa: this.state.TargetingCoppa,
        TargetingLimitedAdTracking: this.state.TargetingLimitedAdTracking,
        TargetingCCPA: this.state.TargetingCCPA,
        TargetingGDPR: this.state.TargetingGDPR,
        TargetingGDPRConsent: this.state.TargetingGDPRConsent,
        TargetingDeviceIDType: this.state.TargetingDeviceIDType,
        // CUSTOM
        Custom4: this.state.TargetingCustom4,
        Custom4Inclusion: this.state.TargetingCustom4Inclusion,
        Custom5: this.state.TargetingCustom5,
        Custom5Inclusion: this.state.TargetingCustom5Inclusion,
        Custom6: this.state.TargetingCustom6,
        Custom6Inclusion: this.state.TargetingCustom6Inclusion,
        Custom7: this.state.TargetingCustom7,
        Custom7Inclusion: this.state.TargetingCustom7Inclusion,
        Custom8: this.state.TargetingCustom8,
        Custom8Inclusion: this.state.TargetingCustom8Inclusion,
        Custom9: this.state.TargetingCustom9,
        Custom9Inclusion: this.state.TargetingCustom9Inclusion,
        Custom10: this.state.TargetingCustom10,
        Custom10Inclusion: this.state.TargetingCustom10Inclusion,
        Custom11: this.state.TargetingCustom11,
        Custom11Inclusion: this.state.TargetingCustom11Inclusion,
        Custom12: this.state.TargetingCustom12,
        Custom12Inclusion: this.state.TargetingCustom12Inclusion,
        Custom13: this.state.TargetingCustom13,
        Custom13Inclusion: this.state.TargetingCustom13Inclusion,
        Custom14: this.state.TargetingCustom14,
        Custom14Inclusion: this.state.TargetingCustom14Inclusion,
        Custom15: this.state.TargetingCustom15,
        Custom15Inclusion: this.state.TargetingCustom15Inclusion,
        Custom16: this.state.TargetingCustom16,
        Custom16Inclusion: this.state.TargetingCustom16Inclusion,
        Custom17: this.state.TargetingCustom17,
        Custom17Inclusion: this.state.TargetingCustom17Inclusion,
        Custom18: this.state.TargetingCustom18,
        Custom18Inclusion: this.state.TargetingCustom18Inclusion,
        CustomTargeting: this.state.CustomTargeting,
        CustomTargetingInclusion: this.state.CustomTargetingInclusion,
        // DEVICE
        TargetingDevices: this.state.TargetingDevices,
        TargetingDevicesIsAllowed: this.state.TargetingDevicesIsAllowed,
        TargetingDeviceTypes: this.state.TargetingDeviceTypes,
        TargetingDeviceTypesIsAllowed: this.state.TargetingDeviceTypesIsAllowed,
        TargetingDeviceSubTypes: this.state.TargetingDeviceSubTypes,
        TargetingDeviceSubTypesIsAllowed: this.state.TargetingDeviceSubTypesIsAllowed,
        TargetingDeviceModels: this.state.TargetingDeviceModels,
        TargetingDeviceModelsIsAllowed: this.state.TargetingDeviceModelsIsAllowed,
        IPFilter: this.state.IPFilter,
        // APP
        TargetingAppBundleID: this.state.TargetingAppBundleID,
        TargetingAppBundleIDIsAllowed: this.state.TargetingAppBundleIDIsAllowed === 2,
        TargetingAppBundleSitePagesLogic: this.state.TargetingAppBundleSitePagesLogic,
        // DEALS
        TargetingDealID: this.state.TargetingDealID,
        TargetingDealIDIsAllowed: this.state.TargetingDealIDIsAllowed as number,
        TargetingFWSectionIDs: this.state.TargetingFWSectionIDs,
        TargetingFWSectionIDsIsAllowed: this.state.TargetingFWSectionIDsIsAllowed,
        // STREAM
        TargetingLivestream: this.state.LivestreamTargeting,
        // SEGMENTS
        TargetingAudienceSegmentIDs: convertIDStringToNumberArray(
          this.state.TargetingAudienceSegmentID,
        ),
        TargetingAudienceSegmentIDsIsAllowed: this.state.TargetingAudienceSegmentIDIsAllowed,
        SegmentTargeting: this.state.SegmentTargeting,
        TargetingContextualSegmentIDs: this.state.ContextualSegmentIDS,
        // SITE PAGES
        TargetingSitePages: this.state.TargetingSitePages,
        TargetingSitePagesIsAllowed: this.state.TargetingSitePagesIsAllowed,
        // FORCED DEFAULTS TO MATCH PRESET STRUCT
        TargetingContentCategory: '',
        TargetingContentCategoryIsAllowed: EAllowStatus.ALLOW,
        TargetingSiteDomain: '',
        TargetingSiteDomainIsAllowed: EAllowStatus.ALLOW,
        // EXTENDED IDS
        TargetingUID20TargetingType: this.state.TargetingUID20TargetingType,
        TargetingGooglePairIDTargetingType: this.state.TargetingGooglePairIDTargetingType,
        TargetingLiveRampATSTargetingType: this.state.TargetingLiveRampATSTargetingType,
        TargetingIrisSignalTargetingType: this.state.TargetingIrisSignalTargetingType,
        // TargetingSamsungIdentityTargetingType: this.state.TargetingSamsungIdentityTargetingType,
        // TargetingSamsungEPGMetadataTargetingType:
        //   this.state.TargetingSamsungEPGMetadataTargetingType,
      };
      return customTargeting;
    };

    getPresetList = () => {
      fetchTargetingPresetOptions(this.props.session.publisher.ID)
        .then(({ Presets }) => {
          this.setState({
            PresetList: Presets,
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            PresetList: [],
          });
        });
    };

    handleApplyAuctionInsightsDatesChange = ({ newStartDate, newEndDate }: INewCalDates): void => {
      this.setState({
        auctionInsightsCalStartDate: newStartDate.clone().startOf('day'),
        auctionInsightsCalEndDate: newEndDate.clone().endOf('day').hours(23).minutes(0).seconds(0),
      });
      track(
        'Campaign Auction Insights - Dates Changed',
        { isSuperUser: hasRoleSuperUser(this.props.user.user) },
        this.props.user.user,
        PUB_OPS_TEAM_IDS,
      );
    };

    render() {
      const {
        readAuthorization,
        writeAuthorization,
        ID,
        snackbarMessage,
        snackbarError,
        openCreateDialog,
        newCreateName,
        newCreateURL,
      } = this.state;
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      const campaignExists = isExistingCampaign(this.state);
      if (campaignExists) {
        if (!readAuthorization.isAuthorized) {
          return (
            <div style={{ marginLeft: '36px', marginTop: '20px' }}>
              <ModelMissingPermission missingPermissions={readAuthorization.missingPermissions} />
            </div>
          );
        }
      } else {
        if (!writeAuthorization.isAuthorized) {
          return (
            <div style={{ marginLeft: '36px', marginTop: '20px' }}>
              <ModelMissingPermission missingPermissions={writeAuthorization.missingPermissions} />
            </div>
          );
        }
      }

      // line item name custom column for creatives modal
      const creativeStartDateColumn = {
        title: 'Start Date',
        field: 'StartDate',
        searchable: true,
        render: (rowData: IAdserverCreativeWithTableData) => {
          if (rowData.StartDate === '') {
            return <Typography style={{ fontSize: 14, fontWeight: 500 }}>Open Start</Typography>;
          }
          return (
            <Typography style={{ fontSize: 14, fontWeight: 500 }}>
              {formatDateFromUTCToOffset(rowData.StartDate, this.state.Timezone).format(
                'YYYY-MM-DD HH:mm',
              )}
            </Typography>
          );
        },
      };

      // line item id custom column for  creatives modal
      const creativeEndDateColumn = {
        title: 'End Date',
        field: 'EndDate',
        searchable: true,
        render: (rowData: IAdserverCreativeWithTableData) => {
          if (rowData.EndDate === '') {
            return <Typography style={{ fontSize: 14, fontWeight: 500 }}>Open End</Typography>;
          }
          return (
            <Typography style={{ fontSize: 14, fontWeight: 500 }}>
              {formatDateFromUTCToOffset(rowData.EndDate, this.state.Timezone).format(
                'YYYY-MM-DD HH:mm',
              )}
            </Typography>
          );
        },
      };

      const chartOptions: RadioOption[] = [
        { tKey: 'LiveData', value: 'liveData' },
        { tKey: 'Insights', value: 'insights', stickerTKey: 'New' },
      ];

      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel largeHorizontalPadding verticalPadding>
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel>{this.renderAppBar()}</Panel>
          <Panel flex scroll>
            <Rows horizontalPadding paddingBottom={spacing.base}>
              <Row largeHorizontalPadding paddingTop={spacing.base} paddingBottom={spacing.none}>
                {/* CHART OPTIONS */}
                <RadioTextButtons
                  options={chartOptions}
                  value={this.state.selectedChartView}
                  onChange={(value) => {
                    this.setState({ selectedChartView: value as 'liveData' | 'insights' });
                    track(
                      'Campaign Settings View - Toggle Chart View',
                      { chart: value as 'liveData' | 'insights' },
                      user.user,
                      PUB_OPS_TEAM_IDS,
                    );
                  }}
                />
              </Row>
              {this.state.selectedChartView === 'insights' && (
                <Row noPadding>
                  <CampaignAuctionInsights
                    campaignID={Number(this.props.campaign.ID)}
                    startDate={moment(this.props.campaign.StartDate).format('YYYY-MM-DD')}
                    endDate={moment(this.props.campaign.EndDate).format('YYYY-MM-DD')}
                    calStartDateStr={this.state.auctionInsightsCalStartDate.format(
                      'YYYY-MM-DD HH:mm:ss',
                    )}
                    calEndDateStr={this.state.auctionInsightsCalEndDate.format(
                      'YYYY-MM-DD HH:mm:ss',
                    )}
                    handleApplyDatesChange={this.handleApplyAuctionInsightsDatesChange}
                  />
                </Row>
              )}
            </Rows>
            <div>
              {/* only show live data if the campaign is not a clone or new */}
              {campaignExists && this.state.selectedChartView === 'liveData' && (
                <Grid>
                  <LiveData
                    resourceIDs={ID}
                    resourceType={'Campaign'}
                    timezone={session.publisher.Timezone}
                    publisher={this.props.session.publisher}
                    maxWidth='1200px'
                    userInfo={this.props.user.user}
                    campaign={this.props.campaign}
                  />
                </Grid>
              )}
              {this.renderTabs()}
            </div>
            <Snackbar
              open={true}
              anchorOrigin={{
                horizontal: 'right',
                vertical: 'bottom',
              }}
            >
              <ModelSnackBarProgressBarContainer
                uploadManager={this.uploadManager}
                isSavable={true}
                isMediafile={true}
              />
            </Snackbar>
            {/* create mediafile from url dialog */}
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={this.state.openCreateBannerDialog}
              onClose={() =>
                this.setState({
                  openCreateBannerDialog: false,
                })
              }
            >
              <CreateBannerModal
                newCreateBannerName={this.state.newCreateBannerName}
                newCreateBannerURL={this.state.newCreateBannerURL}
                handleChangeBanner={this.handleChangeBanner}
                handleCreateBannerFromURL={this.handleCreateBannerFromURL}
                buttonClass={this.props.classes.button}
                publisher={this.props.session.publisher}
                advertiserID={this.props?.order?.AdvertiserID}
                user={this.props.user}
              />
            </Dialog>

            {/* create mediafile from url dialog */}
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={openCreateDialog}
              onClose={this.handleCloseCreateMediafileModal}
            >
              <CreateOrEditFromURLModal
                newCreateName={newCreateName}
                newCreateURL={newCreateURL}
                handleChange={this.handleChange}
                handleCreateFromURL={this.handleCreateFromURL}
                buttonClass={this.props.classes.button}
                isMediafile={this.areCurrentCreativesAssets()}
                publisher={this.props.session.publisher}
                user={this.props.user}
              />
            </Dialog>

            {/* validate creative flight dates  */}
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={this.state.openCreativeFlightDateModal}
              onClose={() => this.handleCloseCreativeDialog(false)}
            >
              <ModalSelectTable
                title={FLIGHT_DATES}
                items={this.state.creativeFlightModalItems}
                renderCustomToolbar={() => this.renderCreativesDialog(FLIGHT_DATES)}
                enableSearchBarLeft={true}
                customColumns={[creativeStartDateColumn, creativeEndDateColumn]}
                interactive={false}
                enableMultiSelect={true}
                handleSelectionChange={(rows: IAdserverCreativeWithTableData[]) =>
                  this.handleSelectionChangeCreativesModal(rows, FLIGHT_DATES)
                }
              />
            </Dialog>

            {/* validate reactivate bidders  */}
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={this.state.openReactivateBiddersModal}
              onClose={() => this.handleCloseCreativeDialog(false)}
            >
              <ModalSelectTable
                title={REACTIVATE_BIDDERS}
                items={this.state.inactiveBiddersTargetingCampaign}
                renderCustomToolbar={() => this.renderCreativesDialog('reactivate bidders')}
                enableSearchBarLeft={true}
                // customColumns={[creativeStartDateColumn, creativeEndDateColumn]}
                interactive={false}
                enableMultiSelect={true}
                handleSelectionChange={(rows: IBidderWithTableData[]) =>
                  this.handleSelectionChangeCreativesModal(rows, 'reactivate bidders')
                }
              />
            </Dialog>

            <SnackbarView
              open={!!snackbarMessage}
              error={!!snackbarError}
              onClose={this.snackbarClose}
            >
              {snackbarMessage}
            </SnackbarView>
          </Panel>
        </Panels>
      );
    }
  },
);
